//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import { trace, context, TraceFlags, Span } from '@opentelemetry/api';

import { ClientBase } from './client-base';
import { inject } from 'aurelia-framework';
import { HttpClient, RequestInit } from 'aurelia-fetch-client';

export class ReportingClientBase extends ClientBase {
  getBaseUrl(_defaultUrl: string, _baseUrl: string) {
    return this.apiService.getServiceUrl('reporting-api');
  }
}

@inject(String, HttpClient)
export class CorporationsClient extends ReportingClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("CorporationsClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5410", baseUrl);
    }

    async companies(corporationId: string): Promise<number[]> {
        const span = this.tracer.startSpan("GET /Corporations/{corporationId}/Companies", {
            attributes: {
                "corporationId": corporationId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/Corporations/{corporationId}/Companies";
        if (corporationId === undefined || corporationId === null)
            throw new globalThis.Error("The parameter 'corporationId' must be defined.");
        url_ = url_.replace("{corporationId}", encodeURIComponent("" + corporationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processCompanies(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processCompanies(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    async companiesWithName(corporationId: string): Promise<CorporationCustomerViewModel[]> {
        const span = this.tracer.startSpan("GET /Corporations/{corporationId}/CompaniesWithName", {
            attributes: {
                "corporationId": corporationId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/Corporations/{corporationId}/CompaniesWithName";
        if (corporationId === undefined || corporationId === null)
            throw new globalThis.Error("The parameter 'corporationId' must be defined.");
        url_ = url_.replace("{corporationId}", encodeURIComponent("" + corporationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processCompaniesWithName(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processCompaniesWithName(response: Response): Promise<CorporationCustomerViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CorporationCustomerViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CorporationCustomerViewModel[]>(null as any);
    }

    async get(): Promise<CorporationViewModel[]> {
        const span = this.tracer.startSpan("GET /Corporations", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/Corporations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<CorporationViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CorporationViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CorporationViewModel[]>(null as any);
    }
}

@inject(String, HttpClient)
export class ExcelReportsClient extends ReportingClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("ExcelReportsClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5410", baseUrl);
    }

    async rf1359Report(companyIdentityId: number, date: string | undefined): Promise<FileResponse> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/ExcelReports/Rf1359Report", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "date": date,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/ExcelReports/Rf1359Report?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processRf1359Report(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processRf1359Report(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    async maestroReport(companyIdentityId: number, date: string | undefined): Promise<FileResponse> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/ExcelReports/MaestroReport", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "date": date,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/ExcelReports/MaestroReport?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processMaestroReport(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processMaestroReport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    async auditReport(companyIdentityId: number, date: string | undefined): Promise<FileResponse> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/ExcelReports/AuditReport", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "date": date,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/ExcelReports/AuditReport?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processAuditReport(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processAuditReport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    async exportPageToTemplate(companyIdentityId: number, request: ExportPageRequest): Promise<FileResponse> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/ExcelReports/ExportPageToTemplate", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/ExcelReports/ExportPageToTemplate";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processExportPageToTemplate(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processExportPageToTemplate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

@inject(String, HttpClient)
export class ExchangeRatesClient extends ReportingClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("ExchangeRatesClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5410", baseUrl);
    }

    async get(currencyCode: string | undefined, dateTime: string | undefined): Promise<number | null> {
        const span = this.tracer.startSpan("GET /ExchangeRates", {
            attributes: {
                "currencyCode": currencyCode,
                "dateTime": dateTime,
            }
        }, context.active());

        let url_ = this.baseUrl + "/ExchangeRates?";
        if (currencyCode === null)
            throw new globalThis.Error("The parameter 'currencyCode' cannot be null.");
        else if (currencyCode !== undefined)
            url_ += "currencyCode=" + encodeURIComponent("" + currencyCode) + "&";
        if (dateTime === null)
            throw new globalThis.Error("The parameter 'dateTime' cannot be null.");
        else if (dateTime !== undefined)
            url_ += "dateTime=" + encodeURIComponent("" + dateTime) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }
}

@inject(String, HttpClient)
export class GlAccountsClient extends ReportingClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("GlAccountsClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5410", baseUrl);
    }

    async get(companyIdentityId: number): Promise<GlLedgerAccountCategoryVm[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/GlAccounts", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/GlAccounts";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<GlLedgerAccountCategoryVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GlLedgerAccountCategoryVm.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GlLedgerAccountCategoryVm[]>(null as any);
    }

    async patch(companyIdentityId: number, request: GlLedgerAccountCategoryVm): Promise<void> {
        const span = this.tracer.startSpan("PATCH /companies/{companyIdentityId}/GlAccounts", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/GlAccounts";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPatch(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPatch(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async reset(companyIdentityId: number, request: GlLedgerAccountCategoryVm): Promise<void> {
        const span = this.tracer.startSpan("PATCH /companies/{companyIdentityId}/GlAccounts/Reset", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/GlAccounts/Reset";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processReset(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processReset(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

@inject(String, HttpClient)
export class GlAccountTransactionsClient extends ReportingClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("GlAccountTransactionsClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5410", baseUrl);
    }

    async get(companyIdentityId: number, voucherId: string): Promise<GlAccountTransaction[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/GlAccountTransactions/{voucherId}", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "voucherId": voucherId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/GlAccountTransactions/{voucherId}";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (voucherId === undefined || voucherId === null)
            throw new globalThis.Error("The parameter 'voucherId' must be defined.");
        url_ = url_.replace("{voucherId}", encodeURIComponent("" + voucherId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<GlAccountTransaction[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GlAccountTransaction.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GlAccountTransaction[]>(null as any);
    }

    async incomingBalance(companyIdentityId: number, accountCode: number | undefined): Promise<number> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/GlAccountTransactions/IncomingBalance", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "accountCode": accountCode,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/GlAccountTransactions/IncomingBalance?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (accountCode === null)
            throw new globalThis.Error("The parameter 'accountCode' cannot be null.");
        else if (accountCode !== undefined)
            url_ += "accountCode=" + encodeURIComponent("" + accountCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processIncomingBalance(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processIncomingBalance(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    async counts(companyIdentityId: number): Promise<GlAccountTransactionCountsViewModel> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/GlAccountTransactions/Counts", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/GlAccountTransactions/Counts";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processCounts(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processCounts(response: Response): Promise<GlAccountTransactionCountsViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GlAccountTransactionCountsViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GlAccountTransactionCountsViewModel>(null as any);
    }

    async rebuildClickHouse(companyIdentityId: number): Promise<void> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/GlAccountTransactions/RebuildClickHouse", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/GlAccountTransactions/RebuildClickHouse";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processRebuildClickHouse(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processRebuildClickHouse(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

@inject(String, HttpClient)
export class GlCategoriesClient extends ReportingClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("GlCategoriesClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5410", baseUrl);
    }

    async get(companyIdentityId: number): Promise<GlLedgerAccountCategoryVm[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/GlCategories", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/GlCategories";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<GlLedgerAccountCategoryVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GlLedgerAccountCategoryVm.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GlLedgerAccountCategoryVm[]>(null as any);
    }
}

@inject(String, HttpClient)
export class GlReportsClient extends ReportingClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("GlReportsClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5410", baseUrl);
    }

    async balanceDebug(companyIdentityId: number, toDate: string): Promise<(GlReportBaseData | undefined)[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/GlReports/BalanceDebug/{toDate}", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "toDate": toDate,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/GlReports/BalanceDebug/{toDate}";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (toDate === undefined || toDate === null)
            throw new globalThis.Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent("" + toDate));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processBalanceDebug(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processBalanceDebug(response: Response): Promise<(GlReportBaseData | undefined)[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GlReportBaseData.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<(GlReportBaseData | undefined)[]>(null as any);
    }

    async balance(companyIdentityId: number, toDate: string): Promise<BalanceReportViewModel> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/GlReports/Balance/{toDate}", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "toDate": toDate,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/GlReports/Balance/{toDate}";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (toDate === undefined || toDate === null)
            throw new globalThis.Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent("" + toDate));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processBalance(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processBalance(response: Response): Promise<BalanceReportViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BalanceReportViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BalanceReportViewModel>(null as any);
    }
}

@inject(String, HttpClient)
export class ImportedPricesClient extends ReportingClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("ImportedPricesClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5410", baseUrl);
    }

    async get(availableInstrumentUuid: string | undefined, request: AgGridPageRequest): Promise<AgGridResponseOfPriceViewModel> {
        const span = this.tracer.startSpan("POST /ImportedPrices/Get", {
            attributes: {
                "availableInstrumentUuid": availableInstrumentUuid,
            }
        }, context.active());

        let url_ = this.baseUrl + "/ImportedPrices/Get?";
        if (availableInstrumentUuid === null)
            throw new globalThis.Error("The parameter 'availableInstrumentUuid' cannot be null.");
        else if (availableInstrumentUuid !== undefined)
            url_ += "availableInstrumentUuid=" + encodeURIComponent("" + availableInstrumentUuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<AgGridResponseOfPriceViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgGridResponseOfPriceViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgGridResponseOfPriceViewModel>(null as any);
    }

    async syncStale(): Promise<void> {
        const span = this.tracer.startSpan("POST /ImportedPrices/SyncStale", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/ImportedPrices/SyncStale";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processSyncStale(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processSyncStale(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

@inject(String, HttpClient)
export class InstrumentForecastClient extends ReportingClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("InstrumentForecastClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5410", baseUrl);
    }

    async get(companyIdentityId: number, instrumentId: string): Promise<InstrumentForecastViewModel> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/InstrumentForecast/{instrumentId}", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "instrumentId": instrumentId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/InstrumentForecast/{instrumentId}";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<InstrumentForecastViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InstrumentForecastViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentForecastViewModel>(null as any);
    }

    async put(companyIdentityId: number, instrumentId: string, instrumentForecastViewModel: InstrumentForecastViewModel): Promise<InstrumentForecastViewModel> {
        const span = this.tracer.startSpan("PUT /companies/{companyIdentityId}/InstrumentForecast/{instrumentId}", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "instrumentId": instrumentId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/InstrumentForecast/{instrumentId}";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(instrumentForecastViewModel);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPut(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPut(response: Response): Promise<InstrumentForecastViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InstrumentForecastViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentForecastViewModel>(null as any);
    }

    async customerInstrumentForecasts(companyIdentityId: number): Promise<InstrumentForecastViewModel[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/InstrumentForecast/CustomerInstrumentForecasts", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/InstrumentForecast/CustomerInstrumentForecasts";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processCustomerInstrumentForecasts(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processCustomerInstrumentForecasts(response: Response): Promise<InstrumentForecastViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstrumentForecastViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentForecastViewModel[]>(null as any);
    }

    async corporationInstrumentForecasts(corporationId: string): Promise<InstrumentForecastViewModel[]> {
        const span = this.tracer.startSpan("GET /corporations/{corporationId}/InstrumentForecast/CorporationInstrumentForecasts", {
            attributes: {
                "corporationId": corporationId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/corporations/{corporationId}/InstrumentForecast/CorporationInstrumentForecasts";
        if (corporationId === undefined || corporationId === null)
            throw new globalThis.Error("The parameter 'corporationId' must be defined.");
        url_ = url_.replace("{corporationId}", encodeURIComponent("" + corporationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processCorporationInstrumentForecasts(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processCorporationInstrumentForecasts(response: Response): Promise<InstrumentForecastViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstrumentForecastViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentForecastViewModel[]>(null as any);
    }
}

@inject(String, HttpClient)
export class InstrumentsClient extends ReportingClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("InstrumentsClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5410", baseUrl);
    }

    async get(companyIdentityId: number, id: string, toDate: string): Promise<InstrumentWithValuesViewModel> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/Instruments/{id}/toDate/{toDate}", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "id": id,
                "toDate": toDate,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Instruments/{id}/toDate/{toDate}";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (toDate === undefined || toDate === null)
            throw new globalThis.Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent("" + toDate));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<InstrumentWithValuesViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InstrumentWithValuesViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentWithValuesViewModel>(null as any);
    }
}

@inject(String, HttpClient)
export class OverviewClient extends ReportingClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("OverviewClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5410", baseUrl);
    }

    /**
     * Returns the instruments for a given company identity ID and request
     * @param companyIdentityId Company identity
     * @param request (optional) Query request
     */
    async get(companyIdentityId: number, request: OverviewRequest | undefined): Promise<InstrumentsViewModelOfInstrumentWithValuesViewModel> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Overview", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Overview";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<InstrumentsViewModelOfInstrumentWithValuesViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InstrumentsViewModelOfInstrumentWithValuesViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentsViewModelOfInstrumentWithValuesViewModel>(null as any);
    }
}

@inject(String, HttpClient)
export class PortfolioClient extends ReportingClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("PortfolioClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5410", baseUrl);
    }

    async byType(companyIdentityId: number, toDate: string): Promise<PorfolioReportViewModel[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/Portfolio/{toDate}/ByType", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "toDate": toDate,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Portfolio/{toDate}/ByType";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (toDate === undefined || toDate === null)
            throw new globalThis.Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent("" + toDate));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processByType(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processByType(response: Response): Promise<PorfolioReportViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PorfolioReportViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PorfolioReportViewModel[]>(null as any);
    }
}

@inject(String, HttpClient)
export class PriceHistoryClient extends ReportingClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("PriceHistoryClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5410", baseUrl);
    }

    async portfolio(companyIdentityId: number, instrumentId: number | undefined, toDate: string | undefined): Promise<SecuritiesPricesChartViewModel[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/PriceHistory/Portfolio", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "instrumentId": instrumentId,
                "toDate": toDate,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/PriceHistory/Portfolio?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' cannot be null.");
        else if (instrumentId !== undefined)
            url_ += "instrumentId=" + encodeURIComponent("" + instrumentId) + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPortfolio(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPortfolio(response: Response): Promise<SecuritiesPricesChartViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SecuritiesPricesChartViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SecuritiesPricesChartViewModel[]>(null as any);
    }

    async marketIndex(availableInstrumentId: string | undefined, toDate: string | undefined, companyIdentityId: string): Promise<SecuritiesPricesChartViewModel[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/PriceHistory/MarketIndex", {
            attributes: {
                "availableInstrumentId": availableInstrumentId,
                "toDate": toDate,
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/PriceHistory/MarketIndex?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (availableInstrumentId === null)
            throw new globalThis.Error("The parameter 'availableInstrumentId' cannot be null.");
        else if (availableInstrumentId !== undefined)
            url_ += "availableInstrumentId=" + encodeURIComponent("" + availableInstrumentId) + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processMarketIndex(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processMarketIndex(response: Response): Promise<SecuritiesPricesChartViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SecuritiesPricesChartViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SecuritiesPricesChartViewModel[]>(null as any);
    }
}

@inject(String, HttpClient)
export class ReconcileClient extends ReportingClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("ReconcileClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5410", baseUrl);
    }

    /**
     * Aggregates GL transactions for a given company and returns account balances for toDate.
     * @param companyIdentityId Company identifier
     * @param fromDate (optional) The date to calculate incoming balances for
     * @param toDate (optional) The date to calculate end balances for
     * @return GL accounts summary
     */
    async summary(companyIdentityId: number, fromDate: string | undefined, toDate: string | undefined): Promise<GeneralLedgerReconcileSummaryResponse[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/Reconcile/Summary", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "fromDate": fromDate,
                "toDate": toDate,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Reconcile/Summary?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processSummary(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processSummary(response: Response): Promise<GeneralLedgerReconcileSummaryResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralLedgerReconcileSummaryResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GeneralLedgerReconcileSummaryResponse[]>(null as any);
    }

    async ledgerVoucher(companyIdentityId: number, voucherId: string | undefined): Promise<LedgerVoucher> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/Reconcile/LedgerVoucher", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "voucherId": voucherId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Reconcile/LedgerVoucher?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (voucherId === null)
            throw new globalThis.Error("The parameter 'voucherId' cannot be null.");
        else if (voucherId !== undefined)
            url_ += "voucherId=" + encodeURIComponent("" + voucherId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processLedgerVoucher(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processLedgerVoucher(response: Response): Promise<LedgerVoucher> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LedgerVoucher.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LedgerVoucher>(null as any);
    }
}

@inject(String, HttpClient)
export class ReportCustomerParametersClient extends ReportingClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("ReportCustomerParametersClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5410", baseUrl);
    }

    async get(companyIdentityId: number, reportId: number | undefined): Promise<ReportCustomerParameter> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/ReportCustomerParameters", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "reportId": reportId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/ReportCustomerParameters?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (reportId === null)
            throw new globalThis.Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<ReportCustomerParameter> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportCustomerParameter.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportCustomerParameter>(null as any);
    }

    async post(companyIdentityId: number, request: ReportCustomerParameter): Promise<ReportCustomerParameter> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/ReportCustomerParameters", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/ReportCustomerParameters";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPost(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPost(response: Response): Promise<ReportCustomerParameter> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportCustomerParameter.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportCustomerParameter>(null as any);
    }

    async patch(companyIdentityId: number, request: ReportCustomerParameter): Promise<ReportCustomerParameter> {
        const span = this.tracer.startSpan("PATCH /companies/{companyIdentityId}/ReportCustomerParameters", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/ReportCustomerParameters";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPatch(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPatch(response: Response): Promise<ReportCustomerParameter> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportCustomerParameter.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportCustomerParameter>(null as any);
    }

    async delete(companyIdentityId: number, id: string | undefined): Promise<void> {
        const span = this.tracer.startSpan("DELETE /companies/{companyIdentityId}/ReportCustomerParameters", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/ReportCustomerParameters?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processDelete(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

@inject(String, HttpClient)
export class ReportPagesClient extends ReportingClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("ReportPagesClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5410", baseUrl);
    }

    async getAll(companyIdentityId: number): Promise<ReportPage[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/ReportPages", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/ReportPages";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGetAll(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGetAll(response: Response): Promise<ReportPage[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReportPage.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportPage[]>(null as any);
    }

    async post(companyIdentityId: number, isGlobal: boolean | undefined, request: ReportPage): Promise<ReportPage> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/ReportPages", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/ReportPages?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (isGlobal === null)
            throw new globalThis.Error("The parameter 'isGlobal' cannot be null.");
        else if (isGlobal !== undefined)
            url_ += "isGlobal=" + encodeURIComponent("" + isGlobal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPost(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPost(response: Response): Promise<ReportPage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportPage.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportPage>(null as any);
    }

    async patch(companyIdentityId: number, isGlobal: boolean | undefined, request: ReportPage): Promise<ReportPage> {
        const span = this.tracer.startSpan("PATCH /companies/{companyIdentityId}/ReportPages", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/ReportPages?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (isGlobal === null)
            throw new globalThis.Error("The parameter 'isGlobal' cannot be null.");
        else if (isGlobal !== undefined)
            url_ += "isGlobal=" + encodeURIComponent("" + isGlobal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPatch(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPatch(response: Response): Promise<ReportPage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportPage.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportPage>(null as any);
    }

    async delete(companyIdentityId: number, id: number | undefined): Promise<void> {
        const span = this.tracer.startSpan("DELETE /companies/{companyIdentityId}/ReportPages", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/ReportPages?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processDelete(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async get(companyIdentityId: number, id: number): Promise<ReportPage> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/ReportPages/{id}", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/ReportPages/{id}";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<ReportPage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportPage.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportPage>(null as any);
    }
}

@inject(String, HttpClient)
export class ReportsClient extends ReportingClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("ReportsClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5410", baseUrl);
    }

    async get(companyIdentityId: number): Promise<Report[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/Reports", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Reports";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<Report[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Report.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Report[]>(null as any);
    }

    async post(companyIdentityId: number, isGlobal: boolean | undefined, overwrite: boolean | undefined, request: Report): Promise<Report> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Reports", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Reports?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (isGlobal === null)
            throw new globalThis.Error("The parameter 'isGlobal' cannot be null.");
        else if (isGlobal !== undefined)
            url_ += "isGlobal=" + encodeURIComponent("" + isGlobal) + "&";
        if (overwrite === null)
            throw new globalThis.Error("The parameter 'overwrite' cannot be null.");
        else if (overwrite !== undefined)
            url_ += "overwrite=" + encodeURIComponent("" + overwrite) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPost(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPost(response: Response): Promise<Report> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Report.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Report>(null as any);
    }

    async patch(companyIdentityId: number, isGlobal: boolean | undefined, request: Report): Promise<Report> {
        const span = this.tracer.startSpan("PATCH /companies/{companyIdentityId}/Reports", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Reports?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (isGlobal === null)
            throw new globalThis.Error("The parameter 'isGlobal' cannot be null.");
        else if (isGlobal !== undefined)
            url_ += "isGlobal=" + encodeURIComponent("" + isGlobal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPatch(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPatch(response: Response): Promise<Report> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Report.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Report>(null as any);
    }

    async delete(companyIdentityId: number, id: number | undefined): Promise<void> {
        const span = this.tracer.startSpan("DELETE /companies/{companyIdentityId}/Reports", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Reports?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processDelete(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

@inject(String, HttpClient)
export class TransactionsClient extends ReportingClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("TransactionsClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5410", baseUrl);
    }

    async grouped(companyIdentityId: number, instrumentId: number | null | undefined, showRetracted: boolean | undefined, externalDocumentId: number | null | undefined, externalRowId: number | null | undefined, fromDate: string | null | undefined, toDate: string | null | undefined): Promise<GroupedTransactionsViewModel[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/Transactions/Grouped", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "instrumentId": instrumentId,
                "externalDocumentId": externalDocumentId,
                "externalRowId": externalRowId,
                "fromDate": fromDate,
                "toDate": toDate,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Transactions/Grouped?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (instrumentId !== undefined && instrumentId !== null)
            url_ += "instrumentId=" + encodeURIComponent("" + instrumentId) + "&";
        if (showRetracted === null)
            throw new globalThis.Error("The parameter 'showRetracted' cannot be null.");
        else if (showRetracted !== undefined)
            url_ += "showRetracted=" + encodeURIComponent("" + showRetracted) + "&";
        if (externalDocumentId !== undefined && externalDocumentId !== null)
            url_ += "externalDocumentId=" + encodeURIComponent("" + externalDocumentId) + "&";
        if (externalRowId !== undefined && externalRowId !== null)
            url_ += "externalRowId=" + encodeURIComponent("" + externalRowId) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGrouped(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGrouped(response: Response): Promise<GroupedTransactionsViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroupedTransactionsViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupedTransactionsViewModel[]>(null as any);
    }

    async transactionCount(): Promise<TransactionCountViewModel[]> {
        const span = this.tracer.startSpan("GET /Transactions/TransactionCount", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/Transactions/TransactionCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processTransactionCount(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processTransactionCount(response: Response): Promise<TransactionCountViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransactionCountViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransactionCountViewModel[]>(null as any);
    }

    async transactionCountPerInstrument(companyIdentityId: number): Promise<TransactionCountViewModel[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/Transactions/TransactionCountPerInstrument", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Transactions/TransactionCountPerInstrument";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processTransactionCountPerInstrument(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processTransactionCountPerInstrument(response: Response): Promise<TransactionCountViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransactionCountViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransactionCountViewModel[]>(null as any);
    }

    async allTransactionCount(): Promise<TransactionCountViewModel> {
        const span = this.tracer.startSpan("GET /Transactions/AllTransactionCount", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/Transactions/AllTransactionCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processAllTransactionCount(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processAllTransactionCount(response: Response): Promise<TransactionCountViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionCountViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransactionCountViewModel>(null as any);
    }
}

@inject(String, HttpClient)
export class CorporationsReportClient extends ReportingClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("CorporationsReportClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5410", baseUrl);
    }

    async instrumentValues(corporationId: string, fromDate: string | null | undefined, toDate: string, categoryTypeId: number | null | undefined, quarters: number | undefined): Promise<InstrumentValuesReportViewModel[]> {
        const span = this.tracer.startSpan("GET /corporations/{corporationId}/CorporationsReport/InstrumentValues/{toDate}", {
            attributes: {
                "corporationId": corporationId,
                "fromDate": fromDate,
                "toDate": toDate,
                "categoryTypeId": categoryTypeId,
                "quarters": quarters,
            }
        }, context.active());

        let url_ = this.baseUrl + "/corporations/{corporationId}/CorporationsReport/InstrumentValues/{toDate}?";
        if (corporationId === undefined || corporationId === null)
            throw new globalThis.Error("The parameter 'corporationId' must be defined.");
        url_ = url_.replace("{corporationId}", encodeURIComponent("" + corporationId));
        if (toDate === undefined || toDate === null)
            throw new globalThis.Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent("" + toDate));
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (categoryTypeId !== undefined && categoryTypeId !== null)
            url_ += "categoryTypeId=" + encodeURIComponent("" + categoryTypeId) + "&";
        if (quarters === null)
            throw new globalThis.Error("The parameter 'quarters' cannot be null.");
        else if (quarters !== undefined)
            url_ += "quarters=" + encodeURIComponent("" + quarters) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processInstrumentValues(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processInstrumentValues(response: Response): Promise<InstrumentValuesReportViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstrumentValuesReportViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentValuesReportViewModel[]>(null as any);
    }

    async customerTotals(corporationId: string, fromDate: string | null | undefined, toDate: string, indexAi: string | null | undefined, historicalMonths: number | undefined): Promise<CustomerTotalValuesReportViewModel[]> {
        const span = this.tracer.startSpan("GET /corporations/{corporationId}/CorporationsReport/CustomerTotals/{toDate}", {
            attributes: {
                "corporationId": corporationId,
                "fromDate": fromDate,
                "toDate": toDate,
                "indexAi": indexAi,
                "historicalMonths": historicalMonths,
            }
        }, context.active());

        let url_ = this.baseUrl + "/corporations/{corporationId}/CorporationsReport/CustomerTotals/{toDate}?";
        if (corporationId === undefined || corporationId === null)
            throw new globalThis.Error("The parameter 'corporationId' must be defined.");
        url_ = url_.replace("{corporationId}", encodeURIComponent("" + corporationId));
        if (toDate === undefined || toDate === null)
            throw new globalThis.Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent("" + toDate));
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (indexAi !== undefined && indexAi !== null)
            url_ += "indexAi=" + encodeURIComponent("" + indexAi) + "&";
        if (historicalMonths === null)
            throw new globalThis.Error("The parameter 'historicalMonths' cannot be null.");
        else if (historicalMonths !== undefined)
            url_ += "historicalMonths=" + encodeURIComponent("" + historicalMonths) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processCustomerTotals(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processCustomerTotals(response: Response): Promise<CustomerTotalValuesReportViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerTotalValuesReportViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerTotalValuesReportViewModel[]>(null as any);
    }

    async instrumentValueGroupsOverTime(corporationId: string, categoryTypeId: number | null | undefined, fromDate: string | undefined, toDate: string): Promise<InstrumentValueGroup[]> {
        const span = this.tracer.startSpan("GET /corporations/{corporationId}/CorporationsReport/InstrumentValueGroupsOverTime/{toDate}", {
            attributes: {
                "corporationId": corporationId,
                "categoryTypeId": categoryTypeId,
                "fromDate": fromDate,
                "toDate": toDate,
            }
        }, context.active());

        let url_ = this.baseUrl + "/corporations/{corporationId}/CorporationsReport/InstrumentValueGroupsOverTime/{toDate}?";
        if (corporationId === undefined || corporationId === null)
            throw new globalThis.Error("The parameter 'corporationId' must be defined.");
        url_ = url_.replace("{corporationId}", encodeURIComponent("" + corporationId));
        if (toDate === undefined || toDate === null)
            throw new globalThis.Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent("" + toDate));
        if (categoryTypeId !== undefined && categoryTypeId !== null)
            url_ += "categoryTypeId=" + encodeURIComponent("" + categoryTypeId) + "&";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processInstrumentValueGroupsOverTime(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processInstrumentValueGroupsOverTime(response: Response): Promise<InstrumentValueGroup[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstrumentValueGroup.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentValueGroup[]>(null as any);
    }

    async instrumentValuesWithAllCategories(corporationId: string, toDate: string, quarters: number | undefined): Promise<InstrumentWithValuesViewModel[]> {
        const span = this.tracer.startSpan("GET /corporations/{corporationId}/CorporationsReport/InstrumentValuesWithAllCategories/{toDate}", {
            attributes: {
                "corporationId": corporationId,
                "toDate": toDate,
                "quarters": quarters,
            }
        }, context.active());

        let url_ = this.baseUrl + "/corporations/{corporationId}/CorporationsReport/InstrumentValuesWithAllCategories/{toDate}?";
        if (corporationId === undefined || corporationId === null)
            throw new globalThis.Error("The parameter 'corporationId' must be defined.");
        url_ = url_.replace("{corporationId}", encodeURIComponent("" + corporationId));
        if (toDate === undefined || toDate === null)
            throw new globalThis.Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent("" + toDate));
        if (quarters === null)
            throw new globalThis.Error("The parameter 'quarters' cannot be null.");
        else if (quarters !== undefined)
            url_ += "quarters=" + encodeURIComponent("" + quarters) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processInstrumentValuesWithAllCategories(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processInstrumentValuesWithAllCategories(response: Response): Promise<InstrumentWithValuesViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstrumentWithValuesViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentWithValuesViewModel[]>(null as any);
    }

    async instrumentPerformance(corporationId: string, toDate: string): Promise<PerformanceViewModel[]> {
        const span = this.tracer.startSpan("GET /corporations/{corporationId}/CorporationsReport/InstrumentPerformance/{toDate}", {
            attributes: {
                "corporationId": corporationId,
                "toDate": toDate,
            }
        }, context.active());

        let url_ = this.baseUrl + "/corporations/{corporationId}/CorporationsReport/InstrumentPerformance/{toDate}";
        if (corporationId === undefined || corporationId === null)
            throw new globalThis.Error("The parameter 'corporationId' must be defined.");
        url_ = url_.replace("{corporationId}", encodeURIComponent("" + corporationId));
        if (toDate === undefined || toDate === null)
            throw new globalThis.Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent("" + toDate));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processInstrumentPerformance(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processInstrumentPerformance(response: Response): Promise<PerformanceViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PerformanceViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PerformanceViewModel[]>(null as any);
    }
}

@inject(String, HttpClient)
export class CorporationsInstrumentClient extends ReportingClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("CorporationsInstrumentClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5410", baseUrl);
    }

    async instruments(corporationId: string): Promise<InstrumentViewModel[]> {
        const span = this.tracer.startSpan("GET /corporations/{corporationId}/CorporationsInstrument/Instruments", {
            attributes: {
                "corporationId": corporationId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/corporations/{corporationId}/CorporationsInstrument/Instruments";
        if (corporationId === undefined || corporationId === null)
            throw new globalThis.Error("The parameter 'corporationId' must be defined.");
        url_ = url_.replace("{corporationId}", encodeURIComponent("" + corporationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processInstruments(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processInstruments(response: Response): Promise<InstrumentViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstrumentViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentViewModel[]>(null as any);
    }
}

@inject(String, HttpClient)
export class CorporationsPbiExportClient extends ReportingClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("CorporationsPbiExportClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5410", baseUrl);
    }

    async instrumentValuesWithAllCategories(corporationId: string, fromDate: string, toDate: string, interval: ClickHouseReportDateRangeInterval | undefined): Promise<InstrumentValuesPbiExportModel[]> {
        const span = this.tracer.startSpan("GET /corporations/{corporationId}/CorporationsPbiExport/InstrumentValuesWithAllCategories/{fromDate}/{toDate}", {
            attributes: {
                "corporationId": corporationId,
                "fromDate": fromDate,
                "toDate": toDate,
            }
        }, context.active());

        let url_ = this.baseUrl + "/corporations/{corporationId}/CorporationsPbiExport/InstrumentValuesWithAllCategories/{fromDate}/{toDate}?";
        if (corporationId === undefined || corporationId === null)
            throw new globalThis.Error("The parameter 'corporationId' must be defined.");
        url_ = url_.replace("{corporationId}", encodeURIComponent("" + corporationId));
        if (fromDate === undefined || fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' must be defined.");
        url_ = url_.replace("{fromDate}", encodeURIComponent("" + fromDate));
        if (toDate === undefined || toDate === null)
            throw new globalThis.Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent("" + toDate));
        if (interval === null)
            throw new globalThis.Error("The parameter 'interval' cannot be null.");
        else if (interval !== undefined)
            url_ += "interval=" + encodeURIComponent("" + interval) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processInstrumentValuesWithAllCategories(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processInstrumentValuesWithAllCategories(response: Response): Promise<InstrumentValuesPbiExportModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstrumentValuesPbiExportModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentValuesPbiExportModel[]>(null as any);
    }

    async bankDepthTotalsOverTime(corporationId: string, fromDate: string, toDate: string, interval: ClickHouseReportDateRangeInterval | undefined): Promise<BankDepthTotalPbiExportModel[]> {
        const span = this.tracer.startSpan("GET /corporations/{corporationId}/CorporationsPbiExport/BankDepthTotalsOverTime/{fromDate}/{toDate}", {
            attributes: {
                "corporationId": corporationId,
                "fromDate": fromDate,
                "toDate": toDate,
            }
        }, context.active());

        let url_ = this.baseUrl + "/corporations/{corporationId}/CorporationsPbiExport/BankDepthTotalsOverTime/{fromDate}/{toDate}?";
        if (corporationId === undefined || corporationId === null)
            throw new globalThis.Error("The parameter 'corporationId' must be defined.");
        url_ = url_.replace("{corporationId}", encodeURIComponent("" + corporationId));
        if (fromDate === undefined || fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' must be defined.");
        url_ = url_.replace("{fromDate}", encodeURIComponent("" + fromDate));
        if (toDate === undefined || toDate === null)
            throw new globalThis.Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent("" + toDate));
        if (interval === null)
            throw new globalThis.Error("The parameter 'interval' cannot be null.");
        else if (interval !== undefined)
            url_ += "interval=" + encodeURIComponent("" + interval) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processBankDepthTotalsOverTime(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processBankDepthTotalsOverTime(response: Response): Promise<BankDepthTotalPbiExportModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BankDepthTotalPbiExportModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankDepthTotalPbiExportModel[]>(null as any);
    }

    async glTransactions(corporationId: string, fromDate: string, toDate: string, interval: ClickHouseReportDateRangeInterval | undefined): Promise<GlTransactionPbiExportModel[]> {
        const span = this.tracer.startSpan("GET /corporations/{corporationId}/CorporationsPbiExport/GlTransactions/{fromDate}/{toDate}", {
            attributes: {
                "corporationId": corporationId,
                "fromDate": fromDate,
                "toDate": toDate,
            }
        }, context.active());

        let url_ = this.baseUrl + "/corporations/{corporationId}/CorporationsPbiExport/GlTransactions/{fromDate}/{toDate}?";
        if (corporationId === undefined || corporationId === null)
            throw new globalThis.Error("The parameter 'corporationId' must be defined.");
        url_ = url_.replace("{corporationId}", encodeURIComponent("" + corporationId));
        if (fromDate === undefined || fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' must be defined.");
        url_ = url_.replace("{fromDate}", encodeURIComponent("" + fromDate));
        if (toDate === undefined || toDate === null)
            throw new globalThis.Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent("" + toDate));
        if (interval === null)
            throw new globalThis.Error("The parameter 'interval' cannot be null.");
        else if (interval !== undefined)
            url_ += "interval=" + encodeURIComponent("" + interval) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGlTransactions(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGlTransactions(response: Response): Promise<GlTransactionPbiExportModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GlTransactionPbiExportModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GlTransactionPbiExportModel[]>(null as any);
    }
}

@inject(String, HttpClient)
export class CorporationsTransactionsClient extends ReportingClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("CorporationsTransactionsClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5410", baseUrl);
    }

    async transactions(corporationId: string): Promise<InstrumentTransaction[]> {
        const span = this.tracer.startSpan("GET /corporations/{corporationId}/CorporationsTransactions/Transactions", {
            attributes: {
                "corporationId": corporationId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/corporations/{corporationId}/CorporationsTransactions/Transactions";
        if (corporationId === undefined || corporationId === null)
            throw new globalThis.Error("The parameter 'corporationId' must be defined.");
        url_ = url_.replace("{corporationId}", encodeURIComponent("" + corporationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processTransactions(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processTransactions(response: Response): Promise<InstrumentTransaction[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstrumentTransaction.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentTransaction[]>(null as any);
    }
}

@inject(String, HttpClient)
export class PortfolioReportClient extends ReportingClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("PortfolioReportClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5410", baseUrl);
    }

    async instrumentValues(companyIdentityId: number, fromDate: string | null | undefined, toDate: string, categoryTypeId: number | null | undefined, portfolio: string | null | undefined, quarters: number | undefined): Promise<InstrumentValuesReportViewModel[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/PortfolioReport/InstrumentValues/{toDate}", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "fromDate": fromDate,
                "toDate": toDate,
                "categoryTypeId": categoryTypeId,
                "portfolio": portfolio,
                "quarters": quarters,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/PortfolioReport/InstrumentValues/{toDate}?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (toDate === undefined || toDate === null)
            throw new globalThis.Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent("" + toDate));
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (categoryTypeId !== undefined && categoryTypeId !== null)
            url_ += "categoryTypeId=" + encodeURIComponent("" + categoryTypeId) + "&";
        if (portfolio !== undefined && portfolio !== null)
            url_ += "portfolio=" + encodeURIComponent("" + portfolio) + "&";
        if (quarters === null)
            throw new globalThis.Error("The parameter 'quarters' cannot be null.");
        else if (quarters !== undefined)
            url_ += "quarters=" + encodeURIComponent("" + quarters) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processInstrumentValues(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processInstrumentValues(response: Response): Promise<InstrumentValuesReportViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstrumentValuesReportViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentValuesReportViewModel[]>(null as any);
    }

    async costBreakdown(companyIdentityId: number, fromDate: string | undefined, toDate: string, hideSmallCost: boolean | undefined, portfolio: string | null | undefined): Promise<InstrumentCostBreakdownViewModel[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/PortfolioReport/CostBreakdown/{toDate}", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "fromDate": fromDate,
                "toDate": toDate,
                "portfolio": portfolio,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/PortfolioReport/CostBreakdown/{toDate}?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (toDate === undefined || toDate === null)
            throw new globalThis.Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent("" + toDate));
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (hideSmallCost === null)
            throw new globalThis.Error("The parameter 'hideSmallCost' cannot be null.");
        else if (hideSmallCost !== undefined)
            url_ += "hideSmallCost=" + encodeURIComponent("" + hideSmallCost) + "&";
        if (portfolio !== undefined && portfolio !== null)
            url_ += "portfolio=" + encodeURIComponent("" + portfolio) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processCostBreakdown(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processCostBreakdown(response: Response): Promise<InstrumentCostBreakdownViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstrumentCostBreakdownViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentCostBreakdownViewModel[]>(null as any);
    }

    async instrumentValuesGrid(companyIdentityId: number, fromDate: string | null | undefined, toDate: string, categoryTypeId: number | null | undefined, portfolio: string | null | undefined, quarters: number | undefined, pageRequest: AgGridPageRequest | undefined): Promise<InstrumentValuesGridResponse> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/PortfolioReport/InstrumentValuesGrid/{toDate}", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "fromDate": fromDate,
                "toDate": toDate,
                "categoryTypeId": categoryTypeId,
                "portfolio": portfolio,
                "quarters": quarters,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/PortfolioReport/InstrumentValuesGrid/{toDate}?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (toDate === undefined || toDate === null)
            throw new globalThis.Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent("" + toDate));
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (categoryTypeId !== undefined && categoryTypeId !== null)
            url_ += "categoryTypeId=" + encodeURIComponent("" + categoryTypeId) + "&";
        if (portfolio !== undefined && portfolio !== null)
            url_ += "portfolio=" + encodeURIComponent("" + portfolio) + "&";
        if (quarters === null)
            throw new globalThis.Error("The parameter 'quarters' cannot be null.");
        else if (quarters !== undefined)
            url_ += "quarters=" + encodeURIComponent("" + quarters) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pageRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processInstrumentValuesGrid(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processInstrumentValuesGrid(response: Response): Promise<InstrumentValuesGridResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InstrumentValuesGridResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentValuesGridResponse>(null as any);
    }

    async customerTotals(companyIdentityId: number, fromDate: string | null | undefined, toDate: string, indexAi: string | null | undefined, historicalMonths: number | undefined): Promise<CustomerTotalValuesReportViewModel[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/PortfolioReport/CustomerTotals/{toDate}", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "fromDate": fromDate,
                "toDate": toDate,
                "indexAi": indexAi,
                "historicalMonths": historicalMonths,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/PortfolioReport/CustomerTotals/{toDate}?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (toDate === undefined || toDate === null)
            throw new globalThis.Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent("" + toDate));
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (indexAi !== undefined && indexAi !== null)
            url_ += "indexAi=" + encodeURIComponent("" + indexAi) + "&";
        if (historicalMonths === null)
            throw new globalThis.Error("The parameter 'historicalMonths' cannot be null.");
        else if (historicalMonths !== undefined)
            url_ += "historicalMonths=" + encodeURIComponent("" + historicalMonths) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processCustomerTotals(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processCustomerTotals(response: Response): Promise<CustomerTotalValuesReportViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerTotalValuesReportViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerTotalValuesReportViewModel[]>(null as any);
    }

    async navDetails(companyIdentityId: number, toDate: string): Promise<NavDetailsViewModel> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/PortfolioReport/NavDetails/{toDate}", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "toDate": toDate,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/PortfolioReport/NavDetails/{toDate}";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (toDate === undefined || toDate === null)
            throw new globalThis.Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent("" + toDate));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processNavDetails(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processNavDetails(response: Response): Promise<NavDetailsViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NavDetailsViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NavDetailsViewModel>(null as any);
    }

    async instrumentValueGroupsOverTime(companyIdentityId: number[], categoryTypeId: number | null | undefined, fromDate: string | undefined, toDate: string): Promise<InstrumentValueGroup[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/PortfolioReport/InstrumentValueGroupsOverTime/{toDate}", {
            attributes: {
                "categoryTypeId": categoryTypeId,
                "fromDate": fromDate,
                "toDate": toDate,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/PortfolioReport/InstrumentValueGroupsOverTime/{toDate}?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent(companyIdentityId.join()));
        if (toDate === undefined || toDate === null)
            throw new globalThis.Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent("" + toDate));
        if (categoryTypeId !== undefined && categoryTypeId !== null)
            url_ += "categoryTypeId=" + encodeURIComponent("" + categoryTypeId) + "&";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processInstrumentValueGroupsOverTime(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processInstrumentValueGroupsOverTime(response: Response): Promise<InstrumentValueGroup[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstrumentValueGroup.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentValueGroup[]>(null as any);
    }

    async bankTotalsOverTime(companyIdentityId: number, fromDate: string | undefined, toDate: string): Promise<BankTotal[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/PortfolioReport/BankTotalsOverTime/{toDate}", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "fromDate": fromDate,
                "toDate": toDate,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/PortfolioReport/BankTotalsOverTime/{toDate}?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (toDate === undefined || toDate === null)
            throw new globalThis.Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent("" + toDate));
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processBankTotalsOverTime(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processBankTotalsOverTime(response: Response): Promise<BankTotal[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BankTotal.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankTotal[]>(null as any);
    }

    async instrumentValuesWithAllCategories(companyIdentityId: number[], toDate: string): Promise<InstrumentWithValuesViewModel[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/PortfolioReport/InstrumentValuesWithAllCategories/{toDate}", {
            attributes: {
                "toDate": toDate,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/PortfolioReport/InstrumentValuesWithAllCategories/{toDate}";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent(companyIdentityId.join()));
        if (toDate === undefined || toDate === null)
            throw new globalThis.Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent("" + toDate));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processInstrumentValuesWithAllCategories(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processInstrumentValuesWithAllCategories(response: Response): Promise<InstrumentWithValuesViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstrumentWithValuesViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentWithValuesViewModel[]>(null as any);
    }

    async instrumentPerformance(companyIdentityId: number[], toDate: string): Promise<PerformanceViewModel[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/PortfolioReport/InstrumentPerformance/{toDate}", {
            attributes: {
                "toDate": toDate,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/PortfolioReport/InstrumentPerformance/{toDate}";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent(companyIdentityId.join()));
        if (toDate === undefined || toDate === null)
            throw new globalThis.Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent("" + toDate));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processInstrumentPerformance(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processInstrumentPerformance(response: Response): Promise<PerformanceViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PerformanceViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PerformanceViewModel[]>(null as any);
    }

    async balance(companyIdentityId: number, dateRanges: ClickHouseReportDateRange[]): Promise<BalanceTotalsQueryModel[]> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/PortfolioReport/Balance", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/PortfolioReport/Balance";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dateRanges);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processBalance(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processBalance(response: Response): Promise<BalanceTotalsQueryModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BalanceTotalsQueryModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BalanceTotalsQueryModel[]>(null as any);
    }
}

export class CorporationCustomerViewModel implements ICorporationCustomerViewModel {
    identityId?: number;
    name?: string;
    corporationId?: string;
    companyReportingType?: CompanyReportingType;

    constructor(data?: ICorporationCustomerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identityId = _data["IdentityId"];
            this.name = _data["Name"];
            this.corporationId = _data["CorporationId"];
            this.companyReportingType = _data["CompanyReportingType"];
        }
    }

    static fromJS(data: any): CorporationCustomerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CorporationCustomerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IdentityId"] = this.identityId;
        data["Name"] = this.name;
        data["CorporationId"] = this.corporationId;
        data["CompanyReportingType"] = this.companyReportingType;
        return data;
    }
}

export interface ICorporationCustomerViewModel {
    identityId?: number;
    name?: string;
    corporationId?: string;
    companyReportingType?: CompanyReportingType;
}

export enum CompanyReportingType {
    Default = 0,
    Parent = 1,
    Subsidiary = 2,
}

export class CorporationViewModel implements ICorporationViewModel {
    corporationName?: string;
    corporationId?: string;

    constructor(data?: ICorporationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.corporationName = _data["CorporationName"];
            this.corporationId = _data["CorporationId"];
        }
    }

    static fromJS(data: any): CorporationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CorporationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CorporationName"] = this.corporationName;
        data["CorporationId"] = this.corporationId;
        return data;
    }
}

export interface ICorporationViewModel {
    corporationName?: string;
    corporationId?: string;
}

/** Request model for exporting multiple widgets' data to single Excel file */
export class ExportPageRequest implements IExportPageRequest {
    /** Name of the page (used to find template: Templates/{PageName}/{PageName}.xlsx) */
    pageName?: string | undefined;
    /** Dictionary of widget data, where:
- Key = widget name (used as worksheet name and table name in template)
- Value = widget data containing Items array */
    widgets?: { [key: string]: WidgetExportData; } | undefined;

    constructor(data?: IExportPageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageName = _data["pageName"];
            if (_data["widgets"]) {
                this.widgets = {} as any;
                for (let key in _data["widgets"]) {
                    if (_data["widgets"].hasOwnProperty(key))
                        (this.widgets as any)![key] = _data["widgets"][key] ? WidgetExportData.fromJS(_data["widgets"][key]) : new WidgetExportData();
                }
            }
        }
    }

    static fromJS(data: any): ExportPageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExportPageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageName"] = this.pageName;
        if (this.widgets) {
            data["widgets"] = {};
            for (let key in this.widgets) {
                if (this.widgets.hasOwnProperty(key))
                    (data["widgets"] as any)[key] = this.widgets[key] ? this.widgets[key].toJSON() : undefined as any;
            }
        }
        return data;
    }
}

/** Request model for exporting multiple widgets' data to single Excel file */
export interface IExportPageRequest {
    /** Name of the page (used to find template: Templates/{PageName}/{PageName}.xlsx) */
    pageName?: string | undefined;
    /** Dictionary of widget data, where:
- Key = widget name (used as worksheet name and table name in template)
- Value = widget data containing Items array */
    widgets?: { [key: string]: WidgetExportData; } | undefined;
}

/** Widget data for page export */
export class WidgetExportData implements IWidgetExportData {
    /** Data rows for this widget
Each item is a dictionary where keys match table column headers */
    items?: any | undefined;

    constructor(data?: IWidgetExportData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.items = _data["items"];
        }
    }

    static fromJS(data: any): WidgetExportData {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetExportData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["items"] = this.items;
        return data;
    }
}

/** Widget data for page export */
export interface IWidgetExportData {
    /** Data rows for this widget
Each item is a dictionary where keys match table column headers */
    items?: any | undefined;
}

export class GlLedgerAccountCategoryVm implements IGlLedgerAccountCategoryVm {
    customerId?: number | undefined;
    id?: number | undefined;
    name?: string | undefined;
    accountLookupCode?: string | undefined;
    glCategoryId?: number;
    glCategoryOverrideId?: number | undefined;
    level1?: string | undefined;
    level2?: string | undefined;
    level3?: string | undefined;
    level4?: string | undefined;
    level5?: string | undefined;
    level6?: string | undefined;
    level7?: string | undefined;
    level8?: string | undefined;
    level9?: string | undefined;
    level10?: string | undefined;
    level1Default?: string | undefined;
    level2Default?: string | undefined;
    level3Default?: string | undefined;
    level4Default?: string | undefined;
    level5Default?: string | undefined;
    level6Default?: string | undefined;
    level7Default?: string | undefined;
    level8Default?: string | undefined;
    level9Default?: string | undefined;
    level10Default?: string | undefined;
    reportType?: string | undefined;

    constructor(data?: IGlLedgerAccountCategoryVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["CustomerId"];
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.accountLookupCode = _data["AccountLookupCode"];
            this.glCategoryId = _data["GlCategoryId"];
            this.glCategoryOverrideId = _data["GlCategoryOverrideId"];
            this.level1 = _data["Level1"];
            this.level2 = _data["Level2"];
            this.level3 = _data["Level3"];
            this.level4 = _data["Level4"];
            this.level5 = _data["Level5"];
            this.level6 = _data["Level6"];
            this.level7 = _data["Level7"];
            this.level8 = _data["Level8"];
            this.level9 = _data["Level9"];
            this.level10 = _data["Level10"];
            this.level1Default = _data["Level1Default"];
            this.level2Default = _data["Level2Default"];
            this.level3Default = _data["Level3Default"];
            this.level4Default = _data["Level4Default"];
            this.level5Default = _data["Level5Default"];
            this.level6Default = _data["Level6Default"];
            this.level7Default = _data["Level7Default"];
            this.level8Default = _data["Level8Default"];
            this.level9Default = _data["Level9Default"];
            this.level10Default = _data["Level10Default"];
            this.reportType = _data["ReportType"];
        }
    }

    static fromJS(data: any): GlLedgerAccountCategoryVm {
        data = typeof data === 'object' ? data : {};
        let result = new GlLedgerAccountCategoryVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomerId"] = this.customerId;
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["AccountLookupCode"] = this.accountLookupCode;
        data["GlCategoryId"] = this.glCategoryId;
        data["GlCategoryOverrideId"] = this.glCategoryOverrideId;
        data["Level1"] = this.level1;
        data["Level2"] = this.level2;
        data["Level3"] = this.level3;
        data["Level4"] = this.level4;
        data["Level5"] = this.level5;
        data["Level6"] = this.level6;
        data["Level7"] = this.level7;
        data["Level8"] = this.level8;
        data["Level9"] = this.level9;
        data["Level10"] = this.level10;
        data["Level1Default"] = this.level1Default;
        data["Level2Default"] = this.level2Default;
        data["Level3Default"] = this.level3Default;
        data["Level4Default"] = this.level4Default;
        data["Level5Default"] = this.level5Default;
        data["Level6Default"] = this.level6Default;
        data["Level7Default"] = this.level7Default;
        data["Level8Default"] = this.level8Default;
        data["Level9Default"] = this.level9Default;
        data["Level10Default"] = this.level10Default;
        data["ReportType"] = this.reportType;
        return data;
    }
}

export interface IGlLedgerAccountCategoryVm {
    customerId?: number | undefined;
    id?: number | undefined;
    name?: string | undefined;
    accountLookupCode?: string | undefined;
    glCategoryId?: number;
    glCategoryOverrideId?: number | undefined;
    level1?: string | undefined;
    level2?: string | undefined;
    level3?: string | undefined;
    level4?: string | undefined;
    level5?: string | undefined;
    level6?: string | undefined;
    level7?: string | undefined;
    level8?: string | undefined;
    level9?: string | undefined;
    level10?: string | undefined;
    level1Default?: string | undefined;
    level2Default?: string | undefined;
    level3Default?: string | undefined;
    level4Default?: string | undefined;
    level5Default?: string | undefined;
    level6Default?: string | undefined;
    level7Default?: string | undefined;
    level8Default?: string | undefined;
    level9Default?: string | undefined;
    level10Default?: string | undefined;
    reportType?: string | undefined;
}

export class GlAccountTransaction implements IGlAccountTransaction {
    compositeKey?: string;
    customerId?: number | undefined;
    customer?: Customer | undefined;
    compositeVoucherNoKey?: string;
    externalClientId?: string;
    externalId?: string;
    externalAccountId?: string | undefined;
    glSystemType?: number;
    externalGlSystemType?: string | undefined;
    id?: number;
    accountCode?: number;
    date?: string;
    voucherNo?: number;
    importedVoucherNo?: number | undefined;
    voucherType?: number;
    text?: string | undefined;
    description?: string | undefined;
    vatCode?: string | undefined;
    vatAmount?: number;
    vatRate?: number;
    amount?: number;
    currencyCode?: string | undefined;
    currencyAmount?: number;
    voucherImagesCount?: number;
    lastChanged?: string | undefined;
    createdDate?: string | undefined;
    voucherDueDate?: string | undefined;
    voucherReference?: string | undefined;
    voucherCid?: string | undefined;
    voucherCreditNoteReference?: string | undefined;
    voucherId?: string | undefined;
    documentNo?: string | undefined;

    constructor(data?: IGlAccountTransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.compositeKey = _data["CompositeKey"];
            this.customerId = _data["CustomerId"];
            this.customer = _data["Customer"] ? Customer.fromJS(_data["Customer"]) : undefined as any;
            this.compositeVoucherNoKey = _data["CompositeVoucherNoKey"];
            this.externalClientId = _data["ExternalClientId"];
            this.externalId = _data["ExternalId"];
            this.externalAccountId = _data["ExternalAccountId"];
            this.glSystemType = _data["GlSystemType"];
            this.externalGlSystemType = _data["ExternalGlSystemType"];
            this.id = _data["Id"];
            this.accountCode = _data["AccountCode"];
            this.date = _data["Date"];
            this.voucherNo = _data["VoucherNo"];
            this.importedVoucherNo = _data["ImportedVoucherNo"];
            this.voucherType = _data["VoucherType"];
            this.text = _data["Text"];
            this.description = _data["Description"];
            this.vatCode = _data["VatCode"];
            this.vatAmount = _data["VatAmount"];
            this.vatRate = _data["VatRate"];
            this.amount = _data["Amount"];
            this.currencyCode = _data["CurrencyCode"];
            this.currencyAmount = _data["CurrencyAmount"];
            this.voucherImagesCount = _data["VoucherImagesCount"];
            this.lastChanged = _data["LastChanged"];
            this.createdDate = _data["CreatedDate"];
            this.voucherDueDate = _data["VoucherDueDate"];
            this.voucherReference = _data["VoucherReference"];
            this.voucherCid = _data["VoucherCid"];
            this.voucherCreditNoteReference = _data["VoucherCreditNoteReference"];
            this.voucherId = _data["VoucherId"];
            this.documentNo = _data["DocumentNo"];
        }
    }

    static fromJS(data: any): GlAccountTransaction {
        data = typeof data === 'object' ? data : {};
        let result = new GlAccountTransaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CompositeKey"] = this.compositeKey;
        data["CustomerId"] = this.customerId;
        data["Customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["CompositeVoucherNoKey"] = this.compositeVoucherNoKey;
        data["ExternalClientId"] = this.externalClientId;
        data["ExternalId"] = this.externalId;
        data["ExternalAccountId"] = this.externalAccountId;
        data["GlSystemType"] = this.glSystemType;
        data["ExternalGlSystemType"] = this.externalGlSystemType;
        data["Id"] = this.id;
        data["AccountCode"] = this.accountCode;
        data["Date"] = this.date;
        data["VoucherNo"] = this.voucherNo;
        data["ImportedVoucherNo"] = this.importedVoucherNo;
        data["VoucherType"] = this.voucherType;
        data["Text"] = this.text;
        data["Description"] = this.description;
        data["VatCode"] = this.vatCode;
        data["VatAmount"] = this.vatAmount;
        data["VatRate"] = this.vatRate;
        data["Amount"] = this.amount;
        data["CurrencyCode"] = this.currencyCode;
        data["CurrencyAmount"] = this.currencyAmount;
        data["VoucherImagesCount"] = this.voucherImagesCount;
        data["LastChanged"] = this.lastChanged;
        data["CreatedDate"] = this.createdDate;
        data["VoucherDueDate"] = this.voucherDueDate;
        data["VoucherReference"] = this.voucherReference;
        data["VoucherCid"] = this.voucherCid;
        data["VoucherCreditNoteReference"] = this.voucherCreditNoteReference;
        data["VoucherId"] = this.voucherId;
        data["DocumentNo"] = this.documentNo;
        return data;
    }
}

export interface IGlAccountTransaction {
    compositeKey?: string;
    customerId?: number | undefined;
    customer?: Customer | undefined;
    compositeVoucherNoKey?: string;
    externalClientId?: string;
    externalId?: string;
    externalAccountId?: string | undefined;
    glSystemType?: number;
    externalGlSystemType?: string | undefined;
    id?: number;
    accountCode?: number;
    date?: string;
    voucherNo?: number;
    importedVoucherNo?: number | undefined;
    voucherType?: number;
    text?: string | undefined;
    description?: string | undefined;
    vatCode?: string | undefined;
    vatAmount?: number;
    vatRate?: number;
    amount?: number;
    currencyCode?: string | undefined;
    currencyAmount?: number;
    voucherImagesCount?: number;
    lastChanged?: string | undefined;
    createdDate?: string | undefined;
    voucherDueDate?: string | undefined;
    voucherReference?: string | undefined;
    voucherCid?: string | undefined;
    voucherCreditNoteReference?: string | undefined;
    voucherId?: string | undefined;
    documentNo?: string | undefined;
}

export class Customer implements ICustomer {
    id?: number;
    uuid?: string;
    identityId?: number;
    corporationId?: string;
    customerName?: string | undefined;
    vatNumber?: string | undefined;
    externalGlClientId?: string | undefined;
    parentCustomer?: Customer | undefined;
    childCustomers?: Customer[] | undefined;
    voucherReceivingEmail?: string | undefined;
    changed?: string;
    companyReportingType?: CompanyReportingType;

    constructor(data?: ICustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.uuid = _data["Uuid"];
            this.identityId = _data["IdentityId"];
            this.corporationId = _data["CorporationId"];
            this.customerName = _data["CustomerName"];
            this.vatNumber = _data["VatNumber"];
            this.externalGlClientId = _data["ExternalGlClientId"];
            this.parentCustomer = _data["ParentCustomer"] ? Customer.fromJS(_data["ParentCustomer"]) : undefined as any;
            if (Array.isArray(_data["ChildCustomers"])) {
                this.childCustomers = [] as any;
                for (let item of _data["ChildCustomers"])
                    this.childCustomers!.push(Customer.fromJS(item));
            }
            this.voucherReceivingEmail = _data["VoucherReceivingEmail"];
            this.changed = _data["Changed"];
            this.companyReportingType = _data["CompanyReportingType"];
        }
    }

    static fromJS(data: any): Customer {
        data = typeof data === 'object' ? data : {};
        let result = new Customer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Uuid"] = this.uuid;
        data["IdentityId"] = this.identityId;
        data["CorporationId"] = this.corporationId;
        data["CustomerName"] = this.customerName;
        data["VatNumber"] = this.vatNumber;
        data["ExternalGlClientId"] = this.externalGlClientId;
        data["ParentCustomer"] = this.parentCustomer ? this.parentCustomer.toJSON() : undefined as any;
        if (Array.isArray(this.childCustomers)) {
            data["ChildCustomers"] = [];
            for (let item of this.childCustomers)
                data["ChildCustomers"].push(item ? item.toJSON() : undefined as any);
        }
        data["VoucherReceivingEmail"] = this.voucherReceivingEmail;
        data["Changed"] = this.changed;
        data["CompanyReportingType"] = this.companyReportingType;
        return data;
    }
}

export interface ICustomer {
    id?: number;
    uuid?: string;
    identityId?: number;
    corporationId?: string;
    customerName?: string | undefined;
    vatNumber?: string | undefined;
    externalGlClientId?: string | undefined;
    parentCustomer?: Customer | undefined;
    childCustomers?: Customer[] | undefined;
    voucherReceivingEmail?: string | undefined;
    changed?: string;
    companyReportingType?: CompanyReportingType;
}

export class GlAccountTransactionCountsViewModel implements IGlAccountTransactionCountsViewModel {
    reportingCount?: number;
    clickHouseCount?: number;
    lastChanged?: string | undefined;

    constructor(data?: IGlAccountTransactionCountsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportingCount = _data["ReportingCount"];
            this.clickHouseCount = _data["ClickHouseCount"];
            this.lastChanged = _data["LastChanged"];
        }
    }

    static fromJS(data: any): GlAccountTransactionCountsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GlAccountTransactionCountsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ReportingCount"] = this.reportingCount;
        data["ClickHouseCount"] = this.clickHouseCount;
        data["LastChanged"] = this.lastChanged;
        return data;
    }
}

export interface IGlAccountTransactionCountsViewModel {
    reportingCount?: number;
    clickHouseCount?: number;
    lastChanged?: string | undefined;
}

export class GlReportBaseData implements IGlReportBaseData {
    externalAccountNo?: string | undefined;
    amount?: number;
    level1?: string | undefined;
    level2?: string | undefined;
    level3?: string | undefined;
    level4?: string | undefined;
    level5?: string | undefined;
    reportType?: string | undefined;
    minDate?: string;

    constructor(data?: IGlReportBaseData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalAccountNo = _data["ExternalAccountNo"];
            this.amount = _data["Amount"];
            this.level1 = _data["Level1"];
            this.level2 = _data["Level2"];
            this.level3 = _data["Level3"];
            this.level4 = _data["Level4"];
            this.level5 = _data["Level5"];
            this.reportType = _data["ReportType"];
            this.minDate = _data["MinDate"];
        }
    }

    static fromJS(data: any): GlReportBaseData {
        data = typeof data === 'object' ? data : {};
        let result = new GlReportBaseData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ExternalAccountNo"] = this.externalAccountNo;
        data["Amount"] = this.amount;
        data["Level1"] = this.level1;
        data["Level2"] = this.level2;
        data["Level3"] = this.level3;
        data["Level4"] = this.level4;
        data["Level5"] = this.level5;
        data["ReportType"] = this.reportType;
        data["MinDate"] = this.minDate;
        return data;
    }
}

export interface IGlReportBaseData {
    externalAccountNo?: string | undefined;
    amount?: number;
    level1?: string | undefined;
    level2?: string | undefined;
    level3?: string | undefined;
    level4?: string | undefined;
    level5?: string | undefined;
    reportType?: string | undefined;
    minDate?: string;
}

export class BalanceReportViewModel implements IBalanceReportViewModel {
    performanceNetSoldSecurities?: number | undefined;
    performanceUnrealPLYTDShortTerm?: number | undefined;
    performanceOperatingExpenses?: number | undefined;
    performanceNetOperatingResult?: number | undefined;
    performanceDividend?: number | undefined;
    performanceNetInterest?: number | undefined;
    performanceNetCurrency?: number | undefined;
    performanceOtherFinancialItems?: number | undefined;
    performanceResultBeforeTax?: number | undefined;
    performanceTax?: number | undefined;
    performanceResultAfterTax?: number | undefined;
    performanceUnrealPLYTDLongTerm?: number | undefined;
    performanceValueAdjustedResult?: number | undefined;
    performanceValueAdjustedResultLastMonth?: number | undefined;
    performanceValueAdjustedResultCurrentMonth?: number | undefined;
    keyBank?: number | undefined;
    keyOther?: number | undefined;
    keyDebt?: number | undefined;
    keyNetShortTerm?: number | undefined;
    keyDividend?: number | undefined;
    keyAccountsPayables?: number | undefined;
    keyNetCash?: number | undefined;
    keyNetToOwner?: number | undefined;
    keyNetToGroup?: number | undefined;
    keyOtherLongTermAssets?: number | undefined;
    keyPortfolioValue?: number | undefined;
    keyTotalAssetsIncludingShareholderLoan?: number | undefined;
    keyShareCapital?: number | undefined;
    keyPremiumFund?: number | undefined;
    keyOtherEquity?: number | undefined;
    keyProfitThisYear?: number | undefined;
    keyTotalEquity?: number | undefined;
    lYNetCurrency?: number | undefined;
    yTDNetCurrency?: number | undefined;
    lYOtherFinItems?: number | undefined;
    yTDOtherFinItems?: number | undefined;
    yTDIntangibleassets?: number | undefined;
    yTDTangibleassets?: number | undefined;
    yTDReceivables?: number | undefined;
    yTDReceivablesgroupcompanies?: number | undefined;
    yTDInvestmentsbaseinvested?: number | undefined;
    yTDInvestmentsakkumulatedperformance?: number | undefined;
    yTDDeposits?: number | undefined;
    yTDTotalassets?: number | undefined;
    yTDPaidequity?: number | undefined;
    yTDRetainedearnings?: number | undefined;
    yTDresult?: number | undefined;
    yTDTotalequity?: number | undefined;
    yTDLiabilities?: number | undefined;
    yTDLiabilitiesgroupcompanies?: number | undefined;
    yTDTotalequityandliabilities?: number | undefined;
    yTDTotalliabilities?: number | undefined;
    yTDOperatingIncome?: number | undefined;
    yTDPersonellExpenses?: number | undefined;
    yTDOtherOperatingExpenses?: number | undefined;
    yTDOperatingProfit?: number | undefined;
    yTDNetInterest?: number | undefined;
    yTDNetSoldSecurities?: number | undefined;
    yTDDividend?: number | undefined;
    yTDInterestCost?: number | undefined;
    yTDLossSoldSecurities?: number | undefined;
    yTDChangeInValueYtd?: number | undefined;
    yTDNetFinancialItems?: number | undefined;
    yTDNetIncomeBeforeTax?: number | undefined;
    lYIntangibleassets?: number | undefined;
    lYTangibleassets?: number | undefined;
    lYReceivables?: number | undefined;
    lYReceivablesgroupcompanies?: number | undefined;
    lYInvestmentsbaseinvested?: number | undefined;
    lYInvestmentsakkumulatedperformance?: number | undefined;
    lYDeposits?: number | undefined;
    lYTotalassets?: number | undefined;
    lYPaidequity?: number | undefined;
    lYRetainedearnings?: number | undefined;
    lYResult?: number | undefined;
    lYTotalequity?: number | undefined;
    lYLiabilities?: number | undefined;
    lYLiabilitiesgroupcompanies?: number | undefined;
    lYTotalequityandliabilities?: number | undefined;
    lYTotalliabilities?: number | undefined;
    lYOperatingIncome?: number | undefined;
    lYPersonellExpenses?: number | undefined;
    lYOtherOperatingExpenses?: number | undefined;
    lYOperatingProfit?: number | undefined;
    lYNetInterest?: number | undefined;
    lYNetSoldSecurities?: number | undefined;
    lYDividend?: number | undefined;
    lYInterestCost?: number | undefined;
    lYLossSoldSecurities?: number | undefined;
    lYChangeInValueYtd?: number | undefined;
    lYNetFinancialItems?: number | undefined;
    lYNetIncomeBeforeTax?: number | undefined;
    lYReportDate?: string | undefined;
    yTDReportDate?: string | undefined;

    constructor(data?: IBalanceReportViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.performanceNetSoldSecurities = _data["PerformanceNetSoldSecurities"];
            this.performanceUnrealPLYTDShortTerm = _data["PerformanceUnrealPLYTDShortTerm"];
            this.performanceOperatingExpenses = _data["PerformanceOperatingExpenses"];
            this.performanceNetOperatingResult = _data["PerformanceNetOperatingResult"];
            this.performanceDividend = _data["PerformanceDividend"];
            this.performanceNetInterest = _data["PerformanceNetInterest"];
            this.performanceNetCurrency = _data["PerformanceNetCurrency"];
            this.performanceOtherFinancialItems = _data["PerformanceOtherFinancialItems"];
            this.performanceResultBeforeTax = _data["PerformanceResultBeforeTax"];
            this.performanceTax = _data["PerformanceTax"];
            this.performanceResultAfterTax = _data["PerformanceResultAfterTax"];
            this.performanceUnrealPLYTDLongTerm = _data["PerformanceUnrealPLYTDLongTerm"];
            this.performanceValueAdjustedResult = _data["PerformanceValueAdjustedResult"];
            this.performanceValueAdjustedResultLastMonth = _data["PerformanceValueAdjustedResultLastMonth"];
            this.performanceValueAdjustedResultCurrentMonth = _data["PerformanceValueAdjustedResultCurrentMonth"];
            this.keyBank = _data["KeyBank"];
            this.keyOther = _data["KeyOther"];
            this.keyDebt = _data["KeyDebt"];
            this.keyNetShortTerm = _data["KeyNetShortTerm"];
            this.keyDividend = _data["KeyDividend"];
            this.keyAccountsPayables = _data["KeyAccountsPayables"];
            this.keyNetCash = _data["KeyNetCash"];
            this.keyNetToOwner = _data["KeyNetToOwner"];
            this.keyNetToGroup = _data["KeyNetToGroup"];
            this.keyOtherLongTermAssets = _data["KeyOtherLongTermAssets"];
            this.keyPortfolioValue = _data["KeyPortfolioValue"];
            this.keyTotalAssetsIncludingShareholderLoan = _data["KeyTotalAssetsIncludingShareholderLoan"];
            this.keyShareCapital = _data["KeyShareCapital"];
            this.keyPremiumFund = _data["KeyPremiumFund"];
            this.keyOtherEquity = _data["KeyOtherEquity"];
            this.keyProfitThisYear = _data["KeyProfitThisYear"];
            this.keyTotalEquity = _data["KeyTotalEquity"];
            this.lYNetCurrency = _data["LYNetCurrency"];
            this.yTDNetCurrency = _data["YTDNetCurrency"];
            this.lYOtherFinItems = _data["LYOtherFinItems"];
            this.yTDOtherFinItems = _data["YTDOtherFinItems"];
            this.yTDIntangibleassets = _data["YTDIntangibleassets"];
            this.yTDTangibleassets = _data["YTDTangibleassets"];
            this.yTDReceivables = _data["YTDReceivables"];
            this.yTDReceivablesgroupcompanies = _data["YTDReceivablesgroupcompanies"];
            this.yTDInvestmentsbaseinvested = _data["YTDInvestmentsbaseinvested"];
            this.yTDInvestmentsakkumulatedperformance = _data["YTDInvestmentsakkumulatedperformance"];
            this.yTDDeposits = _data["YTDDeposits"];
            this.yTDTotalassets = _data["YTDTotalassets"];
            this.yTDPaidequity = _data["YTDPaidequity"];
            this.yTDRetainedearnings = _data["YTDRetainedearnings"];
            this.yTDresult = _data["YTDresult"];
            this.yTDTotalequity = _data["YTDTotalequity"];
            this.yTDLiabilities = _data["YTDLiabilities"];
            this.yTDLiabilitiesgroupcompanies = _data["YTDLiabilitiesgroupcompanies"];
            this.yTDTotalequityandliabilities = _data["YTDTotalequityandliabilities"];
            this.yTDTotalliabilities = _data["YTDTotalliabilities"];
            this.yTDOperatingIncome = _data["YTDOperatingIncome"];
            this.yTDPersonellExpenses = _data["YTDPersonellExpenses"];
            this.yTDOtherOperatingExpenses = _data["YTDOtherOperatingExpenses"];
            this.yTDOperatingProfit = _data["YTDOperatingProfit"];
            this.yTDNetInterest = _data["YTDNetInterest"];
            this.yTDNetSoldSecurities = _data["YTDNetSoldSecurities"];
            this.yTDDividend = _data["YTDDividend"];
            this.yTDInterestCost = _data["YTDInterestCost"];
            this.yTDLossSoldSecurities = _data["YTDLossSoldSecurities"];
            this.yTDChangeInValueYtd = _data["YTDChangeInValueYtd"];
            this.yTDNetFinancialItems = _data["YTDNetFinancialItems"];
            this.yTDNetIncomeBeforeTax = _data["YTDNetIncomeBeforeTax"];
            this.lYIntangibleassets = _data["LYIntangibleassets"];
            this.lYTangibleassets = _data["LYTangibleassets"];
            this.lYReceivables = _data["LYReceivables"];
            this.lYReceivablesgroupcompanies = _data["LYReceivablesgroupcompanies"];
            this.lYInvestmentsbaseinvested = _data["LYInvestmentsbaseinvested"];
            this.lYInvestmentsakkumulatedperformance = _data["LYInvestmentsakkumulatedperformance"];
            this.lYDeposits = _data["LYDeposits"];
            this.lYTotalassets = _data["LYTotalassets"];
            this.lYPaidequity = _data["LYPaidequity"];
            this.lYRetainedearnings = _data["LYRetainedearnings"];
            this.lYResult = _data["LYResult"];
            this.lYTotalequity = _data["LYTotalequity"];
            this.lYLiabilities = _data["LYLiabilities"];
            this.lYLiabilitiesgroupcompanies = _data["LYLiabilitiesgroupcompanies"];
            this.lYTotalequityandliabilities = _data["LYTotalequityandliabilities"];
            this.lYTotalliabilities = _data["LYTotalliabilities"];
            this.lYOperatingIncome = _data["LYOperatingIncome"];
            this.lYPersonellExpenses = _data["LYPersonellExpenses"];
            this.lYOtherOperatingExpenses = _data["LYOtherOperatingExpenses"];
            this.lYOperatingProfit = _data["LYOperatingProfit"];
            this.lYNetInterest = _data["LYNetInterest"];
            this.lYNetSoldSecurities = _data["LYNetSoldSecurities"];
            this.lYDividend = _data["LYDividend"];
            this.lYInterestCost = _data["LYInterestCost"];
            this.lYLossSoldSecurities = _data["LYLossSoldSecurities"];
            this.lYChangeInValueYtd = _data["LYChangeInValueYtd"];
            this.lYNetFinancialItems = _data["LYNetFinancialItems"];
            this.lYNetIncomeBeforeTax = _data["LYNetIncomeBeforeTax"];
            this.lYReportDate = _data["LYReportDate"];
            this.yTDReportDate = _data["YTDReportDate"];
        }
    }

    static fromJS(data: any): BalanceReportViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BalanceReportViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PerformanceNetSoldSecurities"] = this.performanceNetSoldSecurities;
        data["PerformanceUnrealPLYTDShortTerm"] = this.performanceUnrealPLYTDShortTerm;
        data["PerformanceOperatingExpenses"] = this.performanceOperatingExpenses;
        data["PerformanceNetOperatingResult"] = this.performanceNetOperatingResult;
        data["PerformanceDividend"] = this.performanceDividend;
        data["PerformanceNetInterest"] = this.performanceNetInterest;
        data["PerformanceNetCurrency"] = this.performanceNetCurrency;
        data["PerformanceOtherFinancialItems"] = this.performanceOtherFinancialItems;
        data["PerformanceResultBeforeTax"] = this.performanceResultBeforeTax;
        data["PerformanceTax"] = this.performanceTax;
        data["PerformanceResultAfterTax"] = this.performanceResultAfterTax;
        data["PerformanceUnrealPLYTDLongTerm"] = this.performanceUnrealPLYTDLongTerm;
        data["PerformanceValueAdjustedResult"] = this.performanceValueAdjustedResult;
        data["PerformanceValueAdjustedResultLastMonth"] = this.performanceValueAdjustedResultLastMonth;
        data["PerformanceValueAdjustedResultCurrentMonth"] = this.performanceValueAdjustedResultCurrentMonth;
        data["KeyBank"] = this.keyBank;
        data["KeyOther"] = this.keyOther;
        data["KeyDebt"] = this.keyDebt;
        data["KeyNetShortTerm"] = this.keyNetShortTerm;
        data["KeyDividend"] = this.keyDividend;
        data["KeyAccountsPayables"] = this.keyAccountsPayables;
        data["KeyNetCash"] = this.keyNetCash;
        data["KeyNetToOwner"] = this.keyNetToOwner;
        data["KeyNetToGroup"] = this.keyNetToGroup;
        data["KeyOtherLongTermAssets"] = this.keyOtherLongTermAssets;
        data["KeyPortfolioValue"] = this.keyPortfolioValue;
        data["KeyTotalAssetsIncludingShareholderLoan"] = this.keyTotalAssetsIncludingShareholderLoan;
        data["KeyShareCapital"] = this.keyShareCapital;
        data["KeyPremiumFund"] = this.keyPremiumFund;
        data["KeyOtherEquity"] = this.keyOtherEquity;
        data["KeyProfitThisYear"] = this.keyProfitThisYear;
        data["KeyTotalEquity"] = this.keyTotalEquity;
        data["LYNetCurrency"] = this.lYNetCurrency;
        data["YTDNetCurrency"] = this.yTDNetCurrency;
        data["LYOtherFinItems"] = this.lYOtherFinItems;
        data["YTDOtherFinItems"] = this.yTDOtherFinItems;
        data["YTDIntangibleassets"] = this.yTDIntangibleassets;
        data["YTDTangibleassets"] = this.yTDTangibleassets;
        data["YTDReceivables"] = this.yTDReceivables;
        data["YTDReceivablesgroupcompanies"] = this.yTDReceivablesgroupcompanies;
        data["YTDInvestmentsbaseinvested"] = this.yTDInvestmentsbaseinvested;
        data["YTDInvestmentsakkumulatedperformance"] = this.yTDInvestmentsakkumulatedperformance;
        data["YTDDeposits"] = this.yTDDeposits;
        data["YTDTotalassets"] = this.yTDTotalassets;
        data["YTDPaidequity"] = this.yTDPaidequity;
        data["YTDRetainedearnings"] = this.yTDRetainedearnings;
        data["YTDresult"] = this.yTDresult;
        data["YTDTotalequity"] = this.yTDTotalequity;
        data["YTDLiabilities"] = this.yTDLiabilities;
        data["YTDLiabilitiesgroupcompanies"] = this.yTDLiabilitiesgroupcompanies;
        data["YTDTotalequityandliabilities"] = this.yTDTotalequityandliabilities;
        data["YTDTotalliabilities"] = this.yTDTotalliabilities;
        data["YTDOperatingIncome"] = this.yTDOperatingIncome;
        data["YTDPersonellExpenses"] = this.yTDPersonellExpenses;
        data["YTDOtherOperatingExpenses"] = this.yTDOtherOperatingExpenses;
        data["YTDOperatingProfit"] = this.yTDOperatingProfit;
        data["YTDNetInterest"] = this.yTDNetInterest;
        data["YTDNetSoldSecurities"] = this.yTDNetSoldSecurities;
        data["YTDDividend"] = this.yTDDividend;
        data["YTDInterestCost"] = this.yTDInterestCost;
        data["YTDLossSoldSecurities"] = this.yTDLossSoldSecurities;
        data["YTDChangeInValueYtd"] = this.yTDChangeInValueYtd;
        data["YTDNetFinancialItems"] = this.yTDNetFinancialItems;
        data["YTDNetIncomeBeforeTax"] = this.yTDNetIncomeBeforeTax;
        data["LYIntangibleassets"] = this.lYIntangibleassets;
        data["LYTangibleassets"] = this.lYTangibleassets;
        data["LYReceivables"] = this.lYReceivables;
        data["LYReceivablesgroupcompanies"] = this.lYReceivablesgroupcompanies;
        data["LYInvestmentsbaseinvested"] = this.lYInvestmentsbaseinvested;
        data["LYInvestmentsakkumulatedperformance"] = this.lYInvestmentsakkumulatedperformance;
        data["LYDeposits"] = this.lYDeposits;
        data["LYTotalassets"] = this.lYTotalassets;
        data["LYPaidequity"] = this.lYPaidequity;
        data["LYRetainedearnings"] = this.lYRetainedearnings;
        data["LYResult"] = this.lYResult;
        data["LYTotalequity"] = this.lYTotalequity;
        data["LYLiabilities"] = this.lYLiabilities;
        data["LYLiabilitiesgroupcompanies"] = this.lYLiabilitiesgroupcompanies;
        data["LYTotalequityandliabilities"] = this.lYTotalequityandliabilities;
        data["LYTotalliabilities"] = this.lYTotalliabilities;
        data["LYOperatingIncome"] = this.lYOperatingIncome;
        data["LYPersonellExpenses"] = this.lYPersonellExpenses;
        data["LYOtherOperatingExpenses"] = this.lYOtherOperatingExpenses;
        data["LYOperatingProfit"] = this.lYOperatingProfit;
        data["LYNetInterest"] = this.lYNetInterest;
        data["LYNetSoldSecurities"] = this.lYNetSoldSecurities;
        data["LYDividend"] = this.lYDividend;
        data["LYInterestCost"] = this.lYInterestCost;
        data["LYLossSoldSecurities"] = this.lYLossSoldSecurities;
        data["LYChangeInValueYtd"] = this.lYChangeInValueYtd;
        data["LYNetFinancialItems"] = this.lYNetFinancialItems;
        data["LYNetIncomeBeforeTax"] = this.lYNetIncomeBeforeTax;
        data["LYReportDate"] = this.lYReportDate;
        data["YTDReportDate"] = this.yTDReportDate;
        return data;
    }
}

export interface IBalanceReportViewModel {
    performanceNetSoldSecurities?: number | undefined;
    performanceUnrealPLYTDShortTerm?: number | undefined;
    performanceOperatingExpenses?: number | undefined;
    performanceNetOperatingResult?: number | undefined;
    performanceDividend?: number | undefined;
    performanceNetInterest?: number | undefined;
    performanceNetCurrency?: number | undefined;
    performanceOtherFinancialItems?: number | undefined;
    performanceResultBeforeTax?: number | undefined;
    performanceTax?: number | undefined;
    performanceResultAfterTax?: number | undefined;
    performanceUnrealPLYTDLongTerm?: number | undefined;
    performanceValueAdjustedResult?: number | undefined;
    performanceValueAdjustedResultLastMonth?: number | undefined;
    performanceValueAdjustedResultCurrentMonth?: number | undefined;
    keyBank?: number | undefined;
    keyOther?: number | undefined;
    keyDebt?: number | undefined;
    keyNetShortTerm?: number | undefined;
    keyDividend?: number | undefined;
    keyAccountsPayables?: number | undefined;
    keyNetCash?: number | undefined;
    keyNetToOwner?: number | undefined;
    keyNetToGroup?: number | undefined;
    keyOtherLongTermAssets?: number | undefined;
    keyPortfolioValue?: number | undefined;
    keyTotalAssetsIncludingShareholderLoan?: number | undefined;
    keyShareCapital?: number | undefined;
    keyPremiumFund?: number | undefined;
    keyOtherEquity?: number | undefined;
    keyProfitThisYear?: number | undefined;
    keyTotalEquity?: number | undefined;
    lYNetCurrency?: number | undefined;
    yTDNetCurrency?: number | undefined;
    lYOtherFinItems?: number | undefined;
    yTDOtherFinItems?: number | undefined;
    yTDIntangibleassets?: number | undefined;
    yTDTangibleassets?: number | undefined;
    yTDReceivables?: number | undefined;
    yTDReceivablesgroupcompanies?: number | undefined;
    yTDInvestmentsbaseinvested?: number | undefined;
    yTDInvestmentsakkumulatedperformance?: number | undefined;
    yTDDeposits?: number | undefined;
    yTDTotalassets?: number | undefined;
    yTDPaidequity?: number | undefined;
    yTDRetainedearnings?: number | undefined;
    yTDresult?: number | undefined;
    yTDTotalequity?: number | undefined;
    yTDLiabilities?: number | undefined;
    yTDLiabilitiesgroupcompanies?: number | undefined;
    yTDTotalequityandliabilities?: number | undefined;
    yTDTotalliabilities?: number | undefined;
    yTDOperatingIncome?: number | undefined;
    yTDPersonellExpenses?: number | undefined;
    yTDOtherOperatingExpenses?: number | undefined;
    yTDOperatingProfit?: number | undefined;
    yTDNetInterest?: number | undefined;
    yTDNetSoldSecurities?: number | undefined;
    yTDDividend?: number | undefined;
    yTDInterestCost?: number | undefined;
    yTDLossSoldSecurities?: number | undefined;
    yTDChangeInValueYtd?: number | undefined;
    yTDNetFinancialItems?: number | undefined;
    yTDNetIncomeBeforeTax?: number | undefined;
    lYIntangibleassets?: number | undefined;
    lYTangibleassets?: number | undefined;
    lYReceivables?: number | undefined;
    lYReceivablesgroupcompanies?: number | undefined;
    lYInvestmentsbaseinvested?: number | undefined;
    lYInvestmentsakkumulatedperformance?: number | undefined;
    lYDeposits?: number | undefined;
    lYTotalassets?: number | undefined;
    lYPaidequity?: number | undefined;
    lYRetainedearnings?: number | undefined;
    lYResult?: number | undefined;
    lYTotalequity?: number | undefined;
    lYLiabilities?: number | undefined;
    lYLiabilitiesgroupcompanies?: number | undefined;
    lYTotalequityandliabilities?: number | undefined;
    lYTotalliabilities?: number | undefined;
    lYOperatingIncome?: number | undefined;
    lYPersonellExpenses?: number | undefined;
    lYOtherOperatingExpenses?: number | undefined;
    lYOperatingProfit?: number | undefined;
    lYNetInterest?: number | undefined;
    lYNetSoldSecurities?: number | undefined;
    lYDividend?: number | undefined;
    lYInterestCost?: number | undefined;
    lYLossSoldSecurities?: number | undefined;
    lYChangeInValueYtd?: number | undefined;
    lYNetFinancialItems?: number | undefined;
    lYNetIncomeBeforeTax?: number | undefined;
    lYReportDate?: string | undefined;
    yTDReportDate?: string | undefined;
}

export class AgGridResponseOfPriceViewModel implements IAgGridResponseOfPriceViewModel {
    rowData?: PriceViewModel[];
    rowCount?: number;

    constructor(data?: IAgGridResponseOfPriceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["RowData"])) {
                this.rowData = [] as any;
                for (let item of _data["RowData"])
                    this.rowData!.push(PriceViewModel.fromJS(item));
            }
            this.rowCount = _data["RowCount"];
        }
    }

    static fromJS(data: any): AgGridResponseOfPriceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AgGridResponseOfPriceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rowData)) {
            data["RowData"] = [];
            for (let item of this.rowData)
                data["RowData"].push(item ? item.toJSON() : undefined as any);
        }
        data["RowCount"] = this.rowCount;
        return data;
    }
}

export interface IAgGridResponseOfPriceViewModel {
    rowData?: PriceViewModel[];
    rowCount?: number;
}

export class PriceViewModel implements IPriceViewModel {
    id?: number;
    symbol?: string | undefined;
    sellPrice?: number | undefined;
    fromDate?: string | undefined;
    toDate?: string | undefined;
    sellPriceAdjusted?: number;

    constructor(data?: IPriceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.symbol = _data["Symbol"];
            this.sellPrice = _data["SellPrice"];
            this.fromDate = _data["FromDate"];
            this.toDate = _data["ToDate"];
            this.sellPriceAdjusted = _data["SellPriceAdjusted"];
        }
    }

    static fromJS(data: any): PriceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PriceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Symbol"] = this.symbol;
        data["SellPrice"] = this.sellPrice;
        data["FromDate"] = this.fromDate;
        data["ToDate"] = this.toDate;
        data["SellPriceAdjusted"] = this.sellPriceAdjusted;
        return data;
    }
}

export interface IPriceViewModel {
    id?: number;
    symbol?: string | undefined;
    sellPrice?: number | undefined;
    fromDate?: string | undefined;
    toDate?: string | undefined;
    sellPriceAdjusted?: number;
}

export class AgGridPageRequest implements IAgGridPageRequest {
    startRow?: number;
    endRow?: number;
    sortModel?: AgGridSortModel[];
    filterModel?: { [key: string]: AgGridFilterModel; };

    constructor(data?: IAgGridPageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startRow = _data["StartRow"];
            this.endRow = _data["EndRow"];
            if (Array.isArray(_data["SortModel"])) {
                this.sortModel = [] as any;
                for (let item of _data["SortModel"])
                    this.sortModel!.push(AgGridSortModel.fromJS(item));
            }
            if (_data["FilterModel"]) {
                this.filterModel = {} as any;
                for (let key in _data["FilterModel"]) {
                    if (_data["FilterModel"].hasOwnProperty(key))
                        (this.filterModel as any)![key] = _data["FilterModel"][key] ? AgGridFilterModel.fromJS(_data["FilterModel"][key]) : new AgGridFilterModel();
                }
            }
        }
    }

    static fromJS(data: any): AgGridPageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AgGridPageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StartRow"] = this.startRow;
        data["EndRow"] = this.endRow;
        if (Array.isArray(this.sortModel)) {
            data["SortModel"] = [];
            for (let item of this.sortModel)
                data["SortModel"].push(item ? item.toJSON() : undefined as any);
        }
        if (this.filterModel) {
            data["FilterModel"] = {};
            for (let key in this.filterModel) {
                if (this.filterModel.hasOwnProperty(key))
                    (data["FilterModel"] as any)[key] = this.filterModel[key] ? this.filterModel[key].toJSON() : undefined as any;
            }
        }
        return data;
    }
}

export interface IAgGridPageRequest {
    startRow?: number;
    endRow?: number;
    sortModel?: AgGridSortModel[];
    filterModel?: { [key: string]: AgGridFilterModel; };
}

export class AgGridSortModel implements IAgGridSortModel {
    colId?: string;
    sort?: string;

    constructor(data?: IAgGridSortModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.colId = _data["ColId"];
            this.sort = _data["Sort"];
        }
    }

    static fromJS(data: any): AgGridSortModel {
        data = typeof data === 'object' ? data : {};
        let result = new AgGridSortModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ColId"] = this.colId;
        data["Sort"] = this.sort;
        return data;
    }
}

export interface IAgGridSortModel {
    colId?: string;
    sort?: string;
}

export class AgGridFilterModel implements IAgGridFilterModel {
    filterType?: string;
    filter?: string;
    type?: string;
    dateTo?: string;
    dateFrom?: string;
    values?: string[];

    constructor(data?: IAgGridFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterType = _data["FilterType"];
            this.filter = _data["Filter"];
            this.type = _data["Type"];
            this.dateTo = _data["DateTo"];
            this.dateFrom = _data["DateFrom"];
            if (Array.isArray(_data["Values"])) {
                this.values = [] as any;
                for (let item of _data["Values"])
                    this.values!.push(item);
            }
        }
    }

    static fromJS(data: any): AgGridFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new AgGridFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FilterType"] = this.filterType;
        data["Filter"] = this.filter;
        data["Type"] = this.type;
        data["DateTo"] = this.dateTo;
        data["DateFrom"] = this.dateFrom;
        if (Array.isArray(this.values)) {
            data["Values"] = [];
            for (let item of this.values)
                data["Values"].push(item);
        }
        return data;
    }
}

export interface IAgGridFilterModel {
    filterType?: string;
    filter?: string;
    type?: string;
    dateTo?: string;
    dateFrom?: string;
    values?: string[];
}

export class InstrumentForecastViewModel implements IInstrumentForecastViewModel {
    id?: number;
    instrumentId?: number;
    instrumentUuid?: string;
    oneWeekBankEstimate?: number;
    oneMonthBankEstimate?: number;
    sixMonthsBankEstimate?: number;
    oneYearBankEstimate?: number;
    moreThanOneYearBankEstimate?: number;
    yearlyDividendEstimate?: number;

    constructor(data?: IInstrumentForecastViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.instrumentId = _data["InstrumentId"];
            this.instrumentUuid = _data["InstrumentUuid"];
            this.oneWeekBankEstimate = _data["OneWeekBankEstimate"];
            this.oneMonthBankEstimate = _data["OneMonthBankEstimate"];
            this.sixMonthsBankEstimate = _data["SixMonthsBankEstimate"];
            this.oneYearBankEstimate = _data["OneYearBankEstimate"];
            this.moreThanOneYearBankEstimate = _data["MoreThanOneYearBankEstimate"];
            this.yearlyDividendEstimate = _data["YearlyDividendEstimate"];
        }
    }

    static fromJS(data: any): InstrumentForecastViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentForecastViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["InstrumentId"] = this.instrumentId;
        data["InstrumentUuid"] = this.instrumentUuid;
        data["OneWeekBankEstimate"] = this.oneWeekBankEstimate;
        data["OneMonthBankEstimate"] = this.oneMonthBankEstimate;
        data["SixMonthsBankEstimate"] = this.sixMonthsBankEstimate;
        data["OneYearBankEstimate"] = this.oneYearBankEstimate;
        data["MoreThanOneYearBankEstimate"] = this.moreThanOneYearBankEstimate;
        data["YearlyDividendEstimate"] = this.yearlyDividendEstimate;
        return data;
    }
}

export interface IInstrumentForecastViewModel {
    id?: number;
    instrumentId?: number;
    instrumentUuid?: string;
    oneWeekBankEstimate?: number;
    oneMonthBankEstimate?: number;
    sixMonthsBankEstimate?: number;
    oneYearBankEstimate?: number;
    moreThanOneYearBankEstimate?: number;
    yearlyDividendEstimate?: number;
}

export class InstrumentWithValuesViewModel implements IInstrumentWithValuesViewModel {
    id?: number | undefined;
    uuid?: string | undefined;
    isin?: string | undefined;
    ticker?: string | undefined;
    name?: string | undefined;
    portfolio?: string | undefined;
    reportName?: string | undefined;
    quantity?: number | undefined;
    noted?: boolean | undefined;
    taxable?: boolean | undefined;
    divideByFactor?: number | undefined;
    category?: string | undefined;
    sellPrice?: number | undefined;
    purchasedInterest?: boolean | undefined;
    securitiesTypeName?: string | undefined;
    categories?: CategoryViewModel[] | undefined;
    longTerm?: boolean | undefined;
    lowerOfCostOrMarket?: boolean | undefined;
    companyId?: number | undefined;
    customerName?: string | undefined;
    totalCostPrice?: number | undefined;
    showAll?: boolean | undefined;
    currencyCode?: string | undefined;
    tickerPrefix?: string | undefined;
    existingPortfolio?: boolean | undefined;
    tickerWithPrefix?: string | undefined;
    securitiesTypeId?: InstrumentType | undefined;
    autoPriceStatus?: number | undefined;
    estimatedValue?: number | undefined;
    grossMargin?: number | undefined;
    unitCostPrice?: number | undefined;
    averageCostPrice?: number | undefined;
    averageCostPriceInCurrency?: number | undefined;
    lastImportedPriceDate?: string | undefined;
    lastImportedPrice?: number | undefined;
    manualPrice?: number | undefined;
    lastManualPrice?: number | undefined;
    lastManualPriceDate?: string | undefined;
    mergeOrSplitFactor?: number | undefined;
    feedDescription?: string | undefined;
    lookupAvailableInstrumentId?: string | undefined;
    availableinstrumentId?: number | undefined;
    sortOrder?: number | undefined;
    orgNr?: string | undefined;
    mathSellPrice?: number | undefined;
    comment?: string | undefined;
    accountingValue?: number | undefined;
    availableInstrumentBelongsToCompany?: boolean;
    taxValue?: number | undefined;
    lastTaxValueDate?: string | undefined;
    instrumentLoanQuantity?: number;
    lastImportedCurrencyRate?: number | undefined;
    lastImportedCurrencyDate?: string | undefined;
    dimension1?: string | undefined;
    dimension2?: string | undefined;
    dimension3?: string | undefined;
    dimension4?: string | undefined;
    dimension5?: string | undefined;
    sellPriceType?: string | undefined;
    dimension6?: string | undefined;
    dimension7?: string | undefined;
    dimension10?: string | undefined;
    dimension11?: string | undefined;
    dimension12?: string | undefined;
    dimension13?: string | undefined;
    dimension14?: string | undefined;
    dimension20?: string | undefined;
    dimension21?: string | undefined;
    dimension22?: string | undefined;
    dimension23?: string | undefined;
    dimension24?: string | undefined;
    dimension25?: string | undefined;
    dimension26?: string | undefined;
    dimension27?: string | undefined;
    dimension28?: string | undefined;
    dimension50?: string | undefined;
    dimension51?: string | undefined;
    dimension52?: string | undefined;
    dimension53?: string | undefined;
    instrumentId?: number | undefined;
    dimension1Name?: string | undefined;
    unrealized?: number | undefined;
    realized?: number | undefined;
    interest?: number | undefined;
    dividend?: number | undefined;
    unrealizedYearToDate?: number | undefined;
    realizedYearToDate?: number | undefined;
    dividendYearToDate?: number | undefined;
    interestYearToDate?: number | undefined;
    unrealizedLastYear?: number | undefined;
    realizedLastYear?: number | undefined;
    dividendLastYear?: number | undefined;
    interestLastYear?: number | undefined;
    quantityLastYear?: number | undefined;
    unrealizedLastWeek?: number | undefined;
    realizedLastWeek?: number | undefined;
    dividendLastWeek?: number | undefined;
    interestLastWeek?: number | undefined;
    quantityLastWeek?: number | undefined;
    unrealizedLastMonth?: number | undefined;
    realizedLastMonth?: number | undefined;
    dividendLastMonth?: number | undefined;
    interestLastMonth?: number | undefined;
    quantityLastMonth?: number | undefined;
    profitYearToLastMonth?: number | undefined;
    profitYearToLastWeek?: number | undefined;
    changeInUnrealizedMonthOverMonth?: number | undefined;
    changeInRealizedMonthOverMonth?: number | undefined;
    changeInDividendMonthOverMonth?: number | undefined;
    changeInInterestMonthOverMonth?: number | undefined;
    changeInQuantityMonthOverMonth?: number | undefined;
    changeInValueMonthOverMonth?: number | undefined;
    changeInValueWeekOverWeek?: number | undefined;
    changeInProfitMonthOverMonth?: number | undefined;
    changeInProfitWeekOverWeek?: number | undefined;
    changeInValueMonthOverMonthInPercent?: number | undefined;
    changeInValueWeekOverWeekInPercent?: number | undefined;
    changeInProfitMonthOverMonthInPercent?: number | undefined;
    changeInProfitWeekOverWeekInPercent?: number | undefined;
    estimatedValueLastMonth?: number | undefined;
    estimatedValueLastWeek?: number | undefined;
    estimatedValueInPercent?: number | undefined;
    profitLossYearToDateInPercent?: number | undefined;
    costPriceYearToDate?: number | undefined;
    costPriceLastYear?: number | undefined;
    realizedCostReduction?: number | undefined;
    realizedCostReductionLastYear?: number | undefined;
    realizedCostReductionYearToDate?: number | undefined;
    estimatedValueLastYear?: number | undefined;
    countryCode?: string | undefined;
    lastPriceUpdateSuccess?: string | undefined;
    sellPriceCcy?: string | undefined;
    currency?: CurrencyCodeViewModel | undefined;
    avgUnitCostPrice?: number | undefined;
    avgCostPrice?: number | undefined;
    avgUnrealized?: number | undefined;
    avgAccountingValue?: number | undefined;
    unrealizedAccountingValue?: number | undefined;
    avgUnrealizedAccountingValue?: number | undefined;
    profitLoss?: number | undefined;
    profitLossYearToDate?: number | undefined;
    availableInstrumentUuid?: string;

    constructor(data?: IInstrumentWithValuesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.uuid = _data["Uuid"];
            this.isin = _data["Isin"];
            this.ticker = _data["Ticker"];
            this.name = _data["Name"];
            this.portfolio = _data["Portfolio"];
            this.reportName = _data["ReportName"];
            this.quantity = _data["Quantity"];
            this.noted = _data["Noted"];
            this.taxable = _data["Taxable"];
            this.divideByFactor = _data["DivideByFactor"];
            this.category = _data["Category"];
            this.sellPrice = _data["SellPrice"];
            this.purchasedInterest = _data["PurchasedInterest"];
            this.securitiesTypeName = _data["SecuritiesTypeName"];
            if (Array.isArray(_data["Categories"])) {
                this.categories = [] as any;
                for (let item of _data["Categories"])
                    this.categories!.push(CategoryViewModel.fromJS(item));
            }
            this.longTerm = _data["LongTerm"];
            this.lowerOfCostOrMarket = _data["LowerOfCostOrMarket"];
            this.companyId = _data["CompanyId"];
            this.customerName = _data["CustomerName"];
            this.totalCostPrice = _data["TotalCostPrice"];
            this.showAll = _data["ShowAll"];
            this.currencyCode = _data["CurrencyCode"];
            this.tickerPrefix = _data["TickerPrefix"];
            this.existingPortfolio = _data["ExistingPortfolio"];
            this.tickerWithPrefix = _data["TickerWithPrefix"];
            this.securitiesTypeId = _data["SecuritiesTypeId"];
            this.autoPriceStatus = _data["AutoPriceStatus"];
            this.estimatedValue = _data["EstimatedValue"];
            this.grossMargin = _data["GrossMargin"];
            this.unitCostPrice = _data["UnitCostPrice"];
            this.averageCostPrice = _data["AverageCostPrice"];
            this.averageCostPriceInCurrency = _data["AverageCostPriceInCurrency"];
            this.lastImportedPriceDate = _data["LastImportedPriceDate"];
            this.lastImportedPrice = _data["LastImportedPrice"];
            this.manualPrice = _data["ManualPrice"];
            this.lastManualPrice = _data["LastManualPrice"];
            this.lastManualPriceDate = _data["LastManualPriceDate"];
            this.mergeOrSplitFactor = _data["MergeOrSplitFactor"];
            this.feedDescription = _data["FeedDescription"];
            this.lookupAvailableInstrumentId = _data["LookupAvailableInstrumentId"];
            this.availableinstrumentId = _data["AvailableinstrumentId"];
            this.sortOrder = _data["SortOrder"];
            this.orgNr = _data["OrgNr"];
            this.mathSellPrice = _data["MathSellPrice"];
            this.comment = _data["Comment"];
            this.accountingValue = _data["AccountingValue"];
            this.availableInstrumentBelongsToCompany = _data["AvailableInstrumentBelongsToCompany"];
            this.taxValue = _data["TaxValue"];
            this.lastTaxValueDate = _data["LastTaxValueDate"];
            this.instrumentLoanQuantity = _data["InstrumentLoanQuantity"];
            this.lastImportedCurrencyRate = _data["LastImportedCurrencyRate"];
            this.lastImportedCurrencyDate = _data["LastImportedCurrencyDate"];
            this.dimension1 = _data["Dimension1"];
            this.dimension2 = _data["Dimension2"];
            this.dimension3 = _data["Dimension3"];
            this.dimension4 = _data["Dimension4"];
            this.dimension5 = _data["Dimension5"];
            this.sellPriceType = _data["SellPriceType"];
            this.dimension6 = _data["Dimension6"];
            this.dimension7 = _data["Dimension7"];
            this.dimension10 = _data["Dimension10"];
            this.dimension11 = _data["Dimension11"];
            this.dimension12 = _data["Dimension12"];
            this.dimension13 = _data["Dimension13"];
            this.dimension14 = _data["Dimension14"];
            this.dimension20 = _data["Dimension20"];
            this.dimension21 = _data["Dimension21"];
            this.dimension22 = _data["Dimension22"];
            this.dimension23 = _data["Dimension23"];
            this.dimension24 = _data["Dimension24"];
            this.dimension25 = _data["Dimension25"];
            this.dimension26 = _data["Dimension26"];
            this.dimension27 = _data["Dimension27"];
            this.dimension28 = _data["Dimension28"];
            this.dimension50 = _data["Dimension50"];
            this.dimension51 = _data["Dimension51"];
            this.dimension52 = _data["Dimension52"];
            this.dimension53 = _data["Dimension53"];
            this.instrumentId = _data["InstrumentId"];
            this.dimension1Name = _data["Dimension1Name"];
            this.unrealized = _data["Unrealized"];
            this.realized = _data["Realized"];
            this.interest = _data["Interest"];
            this.dividend = _data["Dividend"];
            this.unrealizedYearToDate = _data["UnrealizedYearToDate"];
            this.realizedYearToDate = _data["RealizedYearToDate"];
            this.dividendYearToDate = _data["DividendYearToDate"];
            this.interestYearToDate = _data["InterestYearToDate"];
            this.unrealizedLastYear = _data["UnrealizedLastYear"];
            this.realizedLastYear = _data["RealizedLastYear"];
            this.dividendLastYear = _data["DividendLastYear"];
            this.interestLastYear = _data["InterestLastYear"];
            this.quantityLastYear = _data["QuantityLastYear"];
            this.unrealizedLastWeek = _data["UnrealizedLastWeek"];
            this.realizedLastWeek = _data["RealizedLastWeek"];
            this.dividendLastWeek = _data["DividendLastWeek"];
            this.interestLastWeek = _data["InterestLastWeek"];
            this.quantityLastWeek = _data["QuantityLastWeek"];
            this.unrealizedLastMonth = _data["UnrealizedLastMonth"];
            this.realizedLastMonth = _data["RealizedLastMonth"];
            this.dividendLastMonth = _data["DividendLastMonth"];
            this.interestLastMonth = _data["InterestLastMonth"];
            this.quantityLastMonth = _data["QuantityLastMonth"];
            this.profitYearToLastMonth = _data["ProfitYearToLastMonth"];
            this.profitYearToLastWeek = _data["ProfitYearToLastWeek"];
            this.changeInUnrealizedMonthOverMonth = _data["ChangeInUnrealizedMonthOverMonth"];
            this.changeInRealizedMonthOverMonth = _data["ChangeInRealizedMonthOverMonth"];
            this.changeInDividendMonthOverMonth = _data["ChangeInDividendMonthOverMonth"];
            this.changeInInterestMonthOverMonth = _data["ChangeInInterestMonthOverMonth"];
            this.changeInQuantityMonthOverMonth = _data["ChangeInQuantityMonthOverMonth"];
            this.changeInValueMonthOverMonth = _data["ChangeInValueMonthOverMonth"];
            this.changeInValueWeekOverWeek = _data["ChangeInValueWeekOverWeek"];
            this.changeInProfitMonthOverMonth = _data["ChangeInProfitMonthOverMonth"];
            this.changeInProfitWeekOverWeek = _data["ChangeInProfitWeekOverWeek"];
            this.changeInValueMonthOverMonthInPercent = _data["ChangeInValueMonthOverMonthInPercent"];
            this.changeInValueWeekOverWeekInPercent = _data["ChangeInValueWeekOverWeekInPercent"];
            this.changeInProfitMonthOverMonthInPercent = _data["ChangeInProfitMonthOverMonthInPercent"];
            this.changeInProfitWeekOverWeekInPercent = _data["ChangeInProfitWeekOverWeekInPercent"];
            this.estimatedValueLastMonth = _data["EstimatedValueLastMonth"];
            this.estimatedValueLastWeek = _data["EstimatedValueLastWeek"];
            this.estimatedValueInPercent = _data["EstimatedValueInPercent"];
            this.profitLossYearToDateInPercent = _data["ProfitLossYearToDateInPercent"];
            this.costPriceYearToDate = _data["CostPriceYearToDate"];
            this.costPriceLastYear = _data["CostPriceLastYear"];
            this.realizedCostReduction = _data["RealizedCostReduction"];
            this.realizedCostReductionLastYear = _data["RealizedCostReductionLastYear"];
            this.realizedCostReductionYearToDate = _data["RealizedCostReductionYearToDate"];
            this.estimatedValueLastYear = _data["EstimatedValueLastYear"];
            this.countryCode = _data["CountryCode"];
            this.lastPriceUpdateSuccess = _data["LastPriceUpdateSuccess"];
            this.sellPriceCcy = _data["SellPriceCcy"];
            this.currency = _data["Currency"] ? CurrencyCodeViewModel.fromJS(_data["Currency"]) : undefined as any;
            this.avgUnitCostPrice = _data["AvgUnitCostPrice"];
            this.avgCostPrice = _data["AvgCostPrice"];
            this.avgUnrealized = _data["AvgUnrealized"];
            this.avgAccountingValue = _data["AvgAccountingValue"];
            this.unrealizedAccountingValue = _data["UnrealizedAccountingValue"];
            this.avgUnrealizedAccountingValue = _data["AvgUnrealizedAccountingValue"];
            this.profitLoss = _data["ProfitLoss"];
            this.profitLossYearToDate = _data["ProfitLossYearToDate"];
            this.availableInstrumentUuid = _data["AvailableInstrumentUuid"];
        }
    }

    static fromJS(data: any): InstrumentWithValuesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentWithValuesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Uuid"] = this.uuid;
        data["Isin"] = this.isin;
        data["Ticker"] = this.ticker;
        data["Name"] = this.name;
        data["Portfolio"] = this.portfolio;
        data["ReportName"] = this.reportName;
        data["Quantity"] = this.quantity;
        data["Noted"] = this.noted;
        data["Taxable"] = this.taxable;
        data["DivideByFactor"] = this.divideByFactor;
        data["Category"] = this.category;
        data["SellPrice"] = this.sellPrice;
        data["PurchasedInterest"] = this.purchasedInterest;
        data["SecuritiesTypeName"] = this.securitiesTypeName;
        if (Array.isArray(this.categories)) {
            data["Categories"] = [];
            for (let item of this.categories)
                data["Categories"].push(item ? item.toJSON() : undefined as any);
        }
        data["LongTerm"] = this.longTerm;
        data["LowerOfCostOrMarket"] = this.lowerOfCostOrMarket;
        data["CompanyId"] = this.companyId;
        data["CustomerName"] = this.customerName;
        data["TotalCostPrice"] = this.totalCostPrice;
        data["ShowAll"] = this.showAll;
        data["CurrencyCode"] = this.currencyCode;
        data["TickerPrefix"] = this.tickerPrefix;
        data["ExistingPortfolio"] = this.existingPortfolio;
        data["TickerWithPrefix"] = this.tickerWithPrefix;
        data["SecuritiesTypeId"] = this.securitiesTypeId;
        data["AutoPriceStatus"] = this.autoPriceStatus;
        data["EstimatedValue"] = this.estimatedValue;
        data["GrossMargin"] = this.grossMargin;
        data["UnitCostPrice"] = this.unitCostPrice;
        data["AverageCostPrice"] = this.averageCostPrice;
        data["AverageCostPriceInCurrency"] = this.averageCostPriceInCurrency;
        data["LastImportedPriceDate"] = this.lastImportedPriceDate;
        data["LastImportedPrice"] = this.lastImportedPrice;
        data["ManualPrice"] = this.manualPrice;
        data["LastManualPrice"] = this.lastManualPrice;
        data["LastManualPriceDate"] = this.lastManualPriceDate;
        data["MergeOrSplitFactor"] = this.mergeOrSplitFactor;
        data["FeedDescription"] = this.feedDescription;
        data["LookupAvailableInstrumentId"] = this.lookupAvailableInstrumentId;
        data["AvailableinstrumentId"] = this.availableinstrumentId;
        data["SortOrder"] = this.sortOrder;
        data["OrgNr"] = this.orgNr;
        data["MathSellPrice"] = this.mathSellPrice;
        data["Comment"] = this.comment;
        data["AccountingValue"] = this.accountingValue;
        data["AvailableInstrumentBelongsToCompany"] = this.availableInstrumentBelongsToCompany;
        data["TaxValue"] = this.taxValue;
        data["LastTaxValueDate"] = this.lastTaxValueDate;
        data["InstrumentLoanQuantity"] = this.instrumentLoanQuantity;
        data["LastImportedCurrencyRate"] = this.lastImportedCurrencyRate;
        data["LastImportedCurrencyDate"] = this.lastImportedCurrencyDate;
        data["Dimension1"] = this.dimension1;
        data["Dimension2"] = this.dimension2;
        data["Dimension3"] = this.dimension3;
        data["Dimension4"] = this.dimension4;
        data["Dimension5"] = this.dimension5;
        data["SellPriceType"] = this.sellPriceType;
        data["Dimension6"] = this.dimension6;
        data["Dimension7"] = this.dimension7;
        data["Dimension10"] = this.dimension10;
        data["Dimension11"] = this.dimension11;
        data["Dimension12"] = this.dimension12;
        data["Dimension13"] = this.dimension13;
        data["Dimension14"] = this.dimension14;
        data["Dimension20"] = this.dimension20;
        data["Dimension21"] = this.dimension21;
        data["Dimension22"] = this.dimension22;
        data["Dimension23"] = this.dimension23;
        data["Dimension24"] = this.dimension24;
        data["Dimension25"] = this.dimension25;
        data["Dimension26"] = this.dimension26;
        data["Dimension27"] = this.dimension27;
        data["Dimension28"] = this.dimension28;
        data["Dimension50"] = this.dimension50;
        data["Dimension51"] = this.dimension51;
        data["Dimension52"] = this.dimension52;
        data["Dimension53"] = this.dimension53;
        data["InstrumentId"] = this.instrumentId;
        data["Dimension1Name"] = this.dimension1Name;
        data["Unrealized"] = this.unrealized;
        data["Realized"] = this.realized;
        data["Interest"] = this.interest;
        data["Dividend"] = this.dividend;
        data["UnrealizedYearToDate"] = this.unrealizedYearToDate;
        data["RealizedYearToDate"] = this.realizedYearToDate;
        data["DividendYearToDate"] = this.dividendYearToDate;
        data["InterestYearToDate"] = this.interestYearToDate;
        data["UnrealizedLastYear"] = this.unrealizedLastYear;
        data["RealizedLastYear"] = this.realizedLastYear;
        data["DividendLastYear"] = this.dividendLastYear;
        data["InterestLastYear"] = this.interestLastYear;
        data["QuantityLastYear"] = this.quantityLastYear;
        data["UnrealizedLastWeek"] = this.unrealizedLastWeek;
        data["RealizedLastWeek"] = this.realizedLastWeek;
        data["DividendLastWeek"] = this.dividendLastWeek;
        data["InterestLastWeek"] = this.interestLastWeek;
        data["QuantityLastWeek"] = this.quantityLastWeek;
        data["UnrealizedLastMonth"] = this.unrealizedLastMonth;
        data["RealizedLastMonth"] = this.realizedLastMonth;
        data["DividendLastMonth"] = this.dividendLastMonth;
        data["InterestLastMonth"] = this.interestLastMonth;
        data["QuantityLastMonth"] = this.quantityLastMonth;
        data["ProfitYearToLastMonth"] = this.profitYearToLastMonth;
        data["ProfitYearToLastWeek"] = this.profitYearToLastWeek;
        data["ChangeInUnrealizedMonthOverMonth"] = this.changeInUnrealizedMonthOverMonth;
        data["ChangeInRealizedMonthOverMonth"] = this.changeInRealizedMonthOverMonth;
        data["ChangeInDividendMonthOverMonth"] = this.changeInDividendMonthOverMonth;
        data["ChangeInInterestMonthOverMonth"] = this.changeInInterestMonthOverMonth;
        data["ChangeInQuantityMonthOverMonth"] = this.changeInQuantityMonthOverMonth;
        data["ChangeInValueMonthOverMonth"] = this.changeInValueMonthOverMonth;
        data["ChangeInValueWeekOverWeek"] = this.changeInValueWeekOverWeek;
        data["ChangeInProfitMonthOverMonth"] = this.changeInProfitMonthOverMonth;
        data["ChangeInProfitWeekOverWeek"] = this.changeInProfitWeekOverWeek;
        data["ChangeInValueMonthOverMonthInPercent"] = this.changeInValueMonthOverMonthInPercent;
        data["ChangeInValueWeekOverWeekInPercent"] = this.changeInValueWeekOverWeekInPercent;
        data["ChangeInProfitMonthOverMonthInPercent"] = this.changeInProfitMonthOverMonthInPercent;
        data["ChangeInProfitWeekOverWeekInPercent"] = this.changeInProfitWeekOverWeekInPercent;
        data["EstimatedValueLastMonth"] = this.estimatedValueLastMonth;
        data["EstimatedValueLastWeek"] = this.estimatedValueLastWeek;
        data["EstimatedValueInPercent"] = this.estimatedValueInPercent;
        data["ProfitLossYearToDateInPercent"] = this.profitLossYearToDateInPercent;
        data["CostPriceYearToDate"] = this.costPriceYearToDate;
        data["CostPriceLastYear"] = this.costPriceLastYear;
        data["RealizedCostReduction"] = this.realizedCostReduction;
        data["RealizedCostReductionLastYear"] = this.realizedCostReductionLastYear;
        data["RealizedCostReductionYearToDate"] = this.realizedCostReductionYearToDate;
        data["EstimatedValueLastYear"] = this.estimatedValueLastYear;
        data["CountryCode"] = this.countryCode;
        data["LastPriceUpdateSuccess"] = this.lastPriceUpdateSuccess;
        data["SellPriceCcy"] = this.sellPriceCcy;
        data["Currency"] = this.currency ? this.currency.toJSON() : undefined as any;
        data["AvgUnitCostPrice"] = this.avgUnitCostPrice;
        data["AvgCostPrice"] = this.avgCostPrice;
        data["AvgUnrealized"] = this.avgUnrealized;
        data["AvgAccountingValue"] = this.avgAccountingValue;
        data["UnrealizedAccountingValue"] = this.unrealizedAccountingValue;
        data["AvgUnrealizedAccountingValue"] = this.avgUnrealizedAccountingValue;
        data["ProfitLoss"] = this.profitLoss;
        data["ProfitLossYearToDate"] = this.profitLossYearToDate;
        data["AvailableInstrumentUuid"] = this.availableInstrumentUuid;
        return data;
    }
}

export interface IInstrumentWithValuesViewModel {
    id?: number | undefined;
    uuid?: string | undefined;
    isin?: string | undefined;
    ticker?: string | undefined;
    name?: string | undefined;
    portfolio?: string | undefined;
    reportName?: string | undefined;
    quantity?: number | undefined;
    noted?: boolean | undefined;
    taxable?: boolean | undefined;
    divideByFactor?: number | undefined;
    category?: string | undefined;
    sellPrice?: number | undefined;
    purchasedInterest?: boolean | undefined;
    securitiesTypeName?: string | undefined;
    categories?: CategoryViewModel[] | undefined;
    longTerm?: boolean | undefined;
    lowerOfCostOrMarket?: boolean | undefined;
    companyId?: number | undefined;
    customerName?: string | undefined;
    totalCostPrice?: number | undefined;
    showAll?: boolean | undefined;
    currencyCode?: string | undefined;
    tickerPrefix?: string | undefined;
    existingPortfolio?: boolean | undefined;
    tickerWithPrefix?: string | undefined;
    securitiesTypeId?: InstrumentType | undefined;
    autoPriceStatus?: number | undefined;
    estimatedValue?: number | undefined;
    grossMargin?: number | undefined;
    unitCostPrice?: number | undefined;
    averageCostPrice?: number | undefined;
    averageCostPriceInCurrency?: number | undefined;
    lastImportedPriceDate?: string | undefined;
    lastImportedPrice?: number | undefined;
    manualPrice?: number | undefined;
    lastManualPrice?: number | undefined;
    lastManualPriceDate?: string | undefined;
    mergeOrSplitFactor?: number | undefined;
    feedDescription?: string | undefined;
    lookupAvailableInstrumentId?: string | undefined;
    availableinstrumentId?: number | undefined;
    sortOrder?: number | undefined;
    orgNr?: string | undefined;
    mathSellPrice?: number | undefined;
    comment?: string | undefined;
    accountingValue?: number | undefined;
    availableInstrumentBelongsToCompany?: boolean;
    taxValue?: number | undefined;
    lastTaxValueDate?: string | undefined;
    instrumentLoanQuantity?: number;
    lastImportedCurrencyRate?: number | undefined;
    lastImportedCurrencyDate?: string | undefined;
    dimension1?: string | undefined;
    dimension2?: string | undefined;
    dimension3?: string | undefined;
    dimension4?: string | undefined;
    dimension5?: string | undefined;
    sellPriceType?: string | undefined;
    dimension6?: string | undefined;
    dimension7?: string | undefined;
    dimension10?: string | undefined;
    dimension11?: string | undefined;
    dimension12?: string | undefined;
    dimension13?: string | undefined;
    dimension14?: string | undefined;
    dimension20?: string | undefined;
    dimension21?: string | undefined;
    dimension22?: string | undefined;
    dimension23?: string | undefined;
    dimension24?: string | undefined;
    dimension25?: string | undefined;
    dimension26?: string | undefined;
    dimension27?: string | undefined;
    dimension28?: string | undefined;
    dimension50?: string | undefined;
    dimension51?: string | undefined;
    dimension52?: string | undefined;
    dimension53?: string | undefined;
    instrumentId?: number | undefined;
    dimension1Name?: string | undefined;
    unrealized?: number | undefined;
    realized?: number | undefined;
    interest?: number | undefined;
    dividend?: number | undefined;
    unrealizedYearToDate?: number | undefined;
    realizedYearToDate?: number | undefined;
    dividendYearToDate?: number | undefined;
    interestYearToDate?: number | undefined;
    unrealizedLastYear?: number | undefined;
    realizedLastYear?: number | undefined;
    dividendLastYear?: number | undefined;
    interestLastYear?: number | undefined;
    quantityLastYear?: number | undefined;
    unrealizedLastWeek?: number | undefined;
    realizedLastWeek?: number | undefined;
    dividendLastWeek?: number | undefined;
    interestLastWeek?: number | undefined;
    quantityLastWeek?: number | undefined;
    unrealizedLastMonth?: number | undefined;
    realizedLastMonth?: number | undefined;
    dividendLastMonth?: number | undefined;
    interestLastMonth?: number | undefined;
    quantityLastMonth?: number | undefined;
    profitYearToLastMonth?: number | undefined;
    profitYearToLastWeek?: number | undefined;
    changeInUnrealizedMonthOverMonth?: number | undefined;
    changeInRealizedMonthOverMonth?: number | undefined;
    changeInDividendMonthOverMonth?: number | undefined;
    changeInInterestMonthOverMonth?: number | undefined;
    changeInQuantityMonthOverMonth?: number | undefined;
    changeInValueMonthOverMonth?: number | undefined;
    changeInValueWeekOverWeek?: number | undefined;
    changeInProfitMonthOverMonth?: number | undefined;
    changeInProfitWeekOverWeek?: number | undefined;
    changeInValueMonthOverMonthInPercent?: number | undefined;
    changeInValueWeekOverWeekInPercent?: number | undefined;
    changeInProfitMonthOverMonthInPercent?: number | undefined;
    changeInProfitWeekOverWeekInPercent?: number | undefined;
    estimatedValueLastMonth?: number | undefined;
    estimatedValueLastWeek?: number | undefined;
    estimatedValueInPercent?: number | undefined;
    profitLossYearToDateInPercent?: number | undefined;
    costPriceYearToDate?: number | undefined;
    costPriceLastYear?: number | undefined;
    realizedCostReduction?: number | undefined;
    realizedCostReductionLastYear?: number | undefined;
    realizedCostReductionYearToDate?: number | undefined;
    estimatedValueLastYear?: number | undefined;
    countryCode?: string | undefined;
    lastPriceUpdateSuccess?: string | undefined;
    sellPriceCcy?: string | undefined;
    currency?: CurrencyCodeViewModel | undefined;
    avgUnitCostPrice?: number | undefined;
    avgCostPrice?: number | undefined;
    avgUnrealized?: number | undefined;
    avgAccountingValue?: number | undefined;
    unrealizedAccountingValue?: number | undefined;
    avgUnrealizedAccountingValue?: number | undefined;
    profitLoss?: number | undefined;
    profitLossYearToDate?: number | undefined;
    availableInstrumentUuid?: string;
}

export class CategoryViewModel implements ICategoryViewModel {
    externalId?: string | undefined;
    id?: number | undefined;
    multipleRowId?: number | undefined;
    name?: string | undefined;
    securitiesCategoryType?: CategoryTypeViewModel | undefined;
    isEditable?: boolean;

    constructor(data?: ICategoryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["ExternalId"];
            this.id = _data["Id"];
            this.multipleRowId = _data["MultipleRowId"];
            this.name = _data["Name"];
            this.securitiesCategoryType = _data["SecuritiesCategoryType"] ? CategoryTypeViewModel.fromJS(_data["SecuritiesCategoryType"]) : undefined as any;
            this.isEditable = _data["IsEditable"];
        }
    }

    static fromJS(data: any): CategoryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ExternalId"] = this.externalId;
        data["Id"] = this.id;
        data["MultipleRowId"] = this.multipleRowId;
        data["Name"] = this.name;
        data["SecuritiesCategoryType"] = this.securitiesCategoryType ? this.securitiesCategoryType.toJSON() : undefined as any;
        data["IsEditable"] = this.isEditable;
        return data;
    }
}

export interface ICategoryViewModel {
    externalId?: string | undefined;
    id?: number | undefined;
    multipleRowId?: number | undefined;
    name?: string | undefined;
    securitiesCategoryType?: CategoryTypeViewModel | undefined;
    isEditable?: boolean;
}

export class CategoryTypeViewModel implements ICategoryTypeViewModel {
    id?: number | undefined;
    name?: string | undefined;
    isSystem?: boolean;

    constructor(data?: ICategoryTypeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.isSystem = _data["IsSystem"];
        }
    }

    static fromJS(data: any): CategoryTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["IsSystem"] = this.isSystem;
        return data;
    }
}

export interface ICategoryTypeViewModel {
    id?: number | undefined;
    name?: string | undefined;
    isSystem?: boolean;
}

export enum InstrumentType {
    StocksNoted = 1,
    EquityCertificate = 2,
    Bonds = 3,
    FixedIncomeFunds = 4,
    Derivatives = 5,
    Stocks = 7,
    Dividend = 8,
    Repayment = 9,
    EquityFunds = 10,
    Currency = 13,
    Bank = 14,
    ETF = 15,
    ETN = 16,
    StocksSubsidiaries = 50,
    StocksAssociatedCompanies = 51,
    Loans = 52,
    LoansSubsidiaries = 53,
    LoansAssociatedCompanies = 54,
    Property = 55,
    OtherAssets = 56,
    Partnership = 57,
    Cfd = 58,
    Etc = 59,
    ShortPosition = 60,
}

export class CurrencyCodeViewModel implements ICurrencyCodeViewModel {
    id?: number | undefined;
    name?: string | undefined;
    operatingMic?: string | undefined;

    constructor(data?: ICurrencyCodeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.operatingMic = _data["OperatingMic"];
        }
    }

    static fromJS(data: any): CurrencyCodeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyCodeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["OperatingMic"] = this.operatingMic;
        return data;
    }
}

export interface ICurrencyCodeViewModel {
    id?: number | undefined;
    name?: string | undefined;
    operatingMic?: string | undefined;
}

export class InstrumentsViewModelOfInstrumentWithValuesViewModel implements IInstrumentsViewModelOfInstrumentWithValuesViewModel {
    rowCount?: number;
    rows?: InstrumentWithValuesViewModel[] | undefined;

    constructor(data?: IInstrumentsViewModelOfInstrumentWithValuesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowCount = _data["RowCount"];
            if (Array.isArray(_data["Rows"])) {
                this.rows = [] as any;
                for (let item of _data["Rows"])
                    this.rows!.push(InstrumentWithValuesViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InstrumentsViewModelOfInstrumentWithValuesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentsViewModelOfInstrumentWithValuesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["RowCount"] = this.rowCount;
        if (Array.isArray(this.rows)) {
            data["Rows"] = [];
            for (let item of this.rows)
                data["Rows"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInstrumentsViewModelOfInstrumentWithValuesViewModel {
    rowCount?: number;
    rows?: InstrumentWithValuesViewModel[] | undefined;
}

export class OverviewRequest implements IOverviewRequest {
    toDate?: string | undefined;
    showAll?: boolean;
    portfolio?: string | undefined;

    constructor(data?: IOverviewRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.toDate = _data["ToDate"];
            this.showAll = _data["ShowAll"];
            this.portfolio = _data["Portfolio"];
        }
    }

    static fromJS(data: any): OverviewRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OverviewRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ToDate"] = this.toDate;
        data["ShowAll"] = this.showAll;
        data["Portfolio"] = this.portfolio;
        return data;
    }
}

export interface IOverviewRequest {
    toDate?: string | undefined;
    showAll?: boolean;
    portfolio?: string | undefined;
}

export class PorfolioReportViewModel implements IPorfolioReportViewModel {
    id?: number | undefined;
    isin?: string | undefined;
    ticker?: string | undefined;
    name?: string | undefined;
    categoryId?: number | undefined;
    categoryName?: string | undefined;
    categoryColor?: string | undefined;
    quantity?: number | undefined;
    estimatedProfitLoss?: number | undefined;
    estimatedValue?: number | undefined;
    costPrice?: number | undefined;
    grossMargin?: number | undefined;

    constructor(data?: IPorfolioReportViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.isin = _data["Isin"];
            this.ticker = _data["Ticker"];
            this.name = _data["Name"];
            this.categoryId = _data["CategoryId"];
            this.categoryName = _data["CategoryName"];
            this.categoryColor = _data["CategoryColor"];
            this.quantity = _data["Quantity"];
            this.estimatedProfitLoss = _data["EstimatedProfitLoss"];
            this.estimatedValue = _data["EstimatedValue"];
            this.costPrice = _data["CostPrice"];
            this.grossMargin = _data["GrossMargin"];
        }
    }

    static fromJS(data: any): PorfolioReportViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PorfolioReportViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Isin"] = this.isin;
        data["Ticker"] = this.ticker;
        data["Name"] = this.name;
        data["CategoryId"] = this.categoryId;
        data["CategoryName"] = this.categoryName;
        data["CategoryColor"] = this.categoryColor;
        data["Quantity"] = this.quantity;
        data["EstimatedProfitLoss"] = this.estimatedProfitLoss;
        data["EstimatedValue"] = this.estimatedValue;
        data["CostPrice"] = this.costPrice;
        data["GrossMargin"] = this.grossMargin;
        return data;
    }
}

export interface IPorfolioReportViewModel {
    id?: number | undefined;
    isin?: string | undefined;
    ticker?: string | undefined;
    name?: string | undefined;
    categoryId?: number | undefined;
    categoryName?: string | undefined;
    categoryColor?: string | undefined;
    quantity?: number | undefined;
    estimatedProfitLoss?: number | undefined;
    estimatedValue?: number | undefined;
    costPrice?: number | undefined;
    grossMargin?: number | undefined;
}

export class SecuritiesPricesChartViewModel implements ISecuritiesPricesChartViewModel {
    imported?: number | undefined;
    manual?: number | undefined;
    date?: string;
    hasManualPriceOnDate?: boolean;
    hasImportedPriceOnDate?: boolean;

    constructor(data?: ISecuritiesPricesChartViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imported = _data["Imported"];
            this.manual = _data["Manual"];
            this.date = _data["Date"];
            this.hasManualPriceOnDate = _data["HasManualPriceOnDate"];
            this.hasImportedPriceOnDate = _data["HasImportedPriceOnDate"];
        }
    }

    static fromJS(data: any): SecuritiesPricesChartViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SecuritiesPricesChartViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Imported"] = this.imported;
        data["Manual"] = this.manual;
        data["Date"] = this.date;
        data["HasManualPriceOnDate"] = this.hasManualPriceOnDate;
        data["HasImportedPriceOnDate"] = this.hasImportedPriceOnDate;
        return data;
    }
}

export interface ISecuritiesPricesChartViewModel {
    imported?: number | undefined;
    manual?: number | undefined;
    date?: string;
    hasManualPriceOnDate?: boolean;
    hasImportedPriceOnDate?: boolean;
}

export class GeneralLedgerReconcileSummaryResponse implements IGeneralLedgerReconcileSummaryResponse {
    code?: number | undefined;
    name?: string;
    accountType?: AccountType;
    incomingBalance?: number | undefined;
    amount?: number | undefined;
    balance?: number | undefined;

    constructor(data?: IGeneralLedgerReconcileSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["Code"];
            this.name = _data["Name"];
            this.accountType = _data["AccountType"];
            this.incomingBalance = _data["IncomingBalance"];
            this.amount = _data["Amount"];
            this.balance = _data["Balance"];
        }
    }

    static fromJS(data: any): GeneralLedgerReconcileSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralLedgerReconcileSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.code;
        data["Name"] = this.name;
        data["AccountType"] = this.accountType;
        data["IncomingBalance"] = this.incomingBalance;
        data["Amount"] = this.amount;
        data["Balance"] = this.balance;
        return data;
    }
}

export interface IGeneralLedgerReconcileSummaryResponse {
    code?: number | undefined;
    name?: string;
    accountType?: AccountType;
    incomingBalance?: number | undefined;
    amount?: number | undefined;
    balance?: number | undefined;
}

export enum AccountType {
    Unknown = 0,
    Bank = 1,
    Securities = 2,
    Profit = 3,
    Loss = 4,
    Dividend = 6,
    Repayment = 7,
    Interest = 8,
    InstrumentLoan = 9,
    WithholdingTax = 10,
    FundSwitch = 11,
}

export class LedgerVoucher implements ILedgerVoucher {
    voucherId?: string;
    transactions?: GlAccountTransaction[];

    constructor(data?: ILedgerVoucher) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.voucherId = _data["VoucherId"];
            if (Array.isArray(_data["Transactions"])) {
                this.transactions = [] as any;
                for (let item of _data["Transactions"])
                    this.transactions!.push(GlAccountTransaction.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LedgerVoucher {
        data = typeof data === 'object' ? data : {};
        let result = new LedgerVoucher();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["VoucherId"] = this.voucherId;
        if (Array.isArray(this.transactions)) {
            data["Transactions"] = [];
            for (let item of this.transactions)
                data["Transactions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILedgerVoucher {
    voucherId?: string;
    transactions?: GlAccountTransaction[];
}

export class ReportCustomerParameter implements IReportCustomerParameter {
    id?: string;
    reportId?: number;
    report?: Report | undefined;
    customerId?: number;
    customer?: Customer | undefined;
    values?: string | undefined;

    constructor(data?: IReportCustomerParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.reportId = _data["ReportId"];
            this.report = _data["Report"] ? Report.fromJS(_data["Report"]) : undefined as any;
            this.customerId = _data["CustomerId"];
            this.customer = _data["Customer"] ? Customer.fromJS(_data["Customer"]) : undefined as any;
            this.values = _data["Values"];
        }
    }

    static fromJS(data: any): ReportCustomerParameter {
        data = typeof data === 'object' ? data : {};
        let result = new ReportCustomerParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ReportId"] = this.reportId;
        data["Report"] = this.report ? this.report.toJSON() : undefined as any;
        data["CustomerId"] = this.customerId;
        data["Customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["Values"] = this.values;
        return data;
    }
}

export interface IReportCustomerParameter {
    id?: string;
    reportId?: number;
    report?: Report | undefined;
    customerId?: number;
    customer?: Customer | undefined;
    values?: string | undefined;
}

export class Report implements IReport {
    id?: number;
    name?: string;
    customerId?: number | undefined;
    customer?: Customer | undefined;
    pages?: ReportReportPage[] | undefined;

    constructor(data?: IReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.customerId = _data["CustomerId"];
            this.customer = _data["Customer"] ? Customer.fromJS(_data["Customer"]) : undefined as any;
            if (Array.isArray(_data["Pages"])) {
                this.pages = [] as any;
                for (let item of _data["Pages"])
                    this.pages!.push(ReportReportPage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Report {
        data = typeof data === 'object' ? data : {};
        let result = new Report();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["CustomerId"] = this.customerId;
        data["Customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        if (Array.isArray(this.pages)) {
            data["Pages"] = [];
            for (let item of this.pages)
                data["Pages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IReport {
    id?: number;
    name?: string;
    customerId?: number | undefined;
    customer?: Customer | undefined;
    pages?: ReportReportPage[] | undefined;
}

export class ReportReportPage implements IReportReportPage {
    id?: number;
    reportId?: number;
    reportPageId?: number;
    reportPage?: ReportPage;
    order?: number;

    constructor(data?: IReportReportPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.reportId = _data["ReportId"];
            this.reportPageId = _data["ReportPageId"];
            this.reportPage = _data["ReportPage"] ? ReportPage.fromJS(_data["ReportPage"]) : undefined as any;
            this.order = _data["Order"];
        }
    }

    static fromJS(data: any): ReportReportPage {
        data = typeof data === 'object' ? data : {};
        let result = new ReportReportPage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ReportId"] = this.reportId;
        data["ReportPageId"] = this.reportPageId;
        data["ReportPage"] = this.reportPage ? this.reportPage.toJSON() : undefined as any;
        data["Order"] = this.order;
        return data;
    }
}

export interface IReportReportPage {
    id?: number;
    reportId?: number;
    reportPageId?: number;
    reportPage?: ReportPage;
    order?: number;
}

export class ReportPage implements IReportPage {
    id?: number;
    name!: string;
    isDashboard?: boolean;
    data?: ReportPageData | undefined;
    customerId?: number | undefined;
    customer?: Customer | undefined;

    constructor(data?: IReportPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.isDashboard = _data["IsDashboard"];
            this.data = _data["Data"] ? ReportPageData.fromJS(_data["Data"]) : undefined as any;
            this.customerId = _data["CustomerId"];
            this.customer = _data["Customer"] ? Customer.fromJS(_data["Customer"]) : undefined as any;
        }
    }

    static fromJS(data: any): ReportPage {
        data = typeof data === 'object' ? data : {};
        let result = new ReportPage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["IsDashboard"] = this.isDashboard;
        data["Data"] = this.data ? this.data.toJSON() : undefined as any;
        data["CustomerId"] = this.customerId;
        data["Customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        return data;
    }
}

export interface IReportPage {
    id?: number;
    name: string;
    isDashboard?: boolean;
    data?: ReportPageData | undefined;
    customerId?: number | undefined;
    customer?: Customer | undefined;
}

export class ReportPageData implements IReportPageData {
    widgets?: ReportPageWidgetData[] | undefined;
    draftWidgets?: ReportPageWidgetData[] | undefined;
    layouts?: ReportPageLayout[] | undefined;

    constructor(data?: IReportPageData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Widgets"])) {
                this.widgets = [] as any;
                for (let item of _data["Widgets"])
                    this.widgets!.push(ReportPageWidgetData.fromJS(item));
            }
            if (Array.isArray(_data["DraftWidgets"])) {
                this.draftWidgets = [] as any;
                for (let item of _data["DraftWidgets"])
                    this.draftWidgets!.push(ReportPageWidgetData.fromJS(item));
            }
            if (Array.isArray(_data["Layouts"])) {
                this.layouts = [] as any;
                for (let item of _data["Layouts"])
                    this.layouts!.push(ReportPageLayout.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportPageData {
        data = typeof data === 'object' ? data : {};
        let result = new ReportPageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.widgets)) {
            data["Widgets"] = [];
            for (let item of this.widgets)
                data["Widgets"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.draftWidgets)) {
            data["DraftWidgets"] = [];
            for (let item of this.draftWidgets)
                data["DraftWidgets"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.layouts)) {
            data["Layouts"] = [];
            for (let item of this.layouts)
                data["Layouts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IReportPageData {
    widgets?: ReportPageWidgetData[] | undefined;
    draftWidgets?: ReportPageWidgetData[] | undefined;
    layouts?: ReportPageLayout[] | undefined;
}

export class ReportPageWidgetData implements IReportPageWidgetData {
    name?: string;
    x?: number;
    y?: number;
    w?: number;
    h?: number;
    config?: any | undefined;

    constructor(data?: IReportPageWidgetData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.x = _data["X"];
            this.y = _data["Y"];
            this.w = _data["W"];
            this.h = _data["H"];
            this.config = _data["Config"];
        }
    }

    static fromJS(data: any): ReportPageWidgetData {
        data = typeof data === 'object' ? data : {};
        let result = new ReportPageWidgetData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["X"] = this.x;
        data["Y"] = this.y;
        data["W"] = this.w;
        data["H"] = this.h;
        data["Config"] = this.config;
        return data;
    }
}

export interface IReportPageWidgetData {
    name?: string;
    x?: number;
    y?: number;
    w?: number;
    h?: number;
    config?: any | undefined;
}

export class ReportPageLayout implements IReportPageLayout {
    deviceType?: ReportPageLayoutDeviceType;
    widgets?: ReportPageWidgetData[] | undefined;

    constructor(data?: IReportPageLayout) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceType = _data["DeviceType"];
            if (Array.isArray(_data["Widgets"])) {
                this.widgets = [] as any;
                for (let item of _data["Widgets"])
                    this.widgets!.push(ReportPageWidgetData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportPageLayout {
        data = typeof data === 'object' ? data : {};
        let result = new ReportPageLayout();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DeviceType"] = this.deviceType;
        if (Array.isArray(this.widgets)) {
            data["Widgets"] = [];
            for (let item of this.widgets)
                data["Widgets"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IReportPageLayout {
    deviceType?: ReportPageLayoutDeviceType;
    widgets?: ReportPageWidgetData[] | undefined;
}

export enum ReportPageLayoutDeviceType {
    Phone = 1,
    Tablet = 2,
    Desktop = 3,
}

export class GroupedTransactionsViewModel implements IGroupedTransactionsViewModel {
    documentMetaId?: number | undefined;
    quantity?: number | undefined;
    dividend?: number | undefined;
    interests?: number | undefined;
    details?: TransactionViewmodel[];
    amount?: number | undefined;
    portfolioName?: string;
    portfolioTicker?: string;
    portfolioId?: number | undefined;
    companyName?: string;
    companyId?: number | undefined;
    lastTransactionDate?: string | undefined;
    lastActionType?: number;
    profit?: number | undefined;
    documentId?: number | undefined;
    legacyRetractable?: boolean;
    hasRetractedTransactions?: boolean;
    created?: string | undefined;
    externalDocumentId?: string | undefined;
    externalRowId?: string | undefined;
    lastDetail?: TransactionsGroupedDetailViewModel;
    groupKey?: string;
    legacySendToGlable?: boolean;
    legacySendToGlableInt?: number;
    canCreateGlTransactions?: boolean;
    canPostGlTransactions?: boolean;
    voucherNr?: string | undefined;
    canRetractTransactions?: boolean;
    actionType?: ActionType | undefined;
    actionTypeName?: string;

    constructor(data?: IGroupedTransactionsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentMetaId = _data["DocumentMetaId"];
            this.quantity = _data["Quantity"];
            this.dividend = _data["Dividend"];
            this.interests = _data["Interests"];
            if (Array.isArray(_data["Details"])) {
                this.details = [] as any;
                for (let item of _data["Details"])
                    this.details!.push(TransactionViewmodel.fromJS(item));
            }
            this.amount = _data["Amount"];
            this.portfolioName = _data["PortfolioName"];
            this.portfolioTicker = _data["PortfolioTicker"];
            this.portfolioId = _data["PortfolioId"];
            this.companyName = _data["CompanyName"];
            this.companyId = _data["CompanyId"];
            this.lastTransactionDate = _data["LastTransactionDate"];
            this.lastActionType = _data["LastActionType"];
            this.profit = _data["Profit"];
            this.documentId = _data["DocumentId"];
            this.legacyRetractable = _data["LegacyRetractable"];
            this.hasRetractedTransactions = _data["HasRetractedTransactions"];
            this.created = _data["Created"];
            this.externalDocumentId = _data["ExternalDocumentId"];
            this.externalRowId = _data["ExternalRowId"];
            this.lastDetail = _data["LastDetail"] ? TransactionsGroupedDetailViewModel.fromJS(_data["LastDetail"]) : undefined as any;
            this.groupKey = _data["GroupKey"];
            this.legacySendToGlable = _data["LegacySendToGlable"];
            this.legacySendToGlableInt = _data["LegacySendToGlableInt"];
            this.canCreateGlTransactions = _data["CanCreateGlTransactions"];
            this.canPostGlTransactions = _data["CanPostGlTransactions"];
            this.voucherNr = _data["VoucherNr"];
            this.canRetractTransactions = _data["CanRetractTransactions"];
            this.actionType = _data["ActionType"];
            this.actionTypeName = _data["ActionTypeName"];
        }
    }

    static fromJS(data: any): GroupedTransactionsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GroupedTransactionsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DocumentMetaId"] = this.documentMetaId;
        data["Quantity"] = this.quantity;
        data["Dividend"] = this.dividend;
        data["Interests"] = this.interests;
        if (Array.isArray(this.details)) {
            data["Details"] = [];
            for (let item of this.details)
                data["Details"].push(item ? item.toJSON() : undefined as any);
        }
        data["Amount"] = this.amount;
        data["PortfolioName"] = this.portfolioName;
        data["PortfolioTicker"] = this.portfolioTicker;
        data["PortfolioId"] = this.portfolioId;
        data["CompanyName"] = this.companyName;
        data["CompanyId"] = this.companyId;
        data["LastTransactionDate"] = this.lastTransactionDate;
        data["LastActionType"] = this.lastActionType;
        data["Profit"] = this.profit;
        data["DocumentId"] = this.documentId;
        data["LegacyRetractable"] = this.legacyRetractable;
        data["HasRetractedTransactions"] = this.hasRetractedTransactions;
        data["Created"] = this.created;
        data["ExternalDocumentId"] = this.externalDocumentId;
        data["ExternalRowId"] = this.externalRowId;
        data["LastDetail"] = this.lastDetail ? this.lastDetail.toJSON() : undefined as any;
        data["GroupKey"] = this.groupKey;
        data["LegacySendToGlable"] = this.legacySendToGlable;
        data["LegacySendToGlableInt"] = this.legacySendToGlableInt;
        data["CanCreateGlTransactions"] = this.canCreateGlTransactions;
        data["CanPostGlTransactions"] = this.canPostGlTransactions;
        data["VoucherNr"] = this.voucherNr;
        data["CanRetractTransactions"] = this.canRetractTransactions;
        data["ActionType"] = this.actionType;
        data["ActionTypeName"] = this.actionTypeName;
        return data;
    }
}

export interface IGroupedTransactionsViewModel {
    documentMetaId?: number | undefined;
    quantity?: number | undefined;
    dividend?: number | undefined;
    interests?: number | undefined;
    details?: TransactionViewmodel[];
    amount?: number | undefined;
    portfolioName?: string;
    portfolioTicker?: string;
    portfolioId?: number | undefined;
    companyName?: string;
    companyId?: number | undefined;
    lastTransactionDate?: string | undefined;
    lastActionType?: number;
    profit?: number | undefined;
    documentId?: number | undefined;
    legacyRetractable?: boolean;
    hasRetractedTransactions?: boolean;
    created?: string | undefined;
    externalDocumentId?: string | undefined;
    externalRowId?: string | undefined;
    lastDetail?: TransactionsGroupedDetailViewModel;
    groupKey?: string;
    legacySendToGlable?: boolean;
    legacySendToGlableInt?: number;
    canCreateGlTransactions?: boolean;
    canPostGlTransactions?: boolean;
    voucherNr?: string | undefined;
    canRetractTransactions?: boolean;
    actionType?: ActionType | undefined;
    actionTypeName?: string;
}

export class TransactionViewmodel implements ITransactionViewmodel {
    id?: number | undefined;
    actionType?: ActionType | undefined;
    name?: string;
    reportName?: string;
    quantity?: number | undefined;
    amount?: number | undefined;
    interests?: number | undefined;
    sellPrice?: number | undefined;
    eventDate?: string | undefined;
    createdBy?: string | undefined;
    voucherNr?: string;
    gLId?: string | undefined;
    fee?: number | undefined;
    broker?: string;
    retractable?: boolean;
    glTransactionStatus?: GlStatus;
    glRetractedStatus?: GlStatus;
    failCount?: number | undefined;
    manualPriceUpdate?: boolean;
    companyName?: string;
    companyId?: number;
    documentMetaId?: number;
    externalGeneralledgerId?: string | undefined;
    retracted?: boolean;
    retractedDate?: string | undefined;
    categories?: CategoryViewModel[];
    instrument?: InstrumentViewModel;
    currencyAmount?: number | undefined;
    created?: string | undefined;
    externalDocumentId?: number | undefined;
    externalRowId?: number | undefined;
    currencyCode?: string | undefined;
    account?: string | undefined;

    constructor(data?: ITransactionViewmodel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.actionType = _data["ActionType"];
            this.name = _data["Name"];
            this.reportName = _data["ReportName"];
            this.quantity = _data["Quantity"];
            this.amount = _data["Amount"];
            this.interests = _data["Interests"];
            this.sellPrice = _data["SellPrice"];
            this.eventDate = _data["EventDate"];
            this.createdBy = _data["CreatedBy"];
            this.voucherNr = _data["VoucherNr"];
            this.gLId = _data["GLId"];
            this.fee = _data["Fee"];
            this.broker = _data["Broker"];
            this.retractable = _data["Retractable"];
            this.glTransactionStatus = _data["GlTransactionStatus"];
            this.glRetractedStatus = _data["GlRetractedStatus"];
            this.failCount = _data["FailCount"];
            this.manualPriceUpdate = _data["ManualPriceUpdate"];
            this.companyName = _data["CompanyName"];
            this.companyId = _data["CompanyId"];
            this.documentMetaId = _data["DocumentMetaId"];
            this.externalGeneralledgerId = _data["ExternalGeneralledgerId"];
            this.retracted = _data["Retracted"];
            this.retractedDate = _data["RetractedDate"];
            if (Array.isArray(_data["Categories"])) {
                this.categories = [] as any;
                for (let item of _data["Categories"])
                    this.categories!.push(CategoryViewModel.fromJS(item));
            }
            this.instrument = _data["Instrument"] ? InstrumentViewModel.fromJS(_data["Instrument"]) : undefined as any;
            this.currencyAmount = _data["CurrencyAmount"];
            this.created = _data["Created"];
            this.externalDocumentId = _data["ExternalDocumentId"];
            this.externalRowId = _data["ExternalRowId"];
            this.currencyCode = _data["CurrencyCode"];
            this.account = _data["Account"];
        }
    }

    static fromJS(data: any): TransactionViewmodel {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionViewmodel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ActionType"] = this.actionType;
        data["Name"] = this.name;
        data["ReportName"] = this.reportName;
        data["Quantity"] = this.quantity;
        data["Amount"] = this.amount;
        data["Interests"] = this.interests;
        data["SellPrice"] = this.sellPrice;
        data["EventDate"] = this.eventDate;
        data["CreatedBy"] = this.createdBy;
        data["VoucherNr"] = this.voucherNr;
        data["GLId"] = this.gLId;
        data["Fee"] = this.fee;
        data["Broker"] = this.broker;
        data["Retractable"] = this.retractable;
        data["GlTransactionStatus"] = this.glTransactionStatus;
        data["GlRetractedStatus"] = this.glRetractedStatus;
        data["FailCount"] = this.failCount;
        data["ManualPriceUpdate"] = this.manualPriceUpdate;
        data["CompanyName"] = this.companyName;
        data["CompanyId"] = this.companyId;
        data["DocumentMetaId"] = this.documentMetaId;
        data["ExternalGeneralledgerId"] = this.externalGeneralledgerId;
        data["Retracted"] = this.retracted;
        data["RetractedDate"] = this.retractedDate;
        if (Array.isArray(this.categories)) {
            data["Categories"] = [];
            for (let item of this.categories)
                data["Categories"].push(item ? item.toJSON() : undefined as any);
        }
        data["Instrument"] = this.instrument ? this.instrument.toJSON() : undefined as any;
        data["CurrencyAmount"] = this.currencyAmount;
        data["Created"] = this.created;
        data["ExternalDocumentId"] = this.externalDocumentId;
        data["ExternalRowId"] = this.externalRowId;
        data["CurrencyCode"] = this.currencyCode;
        data["Account"] = this.account;
        return data;
    }
}

export interface ITransactionViewmodel {
    id?: number | undefined;
    actionType?: ActionType | undefined;
    name?: string;
    reportName?: string;
    quantity?: number | undefined;
    amount?: number | undefined;
    interests?: number | undefined;
    sellPrice?: number | undefined;
    eventDate?: string | undefined;
    createdBy?: string | undefined;
    voucherNr?: string;
    gLId?: string | undefined;
    fee?: number | undefined;
    broker?: string;
    retractable?: boolean;
    glTransactionStatus?: GlStatus;
    glRetractedStatus?: GlStatus;
    failCount?: number | undefined;
    manualPriceUpdate?: boolean;
    companyName?: string;
    companyId?: number;
    documentMetaId?: number;
    externalGeneralledgerId?: string | undefined;
    retracted?: boolean;
    retractedDate?: string | undefined;
    categories?: CategoryViewModel[];
    instrument?: InstrumentViewModel;
    currencyAmount?: number | undefined;
    created?: string | undefined;
    externalDocumentId?: number | undefined;
    externalRowId?: number | undefined;
    currencyCode?: string | undefined;
    account?: string | undefined;
}

export enum ActionType {
    Purchased = 0,
    Sold = 1,
    Profit = 2,
    Loss = 3,
    CostReduction = 4,
    Dividend = 5,
    Repayment = 6,
    RepaymentCostReduction = 7,
    RepaymentCostReductionForSale = 8,
    ReceivedInterest = 9,
    PurchaseInterest = 10,
    SoldInterest = 11,
    CapitalIncrease = 16,
    CapitalIncreaseCostReduction = 17,
    CapitalIncreaseCostReductionForSale = 18,
    SplitOrMerge = 25,
    ShortSale = 30,
    ShortPurchased = 31,
    ShortProfit = 32,
    ShortLoss = 33,
    ShortCostReduction = 34,
    InstrumentLoan = 38,
    AverageProfit = 42,
    AverageLoss = 43,
    AverageCostReduction = 44,
    AverageRepaymentCostReductionForSale = 48,
    AverageShortProfit = 52,
    AverageShortLoss = 53,
    AverageShortCostReduction = 54,
    AverageCapitalIncreaseCostReductionForSale = 58,
    FundSwitchPurchase = 60,
    FundSwitchSale = 61,
    FundSwitchPurchaseInterest = 62,
    FundSwitchSaleInterest = 63,
    WithholdingTax = 65,
    FundClassSwitchPurchase = 70,
    FundClassSwitchSale = 71,
}

export enum GlStatus {
    None = 0,
    Created = 1,
    Sent = 2,
    Posted = 3,
    Queued = 4,
}

export class InstrumentViewModel implements IInstrumentViewModel {
    id?: number | undefined;
    insightInstrumentId?: number;
    uuid?: string | undefined;
    isin?: string | undefined;
    ticker?: string | undefined;
    name?: string | undefined;
    noted?: boolean | undefined;
    taxable?: boolean | undefined;
    longTerm?: boolean | undefined;
    lowerOfCostOrMarket?: boolean | undefined;
    reportingCustomerId?: number | undefined;
    currencyCode?: string | undefined;
    availableInstrumentUuid?: string;
    lastManualPriceDate?: string | undefined;
    comment?: string | undefined;
    accountingValue?: number | undefined;
    instrumentType?: InstrumentType | undefined;
    identityId?: number;
    identityUuId?: string;
    lastTaxValueDate?: string | undefined;

    constructor(data?: IInstrumentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.insightInstrumentId = _data["InsightInstrumentId"];
            this.uuid = _data["Uuid"];
            this.isin = _data["Isin"];
            this.ticker = _data["Ticker"];
            this.name = _data["Name"];
            this.noted = _data["Noted"];
            this.taxable = _data["Taxable"];
            this.longTerm = _data["LongTerm"];
            this.lowerOfCostOrMarket = _data["LowerOfCostOrMarket"];
            this.reportingCustomerId = _data["ReportingCustomerId"];
            this.currencyCode = _data["CurrencyCode"];
            this.availableInstrumentUuid = _data["AvailableInstrumentUuid"];
            this.lastManualPriceDate = _data["LastManualPriceDate"];
            this.comment = _data["Comment"];
            this.accountingValue = _data["AccountingValue"];
            this.instrumentType = _data["InstrumentType"];
            this.identityId = _data["IdentityId"];
            this.identityUuId = _data["IdentityUuId"];
            this.lastTaxValueDate = _data["LastTaxValueDate"];
        }
    }

    static fromJS(data: any): InstrumentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["InsightInstrumentId"] = this.insightInstrumentId;
        data["Uuid"] = this.uuid;
        data["Isin"] = this.isin;
        data["Ticker"] = this.ticker;
        data["Name"] = this.name;
        data["Noted"] = this.noted;
        data["Taxable"] = this.taxable;
        data["LongTerm"] = this.longTerm;
        data["LowerOfCostOrMarket"] = this.lowerOfCostOrMarket;
        data["ReportingCustomerId"] = this.reportingCustomerId;
        data["CurrencyCode"] = this.currencyCode;
        data["AvailableInstrumentUuid"] = this.availableInstrumentUuid;
        data["LastManualPriceDate"] = this.lastManualPriceDate;
        data["Comment"] = this.comment;
        data["AccountingValue"] = this.accountingValue;
        data["InstrumentType"] = this.instrumentType;
        data["IdentityId"] = this.identityId;
        data["IdentityUuId"] = this.identityUuId;
        data["LastTaxValueDate"] = this.lastTaxValueDate;
        return data;
    }
}

export interface IInstrumentViewModel {
    id?: number | undefined;
    insightInstrumentId?: number;
    uuid?: string | undefined;
    isin?: string | undefined;
    ticker?: string | undefined;
    name?: string | undefined;
    noted?: boolean | undefined;
    taxable?: boolean | undefined;
    longTerm?: boolean | undefined;
    lowerOfCostOrMarket?: boolean | undefined;
    reportingCustomerId?: number | undefined;
    currencyCode?: string | undefined;
    availableInstrumentUuid?: string;
    lastManualPriceDate?: string | undefined;
    comment?: string | undefined;
    accountingValue?: number | undefined;
    instrumentType?: InstrumentType | undefined;
    identityId?: number;
    identityUuId?: string;
    lastTaxValueDate?: string | undefined;
}

export class TransactionsGroupedDetailViewModel implements ITransactionsGroupedDetailViewModel {
    ticker?: string | undefined;
    isin?: string | undefined;
    orgNr?: string | undefined;
    instrumentId?: number | undefined;
    lastTransactionDate?: string;
    created?: string | undefined;
    lastActionType?: ActionType | undefined;
    retractable?: boolean;
    name?: string | undefined;
    reportName?: string | undefined;

    constructor(data?: ITransactionsGroupedDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticker = _data["Ticker"];
            this.isin = _data["Isin"];
            this.orgNr = _data["OrgNr"];
            this.instrumentId = _data["InstrumentId"];
            this.lastTransactionDate = _data["LastTransactionDate"];
            this.created = _data["Created"];
            this.lastActionType = _data["LastActionType"];
            this.retractable = _data["Retractable"];
            this.name = _data["Name"];
            this.reportName = _data["ReportName"];
        }
    }

    static fromJS(data: any): TransactionsGroupedDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionsGroupedDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Ticker"] = this.ticker;
        data["Isin"] = this.isin;
        data["OrgNr"] = this.orgNr;
        data["InstrumentId"] = this.instrumentId;
        data["LastTransactionDate"] = this.lastTransactionDate;
        data["Created"] = this.created;
        data["LastActionType"] = this.lastActionType;
        data["Retractable"] = this.retractable;
        data["Name"] = this.name;
        data["ReportName"] = this.reportName;
        return data;
    }
}

export interface ITransactionsGroupedDetailViewModel {
    ticker?: string | undefined;
    isin?: string | undefined;
    orgNr?: string | undefined;
    instrumentId?: number | undefined;
    lastTransactionDate?: string;
    created?: string | undefined;
    lastActionType?: ActionType | undefined;
    retractable?: boolean;
    name?: string | undefined;
    reportName?: string | undefined;
}

export class TransactionCountViewModel implements ITransactionCountViewModel {
    companyIdentityId?: number | undefined;
    transactionCount?: number;
    transactionCountRetracted?: number;
    companyName?: string | undefined;
    instrumentName?: string | undefined;
    transactionCountThisMonth?: number;
    transactionCountThisYear?: number;
    transactionCountLastYear?: number;
    transactionCountThisPeriod?: number;
    transactionCreatedCountThisMonth?: number;
    transactionCreatedCountThisYear?: number;
    transactionCreatedCountThisPeriod?: number;
    lastCreatedTransactionDate?: string | undefined;

    constructor(data?: ITransactionCountViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyIdentityId = _data["CompanyIdentityId"];
            this.transactionCount = _data["TransactionCount"];
            this.transactionCountRetracted = _data["TransactionCountRetracted"];
            this.companyName = _data["CompanyName"];
            this.instrumentName = _data["InstrumentName"];
            this.transactionCountThisMonth = _data["TransactionCountThisMonth"];
            this.transactionCountThisYear = _data["TransactionCountThisYear"];
            this.transactionCountLastYear = _data["TransactionCountLastYear"];
            this.transactionCountThisPeriod = _data["TransactionCountThisPeriod"];
            this.transactionCreatedCountThisMonth = _data["TransactionCreatedCountThisMonth"];
            this.transactionCreatedCountThisYear = _data["TransactionCreatedCountThisYear"];
            this.transactionCreatedCountThisPeriod = _data["TransactionCreatedCountThisPeriod"];
            this.lastCreatedTransactionDate = _data["LastCreatedTransactionDate"];
        }
    }

    static fromJS(data: any): TransactionCountViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionCountViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CompanyIdentityId"] = this.companyIdentityId;
        data["TransactionCount"] = this.transactionCount;
        data["TransactionCountRetracted"] = this.transactionCountRetracted;
        data["CompanyName"] = this.companyName;
        data["InstrumentName"] = this.instrumentName;
        data["TransactionCountThisMonth"] = this.transactionCountThisMonth;
        data["TransactionCountThisYear"] = this.transactionCountThisYear;
        data["TransactionCountLastYear"] = this.transactionCountLastYear;
        data["TransactionCountThisPeriod"] = this.transactionCountThisPeriod;
        data["TransactionCreatedCountThisMonth"] = this.transactionCreatedCountThisMonth;
        data["TransactionCreatedCountThisYear"] = this.transactionCreatedCountThisYear;
        data["TransactionCreatedCountThisPeriod"] = this.transactionCreatedCountThisPeriod;
        data["LastCreatedTransactionDate"] = this.lastCreatedTransactionDate;
        return data;
    }
}

export interface ITransactionCountViewModel {
    companyIdentityId?: number | undefined;
    transactionCount?: number;
    transactionCountRetracted?: number;
    companyName?: string | undefined;
    instrumentName?: string | undefined;
    transactionCountThisMonth?: number;
    transactionCountThisYear?: number;
    transactionCountLastYear?: number;
    transactionCountThisPeriod?: number;
    transactionCreatedCountThisMonth?: number;
    transactionCreatedCountThisYear?: number;
    transactionCreatedCountThisPeriod?: number;
    lastCreatedTransactionDate?: string | undefined;
}

export class InstrumentValuesReportViewModel implements IInstrumentValuesReportViewModel {
    date?: string;
    periodName?: string;
    reportingInstrumentId?: number | undefined;
    instrumentId?: number | undefined;
    availableInstrumentId?: number | undefined;
    name?: string;
    portfolioName?: string;
    reportName?: string;
    customerName?: string;
    instrumentTypeId?: InstrumentType | undefined;
    type?: string;
    category?: string | undefined;
    isin?: string;
    orgNr?: string | undefined;
    ticker?: string | undefined;
    taxable?: boolean | undefined;
    noted?: boolean | undefined;
    longTerm?: boolean | undefined;
    lowerOfCostOrMarket?: boolean | undefined;
    currencyCode?: string | undefined;
    currencyRate?: number | undefined;
    currencyRateDate?: string;
    sellPrice?: number | undefined;
    sellPriceFx?: number;
    sellPriceDate?: string;
    sellPriceCcy?: string | undefined;
    sellPriceNok?: number | undefined;
    sellPriceSource?: string | undefined;
    taxValuePerUnit?: number | undefined;
    costPriceYearToDateAdjusted?: number;
    costPricePeriodAdjusted?: number;
    profitLossChangePeriodInPercent?: number;
    profitLossChangeYearToDateInPercent?: number;
    realizedProfitLossClosingBalance?: number;
    realizedProfitLossEndOfLastYear?: number;
    realizedProfitLossChangeYearToDate?: number;
    realizedProfitLossOpeningBalancePeriod?: number;
    realizedProfitLossChangeInPeriod?: number;
    realizedClosingBalance?: number;
    realizedEndOfLastYear?: number;
    realizedChangeYearToDate?: number;
    realizedOpeningBalancePeriod?: number;
    realizedChangeInPeriod?: number;
    avgRealizedProfitLossClosingBalance?: number;
    avgRealizedProfitLossEndOfLastYear?: number;
    avgRealizedProfitLossChangeYearToDate?: number;
    avgRealizedProfitLossOpeningBalancePeriod?: number;
    avgRealizedProfitLossChangeInPeriod?: number;
    profitLossClosingBalance?: number;
    profitLossEndOfLastYear?: number;
    profitLossChangeYearToDate?: number;
    profitLossOpeningBalancePeriod?: number;
    profitLossChangeInPeriod?: number;
    avgProfitLossClosingBalance?: number;
    avgProfitLossEndOfLastYear?: number;
    avgProfitLossChangeYearToDate?: number;
    avgProfitLossOpeningBalancePeriod?: number;
    avgProfitLossChangeInPeriod?: number;
    unrealizedProfitLossChangeInPeriod?: number;
    unrealizedProfitLossOpeningBalancePeriod?: number;
    unrealizedProfitLossChangeYearToDate?: number;
    unrealizedProfitLossClosingBalance?: number;
    unrealizedProfitLossEndOfLastYear?: number;
    avgUnrealizedProfitLossClosingBalance?: number;
    avgUnrealizedProfitLossEndOfLastYear?: number;
    avgUnrealizedProfitLossChangeYearToDate?: number;
    avgUnrealizedProfitLossOpeningBalancePeriod?: number;
    avgUnrealizedProfitLossChangeInPeriod?: number;
    interestChangeInPeriod?: number;
    interestOpeningBalancePeriod?: number;
    interestChangeYearToDate?: number;
    interestClosingBalance?: number;
    interestEndOfLastYear?: number;
    dividendChangeInPeriod?: number;
    dividendOpeningBalancePeriod?: number;
    dividendChangeYearToDate?: number;
    dividendEndOfLastYear?: number;
    dividendClosingBalance?: number;
    repaymentChangeInPeriod?: number;
    repaymentOpeningBalancePeriod?: number;
    repaymentChangeYearToDate?: number;
    repaymentEndOfLastYear?: number;
    repaymentClosingBalance?: number;
    costOfRealizedChangeInPeriod?: number;
    costOfRealizedOpeningBalancePeriod?: number;
    costOfRealizedChangeYearToDate?: number;
    costOfRealizedEndOfLastYear?: number;
    costOfRealizedClosingBalance?: number;
    costPriceChangeInPeriod?: number;
    costPriceOpeningBalancePeriod?: number;
    costPriceChangeYearToDate?: number;
    costPriceEndOfLastYear?: number;
    costPriceClosingBalance?: number;
    avgCostPriceClosingBalance?: number;
    avgCostPriceEndOfLastYear?: number;
    avgCostPriceChangeYearToDate?: number;
    avgCostPriceOpeningBalancePeriod?: number;
    avgCostPriceChangeInPeriod?: number;
    estimatedValueChangeInPeriod?: number;
    estimatedValueOpeningBalancePeriod?: number;
    estimatedValueChangeYearToDate?: number;
    estimatedValueClosingBalance?: number;
    estimatedValueEndOfLastYear?: number;
    quantityClosingBalance?: number;
    quantityEndOfLastYear?: number;
    quantityChangeYearToDate?: number;
    quantityOpeningBalancePeriod?: number;
    quantityChangeInPeriod?: number;
    costOfAcquiredClosingBalance?: number;
    costOfAcquiredEndOfLastYear?: number;
    costOfAcquiredChangeYearToDate?: number;
    costOfAcquiredOpeningBalancePeriod?: number;
    costOfAcquiredChangeInPeriod?: number;
    withHoldingTaxChangeYearToDate?: number;

    constructor(data?: IInstrumentValuesReportViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["Date"];
            this.periodName = _data["PeriodName"];
            this.reportingInstrumentId = _data["ReportingInstrumentId"];
            this.instrumentId = _data["InstrumentId"];
            this.availableInstrumentId = _data["AvailableInstrumentId"];
            this.name = _data["Name"];
            this.portfolioName = _data["PortfolioName"];
            this.reportName = _data["ReportName"];
            this.customerName = _data["CustomerName"];
            this.instrumentTypeId = _data["InstrumentTypeId"];
            this.type = _data["Type"];
            this.category = _data["Category"];
            this.isin = _data["Isin"];
            this.orgNr = _data["OrgNr"];
            this.ticker = _data["Ticker"];
            this.taxable = _data["Taxable"];
            this.noted = _data["Noted"];
            this.longTerm = _data["LongTerm"];
            this.lowerOfCostOrMarket = _data["LowerOfCostOrMarket"];
            this.currencyCode = _data["CurrencyCode"];
            this.currencyRate = _data["CurrencyRate"];
            this.currencyRateDate = _data["CurrencyRateDate"];
            this.sellPrice = _data["SellPrice"];
            this.sellPriceFx = _data["SellPriceFx"];
            this.sellPriceDate = _data["SellPriceDate"];
            this.sellPriceCcy = _data["SellPriceCcy"];
            this.sellPriceNok = _data["SellPriceNok"];
            this.sellPriceSource = _data["SellPriceSource"];
            this.taxValuePerUnit = _data["TaxValuePerUnit"];
            this.costPriceYearToDateAdjusted = _data["CostPriceYearToDateAdjusted"];
            this.costPricePeriodAdjusted = _data["CostPricePeriodAdjusted"];
            this.profitLossChangePeriodInPercent = _data["ProfitLossChangePeriodInPercent"];
            this.profitLossChangeYearToDateInPercent = _data["ProfitLossChangeYearToDateInPercent"];
            this.realizedProfitLossClosingBalance = _data["RealizedProfitLossClosingBalance"];
            this.realizedProfitLossEndOfLastYear = _data["RealizedProfitLossEndOfLastYear"];
            this.realizedProfitLossChangeYearToDate = _data["RealizedProfitLossChangeYearToDate"];
            this.realizedProfitLossOpeningBalancePeriod = _data["RealizedProfitLossOpeningBalancePeriod"];
            this.realizedProfitLossChangeInPeriod = _data["RealizedProfitLossChangeInPeriod"];
            this.realizedClosingBalance = _data["RealizedClosingBalance"];
            this.realizedEndOfLastYear = _data["RealizedEndOfLastYear"];
            this.realizedChangeYearToDate = _data["RealizedChangeYearToDate"];
            this.realizedOpeningBalancePeriod = _data["RealizedOpeningBalancePeriod"];
            this.realizedChangeInPeriod = _data["RealizedChangeInPeriod"];
            this.avgRealizedProfitLossClosingBalance = _data["AvgRealizedProfitLossClosingBalance"];
            this.avgRealizedProfitLossEndOfLastYear = _data["AvgRealizedProfitLossEndOfLastYear"];
            this.avgRealizedProfitLossChangeYearToDate = _data["AvgRealizedProfitLossChangeYearToDate"];
            this.avgRealizedProfitLossOpeningBalancePeriod = _data["AvgRealizedProfitLossOpeningBalancePeriod"];
            this.avgRealizedProfitLossChangeInPeriod = _data["AvgRealizedProfitLossChangeInPeriod"];
            this.profitLossClosingBalance = _data["ProfitLossClosingBalance"];
            this.profitLossEndOfLastYear = _data["ProfitLossEndOfLastYear"];
            this.profitLossChangeYearToDate = _data["ProfitLossChangeYearToDate"];
            this.profitLossOpeningBalancePeriod = _data["ProfitLossOpeningBalancePeriod"];
            this.profitLossChangeInPeriod = _data["ProfitLossChangeInPeriod"];
            this.avgProfitLossClosingBalance = _data["AvgProfitLossClosingBalance"];
            this.avgProfitLossEndOfLastYear = _data["AvgProfitLossEndOfLastYear"];
            this.avgProfitLossChangeYearToDate = _data["AvgProfitLossChangeYearToDate"];
            this.avgProfitLossOpeningBalancePeriod = _data["AvgProfitLossOpeningBalancePeriod"];
            this.avgProfitLossChangeInPeriod = _data["AvgProfitLossChangeInPeriod"];
            this.unrealizedProfitLossChangeInPeriod = _data["UnrealizedProfitLossChangeInPeriod"];
            this.unrealizedProfitLossOpeningBalancePeriod = _data["UnrealizedProfitLossOpeningBalancePeriod"];
            this.unrealizedProfitLossChangeYearToDate = _data["UnrealizedProfitLossChangeYearToDate"];
            this.unrealizedProfitLossClosingBalance = _data["UnrealizedProfitLossClosingBalance"];
            this.unrealizedProfitLossEndOfLastYear = _data["UnrealizedProfitLossEndOfLastYear"];
            this.avgUnrealizedProfitLossClosingBalance = _data["AvgUnrealizedProfitLossClosingBalance"];
            this.avgUnrealizedProfitLossEndOfLastYear = _data["AvgUnrealizedProfitLossEndOfLastYear"];
            this.avgUnrealizedProfitLossChangeYearToDate = _data["AvgUnrealizedProfitLossChangeYearToDate"];
            this.avgUnrealizedProfitLossOpeningBalancePeriod = _data["AvgUnrealizedProfitLossOpeningBalancePeriod"];
            this.avgUnrealizedProfitLossChangeInPeriod = _data["AvgUnrealizedProfitLossChangeInPeriod"];
            this.interestChangeInPeriod = _data["InterestChangeInPeriod"];
            this.interestOpeningBalancePeriod = _data["InterestOpeningBalancePeriod"];
            this.interestChangeYearToDate = _data["InterestChangeYearToDate"];
            this.interestClosingBalance = _data["InterestClosingBalance"];
            this.interestEndOfLastYear = _data["InterestEndOfLastYear"];
            this.dividendChangeInPeriod = _data["DividendChangeInPeriod"];
            this.dividendOpeningBalancePeriod = _data["DividendOpeningBalancePeriod"];
            this.dividendChangeYearToDate = _data["DividendChangeYearToDate"];
            this.dividendEndOfLastYear = _data["DividendEndOfLastYear"];
            this.dividendClosingBalance = _data["DividendClosingBalance"];
            this.repaymentChangeInPeriod = _data["RepaymentChangeInPeriod"];
            this.repaymentOpeningBalancePeriod = _data["RepaymentOpeningBalancePeriod"];
            this.repaymentChangeYearToDate = _data["RepaymentChangeYearToDate"];
            this.repaymentEndOfLastYear = _data["RepaymentEndOfLastYear"];
            this.repaymentClosingBalance = _data["RepaymentClosingBalance"];
            this.costOfRealizedChangeInPeriod = _data["CostOfRealizedChangeInPeriod"];
            this.costOfRealizedOpeningBalancePeriod = _data["CostOfRealizedOpeningBalancePeriod"];
            this.costOfRealizedChangeYearToDate = _data["CostOfRealizedChangeYearToDate"];
            this.costOfRealizedEndOfLastYear = _data["CostOfRealizedEndOfLastYear"];
            this.costOfRealizedClosingBalance = _data["CostOfRealizedClosingBalance"];
            this.costPriceChangeInPeriod = _data["CostPriceChangeInPeriod"];
            this.costPriceOpeningBalancePeriod = _data["CostPriceOpeningBalancePeriod"];
            this.costPriceChangeYearToDate = _data["CostPriceChangeYearToDate"];
            this.costPriceEndOfLastYear = _data["CostPriceEndOfLastYear"];
            this.costPriceClosingBalance = _data["CostPriceClosingBalance"];
            this.avgCostPriceClosingBalance = _data["AvgCostPriceClosingBalance"];
            this.avgCostPriceEndOfLastYear = _data["AvgCostPriceEndOfLastYear"];
            this.avgCostPriceChangeYearToDate = _data["AvgCostPriceChangeYearToDate"];
            this.avgCostPriceOpeningBalancePeriod = _data["AvgCostPriceOpeningBalancePeriod"];
            this.avgCostPriceChangeInPeriod = _data["AvgCostPriceChangeInPeriod"];
            this.estimatedValueChangeInPeriod = _data["EstimatedValueChangeInPeriod"];
            this.estimatedValueOpeningBalancePeriod = _data["EstimatedValueOpeningBalancePeriod"];
            this.estimatedValueChangeYearToDate = _data["EstimatedValueChangeYearToDate"];
            this.estimatedValueClosingBalance = _data["EstimatedValueClosingBalance"];
            this.estimatedValueEndOfLastYear = _data["EstimatedValueEndOfLastYear"];
            this.quantityClosingBalance = _data["QuantityClosingBalance"];
            this.quantityEndOfLastYear = _data["QuantityEndOfLastYear"];
            this.quantityChangeYearToDate = _data["QuantityChangeYearToDate"];
            this.quantityOpeningBalancePeriod = _data["QuantityOpeningBalancePeriod"];
            this.quantityChangeInPeriod = _data["QuantityChangeInPeriod"];
            this.costOfAcquiredClosingBalance = _data["CostOfAcquiredClosingBalance"];
            this.costOfAcquiredEndOfLastYear = _data["CostOfAcquiredEndOfLastYear"];
            this.costOfAcquiredChangeYearToDate = _data["CostOfAcquiredChangeYearToDate"];
            this.costOfAcquiredOpeningBalancePeriod = _data["CostOfAcquiredOpeningBalancePeriod"];
            this.costOfAcquiredChangeInPeriod = _data["CostOfAcquiredChangeInPeriod"];
            this.withHoldingTaxChangeYearToDate = _data["WithHoldingTaxChangeYearToDate"];
        }
    }

    static fromJS(data: any): InstrumentValuesReportViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentValuesReportViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Date"] = this.date;
        data["PeriodName"] = this.periodName;
        data["ReportingInstrumentId"] = this.reportingInstrumentId;
        data["InstrumentId"] = this.instrumentId;
        data["AvailableInstrumentId"] = this.availableInstrumentId;
        data["Name"] = this.name;
        data["PortfolioName"] = this.portfolioName;
        data["ReportName"] = this.reportName;
        data["CustomerName"] = this.customerName;
        data["InstrumentTypeId"] = this.instrumentTypeId;
        data["Type"] = this.type;
        data["Category"] = this.category;
        data["Isin"] = this.isin;
        data["OrgNr"] = this.orgNr;
        data["Ticker"] = this.ticker;
        data["Taxable"] = this.taxable;
        data["Noted"] = this.noted;
        data["LongTerm"] = this.longTerm;
        data["LowerOfCostOrMarket"] = this.lowerOfCostOrMarket;
        data["CurrencyCode"] = this.currencyCode;
        data["CurrencyRate"] = this.currencyRate;
        data["CurrencyRateDate"] = this.currencyRateDate;
        data["SellPrice"] = this.sellPrice;
        data["SellPriceFx"] = this.sellPriceFx;
        data["SellPriceDate"] = this.sellPriceDate;
        data["SellPriceCcy"] = this.sellPriceCcy;
        data["SellPriceNok"] = this.sellPriceNok;
        data["SellPriceSource"] = this.sellPriceSource;
        data["TaxValuePerUnit"] = this.taxValuePerUnit;
        data["CostPriceYearToDateAdjusted"] = this.costPriceYearToDateAdjusted;
        data["CostPricePeriodAdjusted"] = this.costPricePeriodAdjusted;
        data["ProfitLossChangePeriodInPercent"] = this.profitLossChangePeriodInPercent;
        data["ProfitLossChangeYearToDateInPercent"] = this.profitLossChangeYearToDateInPercent;
        data["RealizedProfitLossClosingBalance"] = this.realizedProfitLossClosingBalance;
        data["RealizedProfitLossEndOfLastYear"] = this.realizedProfitLossEndOfLastYear;
        data["RealizedProfitLossChangeYearToDate"] = this.realizedProfitLossChangeYearToDate;
        data["RealizedProfitLossOpeningBalancePeriod"] = this.realizedProfitLossOpeningBalancePeriod;
        data["RealizedProfitLossChangeInPeriod"] = this.realizedProfitLossChangeInPeriod;
        data["RealizedClosingBalance"] = this.realizedClosingBalance;
        data["RealizedEndOfLastYear"] = this.realizedEndOfLastYear;
        data["RealizedChangeYearToDate"] = this.realizedChangeYearToDate;
        data["RealizedOpeningBalancePeriod"] = this.realizedOpeningBalancePeriod;
        data["RealizedChangeInPeriod"] = this.realizedChangeInPeriod;
        data["AvgRealizedProfitLossClosingBalance"] = this.avgRealizedProfitLossClosingBalance;
        data["AvgRealizedProfitLossEndOfLastYear"] = this.avgRealizedProfitLossEndOfLastYear;
        data["AvgRealizedProfitLossChangeYearToDate"] = this.avgRealizedProfitLossChangeYearToDate;
        data["AvgRealizedProfitLossOpeningBalancePeriod"] = this.avgRealizedProfitLossOpeningBalancePeriod;
        data["AvgRealizedProfitLossChangeInPeriod"] = this.avgRealizedProfitLossChangeInPeriod;
        data["ProfitLossClosingBalance"] = this.profitLossClosingBalance;
        data["ProfitLossEndOfLastYear"] = this.profitLossEndOfLastYear;
        data["ProfitLossChangeYearToDate"] = this.profitLossChangeYearToDate;
        data["ProfitLossOpeningBalancePeriod"] = this.profitLossOpeningBalancePeriod;
        data["ProfitLossChangeInPeriod"] = this.profitLossChangeInPeriod;
        data["AvgProfitLossClosingBalance"] = this.avgProfitLossClosingBalance;
        data["AvgProfitLossEndOfLastYear"] = this.avgProfitLossEndOfLastYear;
        data["AvgProfitLossChangeYearToDate"] = this.avgProfitLossChangeYearToDate;
        data["AvgProfitLossOpeningBalancePeriod"] = this.avgProfitLossOpeningBalancePeriod;
        data["AvgProfitLossChangeInPeriod"] = this.avgProfitLossChangeInPeriod;
        data["UnrealizedProfitLossChangeInPeriod"] = this.unrealizedProfitLossChangeInPeriod;
        data["UnrealizedProfitLossOpeningBalancePeriod"] = this.unrealizedProfitLossOpeningBalancePeriod;
        data["UnrealizedProfitLossChangeYearToDate"] = this.unrealizedProfitLossChangeYearToDate;
        data["UnrealizedProfitLossClosingBalance"] = this.unrealizedProfitLossClosingBalance;
        data["UnrealizedProfitLossEndOfLastYear"] = this.unrealizedProfitLossEndOfLastYear;
        data["AvgUnrealizedProfitLossClosingBalance"] = this.avgUnrealizedProfitLossClosingBalance;
        data["AvgUnrealizedProfitLossEndOfLastYear"] = this.avgUnrealizedProfitLossEndOfLastYear;
        data["AvgUnrealizedProfitLossChangeYearToDate"] = this.avgUnrealizedProfitLossChangeYearToDate;
        data["AvgUnrealizedProfitLossOpeningBalancePeriod"] = this.avgUnrealizedProfitLossOpeningBalancePeriod;
        data["AvgUnrealizedProfitLossChangeInPeriod"] = this.avgUnrealizedProfitLossChangeInPeriod;
        data["InterestChangeInPeriod"] = this.interestChangeInPeriod;
        data["InterestOpeningBalancePeriod"] = this.interestOpeningBalancePeriod;
        data["InterestChangeYearToDate"] = this.interestChangeYearToDate;
        data["InterestClosingBalance"] = this.interestClosingBalance;
        data["InterestEndOfLastYear"] = this.interestEndOfLastYear;
        data["DividendChangeInPeriod"] = this.dividendChangeInPeriod;
        data["DividendOpeningBalancePeriod"] = this.dividendOpeningBalancePeriod;
        data["DividendChangeYearToDate"] = this.dividendChangeYearToDate;
        data["DividendEndOfLastYear"] = this.dividendEndOfLastYear;
        data["DividendClosingBalance"] = this.dividendClosingBalance;
        data["RepaymentChangeInPeriod"] = this.repaymentChangeInPeriod;
        data["RepaymentOpeningBalancePeriod"] = this.repaymentOpeningBalancePeriod;
        data["RepaymentChangeYearToDate"] = this.repaymentChangeYearToDate;
        data["RepaymentEndOfLastYear"] = this.repaymentEndOfLastYear;
        data["RepaymentClosingBalance"] = this.repaymentClosingBalance;
        data["CostOfRealizedChangeInPeriod"] = this.costOfRealizedChangeInPeriod;
        data["CostOfRealizedOpeningBalancePeriod"] = this.costOfRealizedOpeningBalancePeriod;
        data["CostOfRealizedChangeYearToDate"] = this.costOfRealizedChangeYearToDate;
        data["CostOfRealizedEndOfLastYear"] = this.costOfRealizedEndOfLastYear;
        data["CostOfRealizedClosingBalance"] = this.costOfRealizedClosingBalance;
        data["CostPriceChangeInPeriod"] = this.costPriceChangeInPeriod;
        data["CostPriceOpeningBalancePeriod"] = this.costPriceOpeningBalancePeriod;
        data["CostPriceChangeYearToDate"] = this.costPriceChangeYearToDate;
        data["CostPriceEndOfLastYear"] = this.costPriceEndOfLastYear;
        data["CostPriceClosingBalance"] = this.costPriceClosingBalance;
        data["AvgCostPriceClosingBalance"] = this.avgCostPriceClosingBalance;
        data["AvgCostPriceEndOfLastYear"] = this.avgCostPriceEndOfLastYear;
        data["AvgCostPriceChangeYearToDate"] = this.avgCostPriceChangeYearToDate;
        data["AvgCostPriceOpeningBalancePeriod"] = this.avgCostPriceOpeningBalancePeriod;
        data["AvgCostPriceChangeInPeriod"] = this.avgCostPriceChangeInPeriod;
        data["EstimatedValueChangeInPeriod"] = this.estimatedValueChangeInPeriod;
        data["EstimatedValueOpeningBalancePeriod"] = this.estimatedValueOpeningBalancePeriod;
        data["EstimatedValueChangeYearToDate"] = this.estimatedValueChangeYearToDate;
        data["EstimatedValueClosingBalance"] = this.estimatedValueClosingBalance;
        data["EstimatedValueEndOfLastYear"] = this.estimatedValueEndOfLastYear;
        data["QuantityClosingBalance"] = this.quantityClosingBalance;
        data["QuantityEndOfLastYear"] = this.quantityEndOfLastYear;
        data["QuantityChangeYearToDate"] = this.quantityChangeYearToDate;
        data["QuantityOpeningBalancePeriod"] = this.quantityOpeningBalancePeriod;
        data["QuantityChangeInPeriod"] = this.quantityChangeInPeriod;
        data["CostOfAcquiredClosingBalance"] = this.costOfAcquiredClosingBalance;
        data["CostOfAcquiredEndOfLastYear"] = this.costOfAcquiredEndOfLastYear;
        data["CostOfAcquiredChangeYearToDate"] = this.costOfAcquiredChangeYearToDate;
        data["CostOfAcquiredOpeningBalancePeriod"] = this.costOfAcquiredOpeningBalancePeriod;
        data["CostOfAcquiredChangeInPeriod"] = this.costOfAcquiredChangeInPeriod;
        data["WithHoldingTaxChangeYearToDate"] = this.withHoldingTaxChangeYearToDate;
        return data;
    }
}

export interface IInstrumentValuesReportViewModel {
    date?: string;
    periodName?: string;
    reportingInstrumentId?: number | undefined;
    instrumentId?: number | undefined;
    availableInstrumentId?: number | undefined;
    name?: string;
    portfolioName?: string;
    reportName?: string;
    customerName?: string;
    instrumentTypeId?: InstrumentType | undefined;
    type?: string;
    category?: string | undefined;
    isin?: string;
    orgNr?: string | undefined;
    ticker?: string | undefined;
    taxable?: boolean | undefined;
    noted?: boolean | undefined;
    longTerm?: boolean | undefined;
    lowerOfCostOrMarket?: boolean | undefined;
    currencyCode?: string | undefined;
    currencyRate?: number | undefined;
    currencyRateDate?: string;
    sellPrice?: number | undefined;
    sellPriceFx?: number;
    sellPriceDate?: string;
    sellPriceCcy?: string | undefined;
    sellPriceNok?: number | undefined;
    sellPriceSource?: string | undefined;
    taxValuePerUnit?: number | undefined;
    costPriceYearToDateAdjusted?: number;
    costPricePeriodAdjusted?: number;
    profitLossChangePeriodInPercent?: number;
    profitLossChangeYearToDateInPercent?: number;
    realizedProfitLossClosingBalance?: number;
    realizedProfitLossEndOfLastYear?: number;
    realizedProfitLossChangeYearToDate?: number;
    realizedProfitLossOpeningBalancePeriod?: number;
    realizedProfitLossChangeInPeriod?: number;
    realizedClosingBalance?: number;
    realizedEndOfLastYear?: number;
    realizedChangeYearToDate?: number;
    realizedOpeningBalancePeriod?: number;
    realizedChangeInPeriod?: number;
    avgRealizedProfitLossClosingBalance?: number;
    avgRealizedProfitLossEndOfLastYear?: number;
    avgRealizedProfitLossChangeYearToDate?: number;
    avgRealizedProfitLossOpeningBalancePeriod?: number;
    avgRealizedProfitLossChangeInPeriod?: number;
    profitLossClosingBalance?: number;
    profitLossEndOfLastYear?: number;
    profitLossChangeYearToDate?: number;
    profitLossOpeningBalancePeriod?: number;
    profitLossChangeInPeriod?: number;
    avgProfitLossClosingBalance?: number;
    avgProfitLossEndOfLastYear?: number;
    avgProfitLossChangeYearToDate?: number;
    avgProfitLossOpeningBalancePeriod?: number;
    avgProfitLossChangeInPeriod?: number;
    unrealizedProfitLossChangeInPeriod?: number;
    unrealizedProfitLossOpeningBalancePeriod?: number;
    unrealizedProfitLossChangeYearToDate?: number;
    unrealizedProfitLossClosingBalance?: number;
    unrealizedProfitLossEndOfLastYear?: number;
    avgUnrealizedProfitLossClosingBalance?: number;
    avgUnrealizedProfitLossEndOfLastYear?: number;
    avgUnrealizedProfitLossChangeYearToDate?: number;
    avgUnrealizedProfitLossOpeningBalancePeriod?: number;
    avgUnrealizedProfitLossChangeInPeriod?: number;
    interestChangeInPeriod?: number;
    interestOpeningBalancePeriod?: number;
    interestChangeYearToDate?: number;
    interestClosingBalance?: number;
    interestEndOfLastYear?: number;
    dividendChangeInPeriod?: number;
    dividendOpeningBalancePeriod?: number;
    dividendChangeYearToDate?: number;
    dividendEndOfLastYear?: number;
    dividendClosingBalance?: number;
    repaymentChangeInPeriod?: number;
    repaymentOpeningBalancePeriod?: number;
    repaymentChangeYearToDate?: number;
    repaymentEndOfLastYear?: number;
    repaymentClosingBalance?: number;
    costOfRealizedChangeInPeriod?: number;
    costOfRealizedOpeningBalancePeriod?: number;
    costOfRealizedChangeYearToDate?: number;
    costOfRealizedEndOfLastYear?: number;
    costOfRealizedClosingBalance?: number;
    costPriceChangeInPeriod?: number;
    costPriceOpeningBalancePeriod?: number;
    costPriceChangeYearToDate?: number;
    costPriceEndOfLastYear?: number;
    costPriceClosingBalance?: number;
    avgCostPriceClosingBalance?: number;
    avgCostPriceEndOfLastYear?: number;
    avgCostPriceChangeYearToDate?: number;
    avgCostPriceOpeningBalancePeriod?: number;
    avgCostPriceChangeInPeriod?: number;
    estimatedValueChangeInPeriod?: number;
    estimatedValueOpeningBalancePeriod?: number;
    estimatedValueChangeYearToDate?: number;
    estimatedValueClosingBalance?: number;
    estimatedValueEndOfLastYear?: number;
    quantityClosingBalance?: number;
    quantityEndOfLastYear?: number;
    quantityChangeYearToDate?: number;
    quantityOpeningBalancePeriod?: number;
    quantityChangeInPeriod?: number;
    costOfAcquiredClosingBalance?: number;
    costOfAcquiredEndOfLastYear?: number;
    costOfAcquiredChangeYearToDate?: number;
    costOfAcquiredOpeningBalancePeriod?: number;
    costOfAcquiredChangeInPeriod?: number;
    withHoldingTaxChangeYearToDate?: number;
}

export class CustomerTotalValuesReportViewModel implements ICustomerTotalValuesReportViewModel {
    customerName?: string;
    periodName?: string;
    dateClosingBalance?: string;
    costPriceClosingBalance?: number;
    estimatedValue?: number;
    interestClosingBalance?: number;
    interestChangeYearToDate?: number;
    interestChangePeriod?: number;
    realizedProfitLossChangeYearToDate?: number;
    realizedProfitLossChangePeriod?: number;
    unrealizedProfitLossChangeYearToDate?: number;
    unrealizedProfitLossChangePeriod?: number;
    profitLossChangeYearToDate?: number;
    profitLossPeriod?: number;
    netAssetValueClosingBalance?: number;
    netAssetValueEndOfLastYear?: number;
    netAssetValueAdjusted?: number;
    netAssetValueEndOfLastYearAdjusted?: number;
    valueAdjustedResultYtd?: number;
    netAssetValueChangePeriodInPercent?: number;
    indexSellpriceClosingBalance?: number;
    indexSellPriceEndOfLastYear?: number;
    indexSellpriceChangeYearToDateInPercent?: number;
    companyStockClosingBalance?: number;
    navPerShare?: number;
    estimatedValueEndOfLastYear?: number;
    profitLossChangeYearToDateInPercent?: number;
    profitLossChangePeriodInPercent?: number;
    costPriceYearToDate?: number;
    costPriceChangePeriod?: number;
    profitLossClosingBalance?: number;
    estimatedValueChangePeriod?: number;
    estimatedValueChangeYearToDate?: number;
    indexSellPriceChangePeriodInPercent?: number;
    netAssetValueChangeYearToDateInPercent?: number;
    glResultChangeYearToDate?: number;
    glResultChangePeriod?: number;
    netAssetValueYtd?: number;
    netAssetValuePeriod?: number;
    netAssetValueYearToDateAdjusted?: number;
    netAssetValuePeriodAdjusted?: number;
    dividendOpeningBalancePeriod?: number;
    dividendClosingBalance?: number;
    dividendEndOfLastYear?: number;
    dividendChangeYearToDate?: number;
    dividendChangeInPeriod?: number;
    repaymentOpeningBalancePeriod?: number;
    repaymentClosingBalance?: number;
    repaymentEndOfLastYear?: number;
    repaymentChangeYearToDate?: number;
    repaymentChangeInPeriod?: number;
    interestEndOfLastYear?: number;
    interestOpeningBalancePeriod?: number;
    realizedProfitLossClosingBalance?: number;
    realizedProfitLossEndOfLastYear?: number;
    realizedProfitLossOpeningBalancePeriod?: number;
    unrealizedProfitLossClosingBalance?: number;
    profitLossChangePeriod?: number;
    profitLossOpeningBalancePeriod?: number;
    profitLossEndOfLastYear?: number;
    unrealizedProfitLossEndOfLastYear?: number;
    unrealizedProfitLossOpeningBalancePeriod?: number;

    constructor(data?: ICustomerTotalValuesReportViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerName = _data["CustomerName"];
            this.periodName = _data["PeriodName"];
            this.dateClosingBalance = _data["DateClosingBalance"];
            this.costPriceClosingBalance = _data["CostPriceClosingBalance"];
            this.estimatedValue = _data["EstimatedValue"];
            this.interestClosingBalance = _data["InterestClosingBalance"];
            this.interestChangeYearToDate = _data["InterestChangeYearToDate"];
            this.interestChangePeriod = _data["InterestChangePeriod"];
            this.realizedProfitLossChangeYearToDate = _data["RealizedProfitLossChangeYearToDate"];
            this.realizedProfitLossChangePeriod = _data["RealizedProfitLossChangePeriod"];
            this.unrealizedProfitLossChangeYearToDate = _data["UnrealizedProfitLossChangeYearToDate"];
            this.unrealizedProfitLossChangePeriod = _data["UnrealizedProfitLossChangePeriod"];
            this.profitLossChangeYearToDate = _data["ProfitLossChangeYearToDate"];
            this.profitLossPeriod = _data["ProfitLossPeriod"];
            this.netAssetValueClosingBalance = _data["NetAssetValueClosingBalance"];
            this.netAssetValueEndOfLastYear = _data["NetAssetValueEndOfLastYear"];
            this.netAssetValueAdjusted = _data["NetAssetValueAdjusted"];
            this.netAssetValueEndOfLastYearAdjusted = _data["NetAssetValueEndOfLastYearAdjusted"];
            this.valueAdjustedResultYtd = _data["ValueAdjustedResultYtd"];
            this.netAssetValueChangePeriodInPercent = _data["NetAssetValueChangePeriodInPercent"];
            this.indexSellpriceClosingBalance = _data["IndexSellpriceClosingBalance"];
            this.indexSellPriceEndOfLastYear = _data["IndexSellPriceEndOfLastYear"];
            this.indexSellpriceChangeYearToDateInPercent = _data["IndexSellpriceChangeYearToDateInPercent"];
            this.companyStockClosingBalance = _data["CompanyStockClosingBalance"];
            this.navPerShare = _data["NavPerShare"];
            this.estimatedValueEndOfLastYear = _data["EstimatedValueEndOfLastYear"];
            this.profitLossChangeYearToDateInPercent = _data["ProfitLossChangeYearToDateInPercent"];
            this.profitLossChangePeriodInPercent = _data["ProfitLossChangePeriodInPercent"];
            this.costPriceYearToDate = _data["CostPriceYearToDate"];
            this.costPriceChangePeriod = _data["CostPriceChangePeriod"];
            this.profitLossClosingBalance = _data["ProfitLossClosingBalance"];
            this.estimatedValueChangePeriod = _data["EstimatedValueChangePeriod"];
            this.estimatedValueChangeYearToDate = _data["EstimatedValueChangeYearToDate"];
            this.indexSellPriceChangePeriodInPercent = _data["IndexSellPriceChangePeriodInPercent"];
            this.netAssetValueChangeYearToDateInPercent = _data["NetAssetValueChangeYearToDateInPercent"];
            this.glResultChangeYearToDate = _data["GlResultChangeYearToDate"];
            this.glResultChangePeriod = _data["GlResultChangePeriod"];
            this.netAssetValueYtd = _data["NetAssetValueYtd"];
            this.netAssetValuePeriod = _data["NetAssetValuePeriod"];
            this.netAssetValueYearToDateAdjusted = _data["NetAssetValueYearToDateAdjusted"];
            this.netAssetValuePeriodAdjusted = _data["NetAssetValuePeriodAdjusted"];
            this.dividendOpeningBalancePeriod = _data["DividendOpeningBalancePeriod"];
            this.dividendClosingBalance = _data["DividendClosingBalance"];
            this.dividendEndOfLastYear = _data["DividendEndOfLastYear"];
            this.dividendChangeYearToDate = _data["DividendChangeYearToDate"];
            this.dividendChangeInPeriod = _data["DividendChangeInPeriod"];
            this.repaymentOpeningBalancePeriod = _data["RepaymentOpeningBalancePeriod"];
            this.repaymentClosingBalance = _data["RepaymentClosingBalance"];
            this.repaymentEndOfLastYear = _data["RepaymentEndOfLastYear"];
            this.repaymentChangeYearToDate = _data["RepaymentChangeYearToDate"];
            this.repaymentChangeInPeriod = _data["RepaymentChangeInPeriod"];
            this.interestEndOfLastYear = _data["InterestEndOfLastYear"];
            this.interestOpeningBalancePeriod = _data["InterestOpeningBalancePeriod"];
            this.realizedProfitLossClosingBalance = _data["RealizedProfitLossClosingBalance"];
            this.realizedProfitLossEndOfLastYear = _data["RealizedProfitLossEndOfLastYear"];
            this.realizedProfitLossOpeningBalancePeriod = _data["RealizedProfitLossOpeningBalancePeriod"];
            this.unrealizedProfitLossClosingBalance = _data["UnrealizedProfitLossClosingBalance"];
            this.profitLossChangePeriod = _data["ProfitLossChangePeriod"];
            this.profitLossOpeningBalancePeriod = _data["ProfitLossOpeningBalancePeriod"];
            this.profitLossEndOfLastYear = _data["ProfitLossEndOfLastYear"];
            this.unrealizedProfitLossEndOfLastYear = _data["UnrealizedProfitLossEndOfLastYear"];
            this.unrealizedProfitLossOpeningBalancePeriod = _data["UnrealizedProfitLossOpeningBalancePeriod"];
        }
    }

    static fromJS(data: any): CustomerTotalValuesReportViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerTotalValuesReportViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomerName"] = this.customerName;
        data["PeriodName"] = this.periodName;
        data["DateClosingBalance"] = this.dateClosingBalance;
        data["CostPriceClosingBalance"] = this.costPriceClosingBalance;
        data["EstimatedValue"] = this.estimatedValue;
        data["InterestClosingBalance"] = this.interestClosingBalance;
        data["InterestChangeYearToDate"] = this.interestChangeYearToDate;
        data["InterestChangePeriod"] = this.interestChangePeriod;
        data["RealizedProfitLossChangeYearToDate"] = this.realizedProfitLossChangeYearToDate;
        data["RealizedProfitLossChangePeriod"] = this.realizedProfitLossChangePeriod;
        data["UnrealizedProfitLossChangeYearToDate"] = this.unrealizedProfitLossChangeYearToDate;
        data["UnrealizedProfitLossChangePeriod"] = this.unrealizedProfitLossChangePeriod;
        data["ProfitLossChangeYearToDate"] = this.profitLossChangeYearToDate;
        data["ProfitLossPeriod"] = this.profitLossPeriod;
        data["NetAssetValueClosingBalance"] = this.netAssetValueClosingBalance;
        data["NetAssetValueEndOfLastYear"] = this.netAssetValueEndOfLastYear;
        data["NetAssetValueAdjusted"] = this.netAssetValueAdjusted;
        data["NetAssetValueEndOfLastYearAdjusted"] = this.netAssetValueEndOfLastYearAdjusted;
        data["ValueAdjustedResultYtd"] = this.valueAdjustedResultYtd;
        data["NetAssetValueChangePeriodInPercent"] = this.netAssetValueChangePeriodInPercent;
        data["IndexSellpriceClosingBalance"] = this.indexSellpriceClosingBalance;
        data["IndexSellPriceEndOfLastYear"] = this.indexSellPriceEndOfLastYear;
        data["IndexSellpriceChangeYearToDateInPercent"] = this.indexSellpriceChangeYearToDateInPercent;
        data["CompanyStockClosingBalance"] = this.companyStockClosingBalance;
        data["NavPerShare"] = this.navPerShare;
        data["EstimatedValueEndOfLastYear"] = this.estimatedValueEndOfLastYear;
        data["ProfitLossChangeYearToDateInPercent"] = this.profitLossChangeYearToDateInPercent;
        data["ProfitLossChangePeriodInPercent"] = this.profitLossChangePeriodInPercent;
        data["CostPriceYearToDate"] = this.costPriceYearToDate;
        data["CostPriceChangePeriod"] = this.costPriceChangePeriod;
        data["ProfitLossClosingBalance"] = this.profitLossClosingBalance;
        data["EstimatedValueChangePeriod"] = this.estimatedValueChangePeriod;
        data["EstimatedValueChangeYearToDate"] = this.estimatedValueChangeYearToDate;
        data["IndexSellPriceChangePeriodInPercent"] = this.indexSellPriceChangePeriodInPercent;
        data["NetAssetValueChangeYearToDateInPercent"] = this.netAssetValueChangeYearToDateInPercent;
        data["GlResultChangeYearToDate"] = this.glResultChangeYearToDate;
        data["GlResultChangePeriod"] = this.glResultChangePeriod;
        data["NetAssetValueYtd"] = this.netAssetValueYtd;
        data["NetAssetValuePeriod"] = this.netAssetValuePeriod;
        data["NetAssetValueYearToDateAdjusted"] = this.netAssetValueYearToDateAdjusted;
        data["NetAssetValuePeriodAdjusted"] = this.netAssetValuePeriodAdjusted;
        data["DividendOpeningBalancePeriod"] = this.dividendOpeningBalancePeriod;
        data["DividendClosingBalance"] = this.dividendClosingBalance;
        data["DividendEndOfLastYear"] = this.dividendEndOfLastYear;
        data["DividendChangeYearToDate"] = this.dividendChangeYearToDate;
        data["DividendChangeInPeriod"] = this.dividendChangeInPeriod;
        data["RepaymentOpeningBalancePeriod"] = this.repaymentOpeningBalancePeriod;
        data["RepaymentClosingBalance"] = this.repaymentClosingBalance;
        data["RepaymentEndOfLastYear"] = this.repaymentEndOfLastYear;
        data["RepaymentChangeYearToDate"] = this.repaymentChangeYearToDate;
        data["RepaymentChangeInPeriod"] = this.repaymentChangeInPeriod;
        data["InterestEndOfLastYear"] = this.interestEndOfLastYear;
        data["InterestOpeningBalancePeriod"] = this.interestOpeningBalancePeriod;
        data["RealizedProfitLossClosingBalance"] = this.realizedProfitLossClosingBalance;
        data["RealizedProfitLossEndOfLastYear"] = this.realizedProfitLossEndOfLastYear;
        data["RealizedProfitLossOpeningBalancePeriod"] = this.realizedProfitLossOpeningBalancePeriod;
        data["UnrealizedProfitLossClosingBalance"] = this.unrealizedProfitLossClosingBalance;
        data["ProfitLossChangePeriod"] = this.profitLossChangePeriod;
        data["ProfitLossOpeningBalancePeriod"] = this.profitLossOpeningBalancePeriod;
        data["ProfitLossEndOfLastYear"] = this.profitLossEndOfLastYear;
        data["UnrealizedProfitLossEndOfLastYear"] = this.unrealizedProfitLossEndOfLastYear;
        data["UnrealizedProfitLossOpeningBalancePeriod"] = this.unrealizedProfitLossOpeningBalancePeriod;
        return data;
    }
}

export interface ICustomerTotalValuesReportViewModel {
    customerName?: string;
    periodName?: string;
    dateClosingBalance?: string;
    costPriceClosingBalance?: number;
    estimatedValue?: number;
    interestClosingBalance?: number;
    interestChangeYearToDate?: number;
    interestChangePeriod?: number;
    realizedProfitLossChangeYearToDate?: number;
    realizedProfitLossChangePeriod?: number;
    unrealizedProfitLossChangeYearToDate?: number;
    unrealizedProfitLossChangePeriod?: number;
    profitLossChangeYearToDate?: number;
    profitLossPeriod?: number;
    netAssetValueClosingBalance?: number;
    netAssetValueEndOfLastYear?: number;
    netAssetValueAdjusted?: number;
    netAssetValueEndOfLastYearAdjusted?: number;
    valueAdjustedResultYtd?: number;
    netAssetValueChangePeriodInPercent?: number;
    indexSellpriceClosingBalance?: number;
    indexSellPriceEndOfLastYear?: number;
    indexSellpriceChangeYearToDateInPercent?: number;
    companyStockClosingBalance?: number;
    navPerShare?: number;
    estimatedValueEndOfLastYear?: number;
    profitLossChangeYearToDateInPercent?: number;
    profitLossChangePeriodInPercent?: number;
    costPriceYearToDate?: number;
    costPriceChangePeriod?: number;
    profitLossClosingBalance?: number;
    estimatedValueChangePeriod?: number;
    estimatedValueChangeYearToDate?: number;
    indexSellPriceChangePeriodInPercent?: number;
    netAssetValueChangeYearToDateInPercent?: number;
    glResultChangeYearToDate?: number;
    glResultChangePeriod?: number;
    netAssetValueYtd?: number;
    netAssetValuePeriod?: number;
    netAssetValueYearToDateAdjusted?: number;
    netAssetValuePeriodAdjusted?: number;
    dividendOpeningBalancePeriod?: number;
    dividendClosingBalance?: number;
    dividendEndOfLastYear?: number;
    dividendChangeYearToDate?: number;
    dividendChangeInPeriod?: number;
    repaymentOpeningBalancePeriod?: number;
    repaymentClosingBalance?: number;
    repaymentEndOfLastYear?: number;
    repaymentChangeYearToDate?: number;
    repaymentChangeInPeriod?: number;
    interestEndOfLastYear?: number;
    interestOpeningBalancePeriod?: number;
    realizedProfitLossClosingBalance?: number;
    realizedProfitLossEndOfLastYear?: number;
    realizedProfitLossOpeningBalancePeriod?: number;
    unrealizedProfitLossClosingBalance?: number;
    profitLossChangePeriod?: number;
    profitLossOpeningBalancePeriod?: number;
    profitLossEndOfLastYear?: number;
    unrealizedProfitLossEndOfLastYear?: number;
    unrealizedProfitLossOpeningBalancePeriod?: number;
}

export class InstrumentValueGroup implements IInstrumentValueGroup {
    periodName?: string;
    group?: string;
    groupId?: number | undefined;
    date?: string;
    costPrice?: number;
    costOfAcquired?: number;
    estimatedValue?: number;
    unrealizedProfitLoss?: number;
    realizedProfitLoss?: number;
    costOfRealized?: number;
    interest?: number;
    dividend?: number;
    estimatedValueFrom?: number;
    profitLossYearToDate?: number;
    costPriceYearToDateAdjusted?: number;

    constructor(data?: IInstrumentValueGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.periodName = _data["PeriodName"];
            this.group = _data["Group"];
            this.groupId = _data["GroupId"];
            this.date = _data["Date"];
            this.costPrice = _data["CostPrice"];
            this.costOfAcquired = _data["CostOfAcquired"];
            this.estimatedValue = _data["EstimatedValue"];
            this.unrealizedProfitLoss = _data["UnrealizedProfitLoss"];
            this.realizedProfitLoss = _data["RealizedProfitLoss"];
            this.costOfRealized = _data["CostOfRealized"];
            this.interest = _data["Interest"];
            this.dividend = _data["Dividend"];
            this.estimatedValueFrom = _data["EstimatedValueFrom"];
            this.profitLossYearToDate = _data["ProfitLossYearToDate"];
            this.costPriceYearToDateAdjusted = _data["CostPriceYearToDateAdjusted"];
        }
    }

    static fromJS(data: any): InstrumentValueGroup {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentValueGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PeriodName"] = this.periodName;
        data["Group"] = this.group;
        data["GroupId"] = this.groupId;
        data["Date"] = this.date;
        data["CostPrice"] = this.costPrice;
        data["CostOfAcquired"] = this.costOfAcquired;
        data["EstimatedValue"] = this.estimatedValue;
        data["UnrealizedProfitLoss"] = this.unrealizedProfitLoss;
        data["RealizedProfitLoss"] = this.realizedProfitLoss;
        data["CostOfRealized"] = this.costOfRealized;
        data["Interest"] = this.interest;
        data["Dividend"] = this.dividend;
        data["EstimatedValueFrom"] = this.estimatedValueFrom;
        data["ProfitLossYearToDate"] = this.profitLossYearToDate;
        data["CostPriceYearToDateAdjusted"] = this.costPriceYearToDateAdjusted;
        return data;
    }
}

export interface IInstrumentValueGroup {
    periodName?: string;
    group?: string;
    groupId?: number | undefined;
    date?: string;
    costPrice?: number;
    costOfAcquired?: number;
    estimatedValue?: number;
    unrealizedProfitLoss?: number;
    realizedProfitLoss?: number;
    costOfRealized?: number;
    interest?: number;
    dividend?: number;
    estimatedValueFrom?: number;
    profitLossYearToDate?: number;
    costPriceYearToDateAdjusted?: number;
}

export class PerformanceViewModel implements IPerformanceViewModel {
    instrumentId?: number | undefined;
    instrumentName?: string;
    isin?: string;
    orgNr?: string;
    closingPrice?: number | undefined;
    changeYearToDate?: number | undefined;
    changeOneWeekToDate?: number | undefined;
    changeOneMonthToDate?: number | undefined;
    changeThreeMonthsToDate?: number | undefined;
    changeSixMonthsToDate?: number | undefined;
    changeOneYearToDate?: number | undefined;
    changeTwoYearsToDate?: number | undefined;
    changeThreeYearsToDate?: number | undefined;
    changeFiveYearsToDate?: number | undefined;

    constructor(data?: IPerformanceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.instrumentId = _data["InstrumentId"];
            this.instrumentName = _data["InstrumentName"];
            this.isin = _data["Isin"];
            this.orgNr = _data["OrgNr"];
            this.closingPrice = _data["ClosingPrice"];
            this.changeYearToDate = _data["ChangeYearToDate"];
            this.changeOneWeekToDate = _data["ChangeOneWeekToDate"];
            this.changeOneMonthToDate = _data["ChangeOneMonthToDate"];
            this.changeThreeMonthsToDate = _data["ChangeThreeMonthsToDate"];
            this.changeSixMonthsToDate = _data["ChangeSixMonthsToDate"];
            this.changeOneYearToDate = _data["ChangeOneYearToDate"];
            this.changeTwoYearsToDate = _data["ChangeTwoYearsToDate"];
            this.changeThreeYearsToDate = _data["ChangeThreeYearsToDate"];
            this.changeFiveYearsToDate = _data["ChangeFiveYearsToDate"];
        }
    }

    static fromJS(data: any): PerformanceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PerformanceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InstrumentId"] = this.instrumentId;
        data["InstrumentName"] = this.instrumentName;
        data["Isin"] = this.isin;
        data["OrgNr"] = this.orgNr;
        data["ClosingPrice"] = this.closingPrice;
        data["ChangeYearToDate"] = this.changeYearToDate;
        data["ChangeOneWeekToDate"] = this.changeOneWeekToDate;
        data["ChangeOneMonthToDate"] = this.changeOneMonthToDate;
        data["ChangeThreeMonthsToDate"] = this.changeThreeMonthsToDate;
        data["ChangeSixMonthsToDate"] = this.changeSixMonthsToDate;
        data["ChangeOneYearToDate"] = this.changeOneYearToDate;
        data["ChangeTwoYearsToDate"] = this.changeTwoYearsToDate;
        data["ChangeThreeYearsToDate"] = this.changeThreeYearsToDate;
        data["ChangeFiveYearsToDate"] = this.changeFiveYearsToDate;
        return data;
    }
}

export interface IPerformanceViewModel {
    instrumentId?: number | undefined;
    instrumentName?: string;
    isin?: string;
    orgNr?: string;
    closingPrice?: number | undefined;
    changeYearToDate?: number | undefined;
    changeOneWeekToDate?: number | undefined;
    changeOneMonthToDate?: number | undefined;
    changeThreeMonthsToDate?: number | undefined;
    changeSixMonthsToDate?: number | undefined;
    changeOneYearToDate?: number | undefined;
    changeTwoYearsToDate?: number | undefined;
    changeThreeYearsToDate?: number | undefined;
    changeFiveYearsToDate?: number | undefined;
}

export class InstrumentValuesPbiExportModel implements IInstrumentValuesPbiExportModel {
    date?: string;
    periodName?: string;
    reportingInstrumentId?: number | undefined;
    instrumentId?: number | undefined;
    availableInstrumentId?: number | undefined;
    name?: string;
    reportName?: string;
    customerName?: string;
    identityId?: number | undefined;
    instrumentTypeId?: InstrumentType | undefined;
    type?: string;
    category?: string | undefined;
    isin?: string;
    orgNr?: string | undefined;
    ticker?: string | undefined;
    taxable?: boolean | undefined;
    noted?: boolean | undefined;
    longTerm?: boolean | undefined;
    lowerOfCostOrMarket?: boolean | undefined;
    currencyCode?: string | undefined;
    currencyRate?: number | undefined;
    currencyRateDate?: string;
    sellPrice?: number | undefined;
    sellPriceDate?: string;
    sellPriceCcy?: string | undefined;
    sellPriceNok?: number | undefined;
    sellPriceSource?: string | undefined;
    category1?: string | undefined;
    category2?: string | undefined;
    category3?: string | undefined;
    category4?: string | undefined;
    customCategory1?: string | undefined;
    customCategory2?: string | undefined;
    customCategory3?: string | undefined;
    customCategory4?: string | undefined;
    customCategory5?: string | undefined;
    customCategory6?: string | undefined;
    customCategory7?: string | undefined;
    customCategory8?: string | undefined;
    customCategory9?: string | undefined;
    realizedClosingBalance?: number;
    realizedProfitLossClosingBalance?: number;
    avgRealizedProfitLossClosingBalance?: number;
    profitLossClosingBalance?: number;
    avgProfitLossClosingBalance?: number;
    unrealizedProfitLossClosingBalance?: number;
    avgUnrealizedProfitLossClosingBalance?: number;
    interestClosingBalance?: number;
    dividendClosingBalance?: number;
    repaymentClosingBalance?: number;
    capitalIncreaseClosingBalance?: number;
    withHoldingTaxClosingBalance?: number;
    costOfRealizedClosingBalance?: number;
    costPriceClosingBalance?: number;
    avgCostPriceClosingBalance?: number;
    estimatedValueClosingBalance?: number;
    quantityClosingBalance?: number;
    costOfAcquiredClosingBalance?: number;
    portfolioId?: number;
    portfolioName?: string;

    constructor(data?: IInstrumentValuesPbiExportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["Date"];
            this.periodName = _data["PeriodName"];
            this.reportingInstrumentId = _data["ReportingInstrumentId"];
            this.instrumentId = _data["InstrumentId"];
            this.availableInstrumentId = _data["AvailableInstrumentId"];
            this.name = _data["Name"];
            this.reportName = _data["ReportName"];
            this.customerName = _data["CustomerName"];
            this.identityId = _data["IdentityId"];
            this.instrumentTypeId = _data["InstrumentTypeId"];
            this.type = _data["Type"];
            this.category = _data["Category"];
            this.isin = _data["Isin"];
            this.orgNr = _data["OrgNr"];
            this.ticker = _data["Ticker"];
            this.taxable = _data["Taxable"];
            this.noted = _data["Noted"];
            this.longTerm = _data["LongTerm"];
            this.lowerOfCostOrMarket = _data["LowerOfCostOrMarket"];
            this.currencyCode = _data["CurrencyCode"];
            this.currencyRate = _data["CurrencyRate"];
            this.currencyRateDate = _data["CurrencyRateDate"];
            this.sellPrice = _data["SellPrice"];
            this.sellPriceDate = _data["SellPriceDate"];
            this.sellPriceCcy = _data["SellPriceCcy"];
            this.sellPriceNok = _data["SellPriceNok"];
            this.sellPriceSource = _data["SellPriceSource"];
            this.category1 = _data["Category1"];
            this.category2 = _data["Category2"];
            this.category3 = _data["Category3"];
            this.category4 = _data["Category4"];
            this.customCategory1 = _data["CustomCategory1"];
            this.customCategory2 = _data["CustomCategory2"];
            this.customCategory3 = _data["CustomCategory3"];
            this.customCategory4 = _data["CustomCategory4"];
            this.customCategory5 = _data["CustomCategory5"];
            this.customCategory6 = _data["CustomCategory6"];
            this.customCategory7 = _data["CustomCategory7"];
            this.customCategory8 = _data["CustomCategory8"];
            this.customCategory9 = _data["CustomCategory9"];
            this.realizedClosingBalance = _data["RealizedClosingBalance"];
            this.realizedProfitLossClosingBalance = _data["RealizedProfitLossClosingBalance"];
            this.avgRealizedProfitLossClosingBalance = _data["AvgRealizedProfitLossClosingBalance"];
            this.profitLossClosingBalance = _data["ProfitLossClosingBalance"];
            this.avgProfitLossClosingBalance = _data["AvgProfitLossClosingBalance"];
            this.unrealizedProfitLossClosingBalance = _data["UnrealizedProfitLossClosingBalance"];
            this.avgUnrealizedProfitLossClosingBalance = _data["AvgUnrealizedProfitLossClosingBalance"];
            this.interestClosingBalance = _data["InterestClosingBalance"];
            this.dividendClosingBalance = _data["DividendClosingBalance"];
            this.repaymentClosingBalance = _data["RepaymentClosingBalance"];
            this.capitalIncreaseClosingBalance = _data["CapitalIncreaseClosingBalance"];
            this.withHoldingTaxClosingBalance = _data["WithHoldingTaxClosingBalance"];
            this.costOfRealizedClosingBalance = _data["CostOfRealizedClosingBalance"];
            this.costPriceClosingBalance = _data["CostPriceClosingBalance"];
            this.avgCostPriceClosingBalance = _data["AvgCostPriceClosingBalance"];
            this.estimatedValueClosingBalance = _data["EstimatedValueClosingBalance"];
            this.quantityClosingBalance = _data["QuantityClosingBalance"];
            this.costOfAcquiredClosingBalance = _data["CostOfAcquiredClosingBalance"];
            this.portfolioId = _data["PortfolioId"];
            this.portfolioName = _data["PortfolioName"];
        }
    }

    static fromJS(data: any): InstrumentValuesPbiExportModel {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentValuesPbiExportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Date"] = this.date;
        data["PeriodName"] = this.periodName;
        data["ReportingInstrumentId"] = this.reportingInstrumentId;
        data["InstrumentId"] = this.instrumentId;
        data["AvailableInstrumentId"] = this.availableInstrumentId;
        data["Name"] = this.name;
        data["ReportName"] = this.reportName;
        data["CustomerName"] = this.customerName;
        data["IdentityId"] = this.identityId;
        data["InstrumentTypeId"] = this.instrumentTypeId;
        data["Type"] = this.type;
        data["Category"] = this.category;
        data["Isin"] = this.isin;
        data["OrgNr"] = this.orgNr;
        data["Ticker"] = this.ticker;
        data["Taxable"] = this.taxable;
        data["Noted"] = this.noted;
        data["LongTerm"] = this.longTerm;
        data["LowerOfCostOrMarket"] = this.lowerOfCostOrMarket;
        data["CurrencyCode"] = this.currencyCode;
        data["CurrencyRate"] = this.currencyRate;
        data["CurrencyRateDate"] = this.currencyRateDate;
        data["SellPrice"] = this.sellPrice;
        data["SellPriceDate"] = this.sellPriceDate;
        data["SellPriceCcy"] = this.sellPriceCcy;
        data["SellPriceNok"] = this.sellPriceNok;
        data["SellPriceSource"] = this.sellPriceSource;
        data["Category1"] = this.category1;
        data["Category2"] = this.category2;
        data["Category3"] = this.category3;
        data["Category4"] = this.category4;
        data["CustomCategory1"] = this.customCategory1;
        data["CustomCategory2"] = this.customCategory2;
        data["CustomCategory3"] = this.customCategory3;
        data["CustomCategory4"] = this.customCategory4;
        data["CustomCategory5"] = this.customCategory5;
        data["CustomCategory6"] = this.customCategory6;
        data["CustomCategory7"] = this.customCategory7;
        data["CustomCategory8"] = this.customCategory8;
        data["CustomCategory9"] = this.customCategory9;
        data["RealizedClosingBalance"] = this.realizedClosingBalance;
        data["RealizedProfitLossClosingBalance"] = this.realizedProfitLossClosingBalance;
        data["AvgRealizedProfitLossClosingBalance"] = this.avgRealizedProfitLossClosingBalance;
        data["ProfitLossClosingBalance"] = this.profitLossClosingBalance;
        data["AvgProfitLossClosingBalance"] = this.avgProfitLossClosingBalance;
        data["UnrealizedProfitLossClosingBalance"] = this.unrealizedProfitLossClosingBalance;
        data["AvgUnrealizedProfitLossClosingBalance"] = this.avgUnrealizedProfitLossClosingBalance;
        data["InterestClosingBalance"] = this.interestClosingBalance;
        data["DividendClosingBalance"] = this.dividendClosingBalance;
        data["RepaymentClosingBalance"] = this.repaymentClosingBalance;
        data["CapitalIncreaseClosingBalance"] = this.capitalIncreaseClosingBalance;
        data["WithHoldingTaxClosingBalance"] = this.withHoldingTaxClosingBalance;
        data["CostOfRealizedClosingBalance"] = this.costOfRealizedClosingBalance;
        data["CostPriceClosingBalance"] = this.costPriceClosingBalance;
        data["AvgCostPriceClosingBalance"] = this.avgCostPriceClosingBalance;
        data["EstimatedValueClosingBalance"] = this.estimatedValueClosingBalance;
        data["QuantityClosingBalance"] = this.quantityClosingBalance;
        data["CostOfAcquiredClosingBalance"] = this.costOfAcquiredClosingBalance;
        data["PortfolioId"] = this.portfolioId;
        data["PortfolioName"] = this.portfolioName;
        return data;
    }
}

export interface IInstrumentValuesPbiExportModel {
    date?: string;
    periodName?: string;
    reportingInstrumentId?: number | undefined;
    instrumentId?: number | undefined;
    availableInstrumentId?: number | undefined;
    name?: string;
    reportName?: string;
    customerName?: string;
    identityId?: number | undefined;
    instrumentTypeId?: InstrumentType | undefined;
    type?: string;
    category?: string | undefined;
    isin?: string;
    orgNr?: string | undefined;
    ticker?: string | undefined;
    taxable?: boolean | undefined;
    noted?: boolean | undefined;
    longTerm?: boolean | undefined;
    lowerOfCostOrMarket?: boolean | undefined;
    currencyCode?: string | undefined;
    currencyRate?: number | undefined;
    currencyRateDate?: string;
    sellPrice?: number | undefined;
    sellPriceDate?: string;
    sellPriceCcy?: string | undefined;
    sellPriceNok?: number | undefined;
    sellPriceSource?: string | undefined;
    category1?: string | undefined;
    category2?: string | undefined;
    category3?: string | undefined;
    category4?: string | undefined;
    customCategory1?: string | undefined;
    customCategory2?: string | undefined;
    customCategory3?: string | undefined;
    customCategory4?: string | undefined;
    customCategory5?: string | undefined;
    customCategory6?: string | undefined;
    customCategory7?: string | undefined;
    customCategory8?: string | undefined;
    customCategory9?: string | undefined;
    realizedClosingBalance?: number;
    realizedProfitLossClosingBalance?: number;
    avgRealizedProfitLossClosingBalance?: number;
    profitLossClosingBalance?: number;
    avgProfitLossClosingBalance?: number;
    unrealizedProfitLossClosingBalance?: number;
    avgUnrealizedProfitLossClosingBalance?: number;
    interestClosingBalance?: number;
    dividendClosingBalance?: number;
    repaymentClosingBalance?: number;
    capitalIncreaseClosingBalance?: number;
    withHoldingTaxClosingBalance?: number;
    costOfRealizedClosingBalance?: number;
    costPriceClosingBalance?: number;
    avgCostPriceClosingBalance?: number;
    estimatedValueClosingBalance?: number;
    quantityClosingBalance?: number;
    costOfAcquiredClosingBalance?: number;
    portfolioId?: number;
    portfolioName?: string;
}

export enum ClickHouseReportDateRangeInterval {
    Day = 1,
    Month = 2,
    Year = 3,
}

export class BankDepthTotalPbiExportModel implements IBankDepthTotalPbiExportModel {
    identityId?: number;
    date?: string;
    bankAmount?: number;
    debtAmount?: number;

    constructor(data?: IBankDepthTotalPbiExportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identityId = _data["IdentityId"];
            this.date = _data["Date"];
            this.bankAmount = _data["BankAmount"];
            this.debtAmount = _data["DebtAmount"];
        }
    }

    static fromJS(data: any): BankDepthTotalPbiExportModel {
        data = typeof data === 'object' ? data : {};
        let result = new BankDepthTotalPbiExportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IdentityId"] = this.identityId;
        data["Date"] = this.date;
        data["BankAmount"] = this.bankAmount;
        data["DebtAmount"] = this.debtAmount;
        return data;
    }
}

export interface IBankDepthTotalPbiExportModel {
    identityId?: number;
    date?: string;
    bankAmount?: number;
    debtAmount?: number;
}

export class GlTransactionPbiExportModel implements IGlTransactionPbiExportModel {
    date?: string;
    customerId?: number;
    identityId?: number;
    accountCode?: string;
    amount?: number;
    vatAmount?: number;
    level1?: string;
    level2?: string;
    level3?: string;
    level4?: string;
    level5?: string;
    externalId?: string;

    constructor(data?: IGlTransactionPbiExportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["Date"];
            this.customerId = _data["CustomerId"];
            this.identityId = _data["IdentityId"];
            this.accountCode = _data["AccountCode"];
            this.amount = _data["Amount"];
            this.vatAmount = _data["VatAmount"];
            this.level1 = _data["Level1"];
            this.level2 = _data["Level2"];
            this.level3 = _data["Level3"];
            this.level4 = _data["Level4"];
            this.level5 = _data["Level5"];
            this.externalId = _data["ExternalId"];
        }
    }

    static fromJS(data: any): GlTransactionPbiExportModel {
        data = typeof data === 'object' ? data : {};
        let result = new GlTransactionPbiExportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Date"] = this.date;
        data["CustomerId"] = this.customerId;
        data["IdentityId"] = this.identityId;
        data["AccountCode"] = this.accountCode;
        data["Amount"] = this.amount;
        data["VatAmount"] = this.vatAmount;
        data["Level1"] = this.level1;
        data["Level2"] = this.level2;
        data["Level3"] = this.level3;
        data["Level4"] = this.level4;
        data["Level5"] = this.level5;
        data["ExternalId"] = this.externalId;
        return data;
    }
}

export interface IGlTransactionPbiExportModel {
    date?: string;
    customerId?: number;
    identityId?: number;
    accountCode?: string;
    amount?: number;
    vatAmount?: number;
    level1?: string;
    level2?: string;
    level3?: string;
    level4?: string;
    level5?: string;
    externalId?: string;
}

export class InstrumentTransaction implements IInstrumentTransaction {
    id?: number;
    transactionDate?: string;
    quantity?: number | undefined;
    amount?: number | undefined;
    fee?: number | undefined;
    changedById?: number | undefined;
    createdById?: number | undefined;
    created?: string | undefined;
    changed?: string | undefined;
    actionType?: ActionType | undefined;
    broker?: string | undefined;
    interests?: number | undefined;
    retracted?: string | undefined;
    externalGeneralLedgerId?: string | undefined;
    voucherNr?: string | undefined;
    currencyCode?: string | undefined;
    externalDocumentId?: string | undefined;
    externalDocumentRowId?: string | undefined;
    currencyAmount?: number | undefined;
    currencyInterests?: number | undefined;
    parentTransactionsId?: number | undefined;
    parentTransactions?: InstrumentTransaction | undefined;
    counterTransactionId?: number | undefined;
    counterTransaction?: InstrumentTransaction | undefined;
    instrumentId?: number;
    instrument?: Instrument | undefined;
    insightTransactionId?: number | undefined;
    categoryInstrumentTransactions?: CategoryInstrumentTransactions[] | undefined;
    inverseCounterTransaction?: InstrumentTransaction[] | undefined;
    childTransactions?: InstrumentTransaction[] | undefined;
    instrumentTransactionGlTransactionInsightLine?: InstrumentTransactionGlTransactionInsightLine[];
    dueDate?: string | undefined;

    constructor(data?: IInstrumentTransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.transactionDate = _data["TransactionDate"];
            this.quantity = _data["Quantity"];
            this.amount = _data["Amount"];
            this.fee = _data["Fee"];
            this.changedById = _data["ChangedById"];
            this.createdById = _data["CreatedById"];
            this.created = _data["Created"];
            this.changed = _data["Changed"];
            this.actionType = _data["ActionType"];
            this.broker = _data["Broker"];
            this.interests = _data["Interests"];
            this.retracted = _data["Retracted"];
            this.externalGeneralLedgerId = _data["ExternalGeneralLedgerId"];
            this.voucherNr = _data["VoucherNr"];
            this.currencyCode = _data["CurrencyCode"];
            this.externalDocumentId = _data["ExternalDocumentId"];
            this.externalDocumentRowId = _data["ExternalDocumentRowId"];
            this.currencyAmount = _data["CurrencyAmount"];
            this.currencyInterests = _data["CurrencyInterests"];
            this.parentTransactionsId = _data["ParentTransactionsId"];
            this.parentTransactions = _data["ParentTransactions"] ? InstrumentTransaction.fromJS(_data["ParentTransactions"]) : undefined as any;
            this.counterTransactionId = _data["CounterTransactionId"];
            this.counterTransaction = _data["CounterTransaction"] ? InstrumentTransaction.fromJS(_data["CounterTransaction"]) : undefined as any;
            this.instrumentId = _data["InstrumentId"];
            this.instrument = _data["Instrument"] ? Instrument.fromJS(_data["Instrument"]) : undefined as any;
            this.insightTransactionId = _data["InsightTransactionId"];
            if (Array.isArray(_data["CategoryInstrumentTransactions"])) {
                this.categoryInstrumentTransactions = [] as any;
                for (let item of _data["CategoryInstrumentTransactions"])
                    this.categoryInstrumentTransactions!.push(CategoryInstrumentTransactions.fromJS(item));
            }
            if (Array.isArray(_data["InverseCounterTransaction"])) {
                this.inverseCounterTransaction = [] as any;
                for (let item of _data["InverseCounterTransaction"])
                    this.inverseCounterTransaction!.push(InstrumentTransaction.fromJS(item));
            }
            if (Array.isArray(_data["ChildTransactions"])) {
                this.childTransactions = [] as any;
                for (let item of _data["ChildTransactions"])
                    this.childTransactions!.push(InstrumentTransaction.fromJS(item));
            }
            if (Array.isArray(_data["InstrumentTransactionGlTransactionInsightLine"])) {
                this.instrumentTransactionGlTransactionInsightLine = [] as any;
                for (let item of _data["InstrumentTransactionGlTransactionInsightLine"])
                    this.instrumentTransactionGlTransactionInsightLine!.push(InstrumentTransactionGlTransactionInsightLine.fromJS(item));
            }
            this.dueDate = _data["DueDate"];
        }
    }

    static fromJS(data: any): InstrumentTransaction {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentTransaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["TransactionDate"] = this.transactionDate;
        data["Quantity"] = this.quantity;
        data["Amount"] = this.amount;
        data["Fee"] = this.fee;
        data["ChangedById"] = this.changedById;
        data["CreatedById"] = this.createdById;
        data["Created"] = this.created;
        data["Changed"] = this.changed;
        data["ActionType"] = this.actionType;
        data["Broker"] = this.broker;
        data["Interests"] = this.interests;
        data["Retracted"] = this.retracted;
        data["ExternalGeneralLedgerId"] = this.externalGeneralLedgerId;
        data["VoucherNr"] = this.voucherNr;
        data["CurrencyCode"] = this.currencyCode;
        data["ExternalDocumentId"] = this.externalDocumentId;
        data["ExternalDocumentRowId"] = this.externalDocumentRowId;
        data["CurrencyAmount"] = this.currencyAmount;
        data["CurrencyInterests"] = this.currencyInterests;
        data["ParentTransactionsId"] = this.parentTransactionsId;
        data["ParentTransactions"] = this.parentTransactions ? this.parentTransactions.toJSON() : undefined as any;
        data["CounterTransactionId"] = this.counterTransactionId;
        data["CounterTransaction"] = this.counterTransaction ? this.counterTransaction.toJSON() : undefined as any;
        data["InstrumentId"] = this.instrumentId;
        data["Instrument"] = this.instrument ? this.instrument.toJSON() : undefined as any;
        data["InsightTransactionId"] = this.insightTransactionId;
        if (Array.isArray(this.categoryInstrumentTransactions)) {
            data["CategoryInstrumentTransactions"] = [];
            for (let item of this.categoryInstrumentTransactions)
                data["CategoryInstrumentTransactions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.inverseCounterTransaction)) {
            data["InverseCounterTransaction"] = [];
            for (let item of this.inverseCounterTransaction)
                data["InverseCounterTransaction"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.childTransactions)) {
            data["ChildTransactions"] = [];
            for (let item of this.childTransactions)
                data["ChildTransactions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.instrumentTransactionGlTransactionInsightLine)) {
            data["InstrumentTransactionGlTransactionInsightLine"] = [];
            for (let item of this.instrumentTransactionGlTransactionInsightLine)
                data["InstrumentTransactionGlTransactionInsightLine"].push(item ? item.toJSON() : undefined as any);
        }
        data["DueDate"] = this.dueDate;
        return data;
    }
}

export interface IInstrumentTransaction {
    id?: number;
    transactionDate?: string;
    quantity?: number | undefined;
    amount?: number | undefined;
    fee?: number | undefined;
    changedById?: number | undefined;
    createdById?: number | undefined;
    created?: string | undefined;
    changed?: string | undefined;
    actionType?: ActionType | undefined;
    broker?: string | undefined;
    interests?: number | undefined;
    retracted?: string | undefined;
    externalGeneralLedgerId?: string | undefined;
    voucherNr?: string | undefined;
    currencyCode?: string | undefined;
    externalDocumentId?: string | undefined;
    externalDocumentRowId?: string | undefined;
    currencyAmount?: number | undefined;
    currencyInterests?: number | undefined;
    parentTransactionsId?: number | undefined;
    parentTransactions?: InstrumentTransaction | undefined;
    counterTransactionId?: number | undefined;
    counterTransaction?: InstrumentTransaction | undefined;
    instrumentId?: number;
    instrument?: Instrument | undefined;
    insightTransactionId?: number | undefined;
    categoryInstrumentTransactions?: CategoryInstrumentTransactions[] | undefined;
    inverseCounterTransaction?: InstrumentTransaction[] | undefined;
    childTransactions?: InstrumentTransaction[] | undefined;
    instrumentTransactionGlTransactionInsightLine?: InstrumentTransactionGlTransactionInsightLine[];
    dueDate?: string | undefined;
}

export class Instrument implements IInstrument {
    id?: number;
    uuid?: string;
    instrumentId?: number;
    isin?: string | undefined;
    ticker?: string | undefined;
    name?: string | undefined;
    noted?: boolean;
    taxable?: boolean;
    longTerm?: boolean;
    lowerOfCostOrMarket?: boolean;
    terminated?: boolean;
    availableInstrumentId?: number | undefined;
    availableInstrumentUuid?: string | undefined;
    availableInstrument?: AvailableInstrument | undefined;
    comment?: string | undefined;
    countryCode?: string | undefined;
    accountingValue?: number | undefined;
    category?: Category | undefined;
    customerId?: number | undefined;
    customer?: Customer | undefined;
    instrumentCurrencyId?: number | undefined;
    currency?: InstrumentCurrency;
    instrumentTypeId?: InstrumentType | undefined;
    categoriesInstruments?: CategoriesInstruments[];
    instrumentTaxValues?: InstrumentTaxValue[];
    instrumentTransactions?: InstrumentTransaction[];
    instrumentPrices?: InstrumentPrice[];

    constructor(data?: IInstrument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.uuid = _data["Uuid"];
            this.instrumentId = _data["InstrumentId"];
            this.isin = _data["Isin"];
            this.ticker = _data["Ticker"];
            this.name = _data["Name"];
            this.noted = _data["Noted"];
            this.taxable = _data["Taxable"];
            this.longTerm = _data["LongTerm"];
            this.lowerOfCostOrMarket = _data["LowerOfCostOrMarket"];
            this.terminated = _data["Terminated"];
            this.availableInstrumentId = _data["AvailableInstrumentId"];
            this.availableInstrumentUuid = _data["AvailableInstrumentUuid"];
            this.availableInstrument = _data["AvailableInstrument"] ? AvailableInstrument.fromJS(_data["AvailableInstrument"]) : undefined as any;
            this.comment = _data["Comment"];
            this.countryCode = _data["CountryCode"];
            this.accountingValue = _data["AccountingValue"];
            this.category = _data["Category"] ? Category.fromJS(_data["Category"]) : undefined as any;
            this.customerId = _data["CustomerId"];
            this.customer = _data["Customer"] ? Customer.fromJS(_data["Customer"]) : undefined as any;
            this.instrumentCurrencyId = _data["InstrumentCurrencyId"];
            this.currency = _data["Currency"] ? InstrumentCurrency.fromJS(_data["Currency"]) : undefined as any;
            this.instrumentTypeId = _data["InstrumentTypeId"];
            if (Array.isArray(_data["CategoriesInstruments"])) {
                this.categoriesInstruments = [] as any;
                for (let item of _data["CategoriesInstruments"])
                    this.categoriesInstruments!.push(CategoriesInstruments.fromJS(item));
            }
            if (Array.isArray(_data["InstrumentTaxValues"])) {
                this.instrumentTaxValues = [] as any;
                for (let item of _data["InstrumentTaxValues"])
                    this.instrumentTaxValues!.push(InstrumentTaxValue.fromJS(item));
            }
            if (Array.isArray(_data["InstrumentTransactions"])) {
                this.instrumentTransactions = [] as any;
                for (let item of _data["InstrumentTransactions"])
                    this.instrumentTransactions!.push(InstrumentTransaction.fromJS(item));
            }
            if (Array.isArray(_data["InstrumentPrices"])) {
                this.instrumentPrices = [] as any;
                for (let item of _data["InstrumentPrices"])
                    this.instrumentPrices!.push(InstrumentPrice.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Instrument {
        data = typeof data === 'object' ? data : {};
        let result = new Instrument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Uuid"] = this.uuid;
        data["InstrumentId"] = this.instrumentId;
        data["Isin"] = this.isin;
        data["Ticker"] = this.ticker;
        data["Name"] = this.name;
        data["Noted"] = this.noted;
        data["Taxable"] = this.taxable;
        data["LongTerm"] = this.longTerm;
        data["LowerOfCostOrMarket"] = this.lowerOfCostOrMarket;
        data["Terminated"] = this.terminated;
        data["AvailableInstrumentId"] = this.availableInstrumentId;
        data["AvailableInstrumentUuid"] = this.availableInstrumentUuid;
        data["AvailableInstrument"] = this.availableInstrument ? this.availableInstrument.toJSON() : undefined as any;
        data["Comment"] = this.comment;
        data["CountryCode"] = this.countryCode;
        data["AccountingValue"] = this.accountingValue;
        data["Category"] = this.category ? this.category.toJSON() : undefined as any;
        data["CustomerId"] = this.customerId;
        data["Customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["InstrumentCurrencyId"] = this.instrumentCurrencyId;
        data["Currency"] = this.currency ? this.currency.toJSON() : undefined as any;
        data["InstrumentTypeId"] = this.instrumentTypeId;
        if (Array.isArray(this.categoriesInstruments)) {
            data["CategoriesInstruments"] = [];
            for (let item of this.categoriesInstruments)
                data["CategoriesInstruments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.instrumentTaxValues)) {
            data["InstrumentTaxValues"] = [];
            for (let item of this.instrumentTaxValues)
                data["InstrumentTaxValues"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.instrumentTransactions)) {
            data["InstrumentTransactions"] = [];
            for (let item of this.instrumentTransactions)
                data["InstrumentTransactions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.instrumentPrices)) {
            data["InstrumentPrices"] = [];
            for (let item of this.instrumentPrices)
                data["InstrumentPrices"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInstrument {
    id?: number;
    uuid?: string;
    instrumentId?: number;
    isin?: string | undefined;
    ticker?: string | undefined;
    name?: string | undefined;
    noted?: boolean;
    taxable?: boolean;
    longTerm?: boolean;
    lowerOfCostOrMarket?: boolean;
    terminated?: boolean;
    availableInstrumentId?: number | undefined;
    availableInstrumentUuid?: string | undefined;
    availableInstrument?: AvailableInstrument | undefined;
    comment?: string | undefined;
    countryCode?: string | undefined;
    accountingValue?: number | undefined;
    category?: Category | undefined;
    customerId?: number | undefined;
    customer?: Customer | undefined;
    instrumentCurrencyId?: number | undefined;
    currency?: InstrumentCurrency;
    instrumentTypeId?: InstrumentType | undefined;
    categoriesInstruments?: CategoriesInstruments[];
    instrumentTaxValues?: InstrumentTaxValue[];
    instrumentTransactions?: InstrumentTransaction[];
    instrumentPrices?: InstrumentPrice[];
}

export class AvailableInstrument implements IAvailableInstrument {
    ticker?: string | undefined;
    lastUpdated?: string | undefined;
    name?: string | undefined;
    isin?: string | undefined;
    id?: number;
    uuid?: string;
    marketsId?: number | undefined;
    failCount?: number | undefined;
    orgNr?: string | undefined;
    feedDescription?: string | undefined;
    customerId?: number | undefined;
    importedPrices?: ImportedPrice[];
    instruments?: Instrument[];
    availableInstrumentId?: number | undefined;
    lookupAvailableInstrumentId?: string | undefined;
    deprRemoveFromHistoricalQuery?: boolean | undefined;
    lastPricelUpdated?: string | undefined;
    lastPriceUpdateAttempt?: string | undefined;
    lastPriceUpdateSuccess?: string | undefined;
    priceUpdateFails?: number | undefined;
    removeFromHistoricalQueryAuto?: boolean;
    removeFromEodQuery?: boolean | undefined;
    availableInstrumentInboxId?: number | undefined;
    currencyCode?: string | undefined;
    countryCode?: string | undefined;
    systemComments?: string | undefined;
    instrumentTypeId?: InstrumentType | undefined;
    currencyMappings?: CurrencyMapping[];
    overrideStartDateForHistoricalPriceQuery?: string | undefined;

    constructor(data?: IAvailableInstrument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticker = _data["Ticker"];
            this.lastUpdated = _data["LastUpdated"];
            this.name = _data["Name"];
            this.isin = _data["Isin"];
            this.id = _data["Id"];
            this.uuid = _data["Uuid"];
            this.marketsId = _data["MarketsId"];
            this.failCount = _data["FailCount"];
            this.orgNr = _data["OrgNr"];
            this.feedDescription = _data["FeedDescription"];
            this.customerId = _data["CustomerId"];
            if (Array.isArray(_data["ImportedPrices"])) {
                this.importedPrices = [] as any;
                for (let item of _data["ImportedPrices"])
                    this.importedPrices!.push(ImportedPrice.fromJS(item));
            }
            if (Array.isArray(_data["Instruments"])) {
                this.instruments = [] as any;
                for (let item of _data["Instruments"])
                    this.instruments!.push(Instrument.fromJS(item));
            }
            this.availableInstrumentId = _data["AvailableInstrumentId"];
            this.lookupAvailableInstrumentId = _data["LookupAvailableInstrumentId"];
            this.deprRemoveFromHistoricalQuery = _data["DeprRemoveFromHistoricalQuery"];
            this.lastPricelUpdated = _data["LastPricelUpdated"];
            this.lastPriceUpdateAttempt = _data["LastPriceUpdateAttempt"];
            this.lastPriceUpdateSuccess = _data["LastPriceUpdateSuccess"];
            this.priceUpdateFails = _data["PriceUpdateFails"];
            this.removeFromHistoricalQueryAuto = _data["RemoveFromHistoricalQueryAuto"];
            this.removeFromEodQuery = _data["RemoveFromEodQuery"];
            this.availableInstrumentInboxId = _data["AvailableInstrumentInboxId"];
            this.currencyCode = _data["CurrencyCode"];
            this.countryCode = _data["CountryCode"];
            this.systemComments = _data["SystemComments"];
            this.instrumentTypeId = _data["InstrumentTypeId"];
            if (Array.isArray(_data["CurrencyMappings"])) {
                this.currencyMappings = [] as any;
                for (let item of _data["CurrencyMappings"])
                    this.currencyMappings!.push(CurrencyMapping.fromJS(item));
            }
            this.overrideStartDateForHistoricalPriceQuery = _data["OverrideStartDateForHistoricalPriceQuery"];
        }
    }

    static fromJS(data: any): AvailableInstrument {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableInstrument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Ticker"] = this.ticker;
        data["LastUpdated"] = this.lastUpdated;
        data["Name"] = this.name;
        data["Isin"] = this.isin;
        data["Id"] = this.id;
        data["Uuid"] = this.uuid;
        data["MarketsId"] = this.marketsId;
        data["FailCount"] = this.failCount;
        data["OrgNr"] = this.orgNr;
        data["FeedDescription"] = this.feedDescription;
        data["CustomerId"] = this.customerId;
        if (Array.isArray(this.importedPrices)) {
            data["ImportedPrices"] = [];
            for (let item of this.importedPrices)
                data["ImportedPrices"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.instruments)) {
            data["Instruments"] = [];
            for (let item of this.instruments)
                data["Instruments"].push(item ? item.toJSON() : undefined as any);
        }
        data["AvailableInstrumentId"] = this.availableInstrumentId;
        data["LookupAvailableInstrumentId"] = this.lookupAvailableInstrumentId;
        data["DeprRemoveFromHistoricalQuery"] = this.deprRemoveFromHistoricalQuery;
        data["LastPricelUpdated"] = this.lastPricelUpdated;
        data["LastPriceUpdateAttempt"] = this.lastPriceUpdateAttempt;
        data["LastPriceUpdateSuccess"] = this.lastPriceUpdateSuccess;
        data["PriceUpdateFails"] = this.priceUpdateFails;
        data["RemoveFromHistoricalQueryAuto"] = this.removeFromHistoricalQueryAuto;
        data["RemoveFromEodQuery"] = this.removeFromEodQuery;
        data["AvailableInstrumentInboxId"] = this.availableInstrumentInboxId;
        data["CurrencyCode"] = this.currencyCode;
        data["CountryCode"] = this.countryCode;
        data["SystemComments"] = this.systemComments;
        data["InstrumentTypeId"] = this.instrumentTypeId;
        if (Array.isArray(this.currencyMappings)) {
            data["CurrencyMappings"] = [];
            for (let item of this.currencyMappings)
                data["CurrencyMappings"].push(item ? item.toJSON() : undefined as any);
        }
        data["OverrideStartDateForHistoricalPriceQuery"] = this.overrideStartDateForHistoricalPriceQuery;
        return data;
    }
}

export interface IAvailableInstrument {
    ticker?: string | undefined;
    lastUpdated?: string | undefined;
    name?: string | undefined;
    isin?: string | undefined;
    id?: number;
    uuid?: string;
    marketsId?: number | undefined;
    failCount?: number | undefined;
    orgNr?: string | undefined;
    feedDescription?: string | undefined;
    customerId?: number | undefined;
    importedPrices?: ImportedPrice[];
    instruments?: Instrument[];
    availableInstrumentId?: number | undefined;
    lookupAvailableInstrumentId?: string | undefined;
    deprRemoveFromHistoricalQuery?: boolean | undefined;
    lastPricelUpdated?: string | undefined;
    lastPriceUpdateAttempt?: string | undefined;
    lastPriceUpdateSuccess?: string | undefined;
    priceUpdateFails?: number | undefined;
    removeFromHistoricalQueryAuto?: boolean;
    removeFromEodQuery?: boolean | undefined;
    availableInstrumentInboxId?: number | undefined;
    currencyCode?: string | undefined;
    countryCode?: string | undefined;
    systemComments?: string | undefined;
    instrumentTypeId?: InstrumentType | undefined;
    currencyMappings?: CurrencyMapping[];
    overrideStartDateForHistoricalPriceQuery?: string | undefined;
}

export class ImportedPrice implements IImportedPrice {
    sellPrice?: number | undefined;
    sellPriceAdjusted?: number | undefined;
    availableInstrumentId?: number | undefined;
    availableInstrumentUuid?: string | undefined;
    id?: number;
    date?: string;
    lastAdjustmentDate?: string | undefined;
    availableInstrument?: AvailableInstrument;

    constructor(data?: IImportedPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sellPrice = _data["SellPrice"];
            this.sellPriceAdjusted = _data["SellPriceAdjusted"];
            this.availableInstrumentId = _data["AvailableInstrumentId"];
            this.availableInstrumentUuid = _data["AvailableInstrumentUuid"];
            this.id = _data["Id"];
            this.date = _data["Date"];
            this.lastAdjustmentDate = _data["LastAdjustmentDate"];
            this.availableInstrument = _data["AvailableInstrument"] ? AvailableInstrument.fromJS(_data["AvailableInstrument"]) : undefined as any;
        }
    }

    static fromJS(data: any): ImportedPrice {
        data = typeof data === 'object' ? data : {};
        let result = new ImportedPrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SellPrice"] = this.sellPrice;
        data["SellPriceAdjusted"] = this.sellPriceAdjusted;
        data["AvailableInstrumentId"] = this.availableInstrumentId;
        data["AvailableInstrumentUuid"] = this.availableInstrumentUuid;
        data["Id"] = this.id;
        data["Date"] = this.date;
        data["LastAdjustmentDate"] = this.lastAdjustmentDate;
        data["AvailableInstrument"] = this.availableInstrument ? this.availableInstrument.toJSON() : undefined as any;
        return data;
    }
}

export interface IImportedPrice {
    sellPrice?: number | undefined;
    sellPriceAdjusted?: number | undefined;
    availableInstrumentId?: number | undefined;
    availableInstrumentUuid?: string | undefined;
    id?: number;
    date?: string;
    lastAdjustmentDate?: string | undefined;
    availableInstrument?: AvailableInstrument;
}

export class CurrencyMapping implements ICurrencyMapping {
    id?: number;
    description?: string;
    instrumentCurrencyId?: number | undefined;
    instrumentCurrency?: InstrumentCurrency | undefined;
    reportingCurrencyId?: number | undefined;
    reportingCurrency?: ReportingCurrency | undefined;
    currencyMultiplier?: number;
    availableInstrumentFxPairId?: number | undefined;
    availableInstrumentFxPairUuid?: string | undefined;
    availableInstrumentFxPair?: AvailableInstrument | undefined;

    constructor(data?: ICurrencyMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.description = _data["Description"];
            this.instrumentCurrencyId = _data["InstrumentCurrencyId"];
            this.instrumentCurrency = _data["InstrumentCurrency"] ? InstrumentCurrency.fromJS(_data["InstrumentCurrency"]) : undefined as any;
            this.reportingCurrencyId = _data["ReportingCurrencyId"];
            this.reportingCurrency = _data["ReportingCurrency"] ? ReportingCurrency.fromJS(_data["ReportingCurrency"]) : undefined as any;
            this.currencyMultiplier = _data["CurrencyMultiplier"];
            this.availableInstrumentFxPairId = _data["AvailableInstrumentFxPairId"];
            this.availableInstrumentFxPairUuid = _data["AvailableInstrumentFxPairUuid"];
            this.availableInstrumentFxPair = _data["AvailableInstrumentFxPair"] ? AvailableInstrument.fromJS(_data["AvailableInstrumentFxPair"]) : undefined as any;
        }
    }

    static fromJS(data: any): CurrencyMapping {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Description"] = this.description;
        data["InstrumentCurrencyId"] = this.instrumentCurrencyId;
        data["InstrumentCurrency"] = this.instrumentCurrency ? this.instrumentCurrency.toJSON() : undefined as any;
        data["ReportingCurrencyId"] = this.reportingCurrencyId;
        data["ReportingCurrency"] = this.reportingCurrency ? this.reportingCurrency.toJSON() : undefined as any;
        data["CurrencyMultiplier"] = this.currencyMultiplier;
        data["AvailableInstrumentFxPairId"] = this.availableInstrumentFxPairId;
        data["AvailableInstrumentFxPairUuid"] = this.availableInstrumentFxPairUuid;
        data["AvailableInstrumentFxPair"] = this.availableInstrumentFxPair ? this.availableInstrumentFxPair.toJSON() : undefined as any;
        return data;
    }
}

export interface ICurrencyMapping {
    id?: number;
    description?: string;
    instrumentCurrencyId?: number | undefined;
    instrumentCurrency?: InstrumentCurrency | undefined;
    reportingCurrencyId?: number | undefined;
    reportingCurrency?: ReportingCurrency | undefined;
    currencyMultiplier?: number;
    availableInstrumentFxPairId?: number | undefined;
    availableInstrumentFxPairUuid?: string | undefined;
    availableInstrumentFxPair?: AvailableInstrument | undefined;
}

export class InstrumentCurrency implements IInstrumentCurrency {
    id?: number;
    currencyCode?: string;
    currencyMapping?: CurrencyMapping;

    constructor(data?: IInstrumentCurrency) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.currencyCode = _data["CurrencyCode"];
            this.currencyMapping = _data["CurrencyMapping"] ? CurrencyMapping.fromJS(_data["CurrencyMapping"]) : undefined as any;
        }
    }

    static fromJS(data: any): InstrumentCurrency {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentCurrency();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CurrencyCode"] = this.currencyCode;
        data["CurrencyMapping"] = this.currencyMapping ? this.currencyMapping.toJSON() : undefined as any;
        return data;
    }
}

export interface IInstrumentCurrency {
    id?: number;
    currencyCode?: string;
    currencyMapping?: CurrencyMapping;
}

export class ReportingCurrency implements IReportingCurrency {
    id?: number;
    currencyCode?: string;

    constructor(data?: IReportingCurrency) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.currencyCode = _data["CurrencyCode"];
        }
    }

    static fromJS(data: any): ReportingCurrency {
        data = typeof data === 'object' ? data : {};
        let result = new ReportingCurrency();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CurrencyCode"] = this.currencyCode;
        return data;
    }
}

export interface IReportingCurrency {
    id?: number;
    currencyCode?: string;
}

export class Category implements ICategory {
    id?: number;
    name?: string;
    externalId?: string | undefined;
    disabled?: boolean;
    insightId?: number;
    customer?: Customer | undefined;
    categoryTypeId?: number;
    categoryType?: CategoryType;
    categoryInstrumentTransactions?: CategoryInstrumentTransactions[];
    categoriesInstruments?: CategoriesInstruments[];
    defaultCategoriesInstruments?: CategoriesInstruments[];

    constructor(data?: ICategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.externalId = _data["ExternalId"];
            this.disabled = _data["Disabled"];
            this.insightId = _data["InsightId"];
            this.customer = _data["Customer"] ? Customer.fromJS(_data["Customer"]) : undefined as any;
            this.categoryTypeId = _data["CategoryTypeId"];
            this.categoryType = _data["CategoryType"] ? CategoryType.fromJS(_data["CategoryType"]) : undefined as any;
            if (Array.isArray(_data["CategoryInstrumentTransactions"])) {
                this.categoryInstrumentTransactions = [] as any;
                for (let item of _data["CategoryInstrumentTransactions"])
                    this.categoryInstrumentTransactions!.push(CategoryInstrumentTransactions.fromJS(item));
            }
            if (Array.isArray(_data["CategoriesInstruments"])) {
                this.categoriesInstruments = [] as any;
                for (let item of _data["CategoriesInstruments"])
                    this.categoriesInstruments!.push(CategoriesInstruments.fromJS(item));
            }
            if (Array.isArray(_data["DefaultCategoriesInstruments"])) {
                this.defaultCategoriesInstruments = [] as any;
                for (let item of _data["DefaultCategoriesInstruments"])
                    this.defaultCategoriesInstruments!.push(CategoriesInstruments.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Category {
        data = typeof data === 'object' ? data : {};
        let result = new Category();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["ExternalId"] = this.externalId;
        data["Disabled"] = this.disabled;
        data["InsightId"] = this.insightId;
        data["Customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["CategoryTypeId"] = this.categoryTypeId;
        data["CategoryType"] = this.categoryType ? this.categoryType.toJSON() : undefined as any;
        if (Array.isArray(this.categoryInstrumentTransactions)) {
            data["CategoryInstrumentTransactions"] = [];
            for (let item of this.categoryInstrumentTransactions)
                data["CategoryInstrumentTransactions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.categoriesInstruments)) {
            data["CategoriesInstruments"] = [];
            for (let item of this.categoriesInstruments)
                data["CategoriesInstruments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.defaultCategoriesInstruments)) {
            data["DefaultCategoriesInstruments"] = [];
            for (let item of this.defaultCategoriesInstruments)
                data["DefaultCategoriesInstruments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICategory {
    id?: number;
    name?: string;
    externalId?: string | undefined;
    disabled?: boolean;
    insightId?: number;
    customer?: Customer | undefined;
    categoryTypeId?: number;
    categoryType?: CategoryType;
    categoryInstrumentTransactions?: CategoryInstrumentTransactions[];
    categoriesInstruments?: CategoriesInstruments[];
    defaultCategoriesInstruments?: CategoriesInstruments[];
}

export class CategoryType implements ICategoryType {
    id?: number;
    name?: string;

    constructor(data?: ICategoryType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): CategoryType {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        return data;
    }
}

export interface ICategoryType {
    id?: number;
    name?: string;
}

export class CategoryInstrumentTransactions implements ICategoryInstrumentTransactions {
    categoryId?: number;
    instrumentTransactionId?: number;
    category?: Category | undefined;
    instrumentTransaction?: InstrumentTransaction | undefined;

    constructor(data?: ICategoryInstrumentTransactions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["CategoryId"];
            this.instrumentTransactionId = _data["InstrumentTransactionId"];
            this.category = _data["Category"] ? Category.fromJS(_data["Category"]) : undefined as any;
            this.instrumentTransaction = _data["InstrumentTransaction"] ? InstrumentTransaction.fromJS(_data["InstrumentTransaction"]) : undefined as any;
        }
    }

    static fromJS(data: any): CategoryInstrumentTransactions {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryInstrumentTransactions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CategoryId"] = this.categoryId;
        data["InstrumentTransactionId"] = this.instrumentTransactionId;
        data["Category"] = this.category ? this.category.toJSON() : undefined as any;
        data["InstrumentTransaction"] = this.instrumentTransaction ? this.instrumentTransaction.toJSON() : undefined as any;
        return data;
    }
}

export interface ICategoryInstrumentTransactions {
    categoryId?: number;
    instrumentTransactionId?: number;
    category?: Category | undefined;
    instrumentTransaction?: InstrumentTransaction | undefined;
}

export class CategoriesInstruments implements ICategoriesInstruments {
    categoryId?: number;
    defaultCategoryId?: number | undefined;
    instrumentId?: number;
    category?: Category;
    defaultCategory?: Category | undefined;
    instrument?: Instrument;
    portion?: number;
    date?: string;

    constructor(data?: ICategoriesInstruments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["CategoryId"];
            this.defaultCategoryId = _data["DefaultCategoryId"];
            this.instrumentId = _data["InstrumentId"];
            this.category = _data["Category"] ? Category.fromJS(_data["Category"]) : undefined as any;
            this.defaultCategory = _data["DefaultCategory"] ? Category.fromJS(_data["DefaultCategory"]) : undefined as any;
            this.instrument = _data["Instrument"] ? Instrument.fromJS(_data["Instrument"]) : undefined as any;
            this.portion = _data["Portion"];
            this.date = _data["Date"];
        }
    }

    static fromJS(data: any): CategoriesInstruments {
        data = typeof data === 'object' ? data : {};
        let result = new CategoriesInstruments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CategoryId"] = this.categoryId;
        data["DefaultCategoryId"] = this.defaultCategoryId;
        data["InstrumentId"] = this.instrumentId;
        data["Category"] = this.category ? this.category.toJSON() : undefined as any;
        data["DefaultCategory"] = this.defaultCategory ? this.defaultCategory.toJSON() : undefined as any;
        data["Instrument"] = this.instrument ? this.instrument.toJSON() : undefined as any;
        data["Portion"] = this.portion;
        data["Date"] = this.date;
        return data;
    }
}

export interface ICategoriesInstruments {
    categoryId?: number;
    defaultCategoryId?: number | undefined;
    instrumentId?: number;
    category?: Category;
    defaultCategory?: Category | undefined;
    instrument?: Instrument;
    portion?: number;
    date?: string;
}

export class InstrumentTaxValue implements IInstrumentTaxValue {
    id?: string;
    taxValue?: number;
    fromDate?: string;
    created?: string;
    updated?: string | undefined;
    instrumentId?: number | undefined;
    instrumentUuid?: string | undefined;
    instrument?: Instrument | undefined;
    createdByEmail?: string;
    updatedByEmail?: string | undefined;

    constructor(data?: IInstrumentTaxValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.taxValue = _data["TaxValue"];
            this.fromDate = _data["FromDate"];
            this.created = _data["Created"];
            this.updated = _data["Updated"];
            this.instrumentId = _data["InstrumentId"];
            this.instrumentUuid = _data["InstrumentUuid"];
            this.instrument = _data["Instrument"] ? Instrument.fromJS(_data["Instrument"]) : undefined as any;
            this.createdByEmail = _data["CreatedByEmail"];
            this.updatedByEmail = _data["UpdatedByEmail"];
        }
    }

    static fromJS(data: any): InstrumentTaxValue {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentTaxValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["TaxValue"] = this.taxValue;
        data["FromDate"] = this.fromDate;
        data["Created"] = this.created;
        data["Updated"] = this.updated;
        data["InstrumentId"] = this.instrumentId;
        data["InstrumentUuid"] = this.instrumentUuid;
        data["Instrument"] = this.instrument ? this.instrument.toJSON() : undefined as any;
        data["CreatedByEmail"] = this.createdByEmail;
        data["UpdatedByEmail"] = this.updatedByEmail;
        return data;
    }
}

export interface IInstrumentTaxValue {
    id?: string;
    taxValue?: number;
    fromDate?: string;
    created?: string;
    updated?: string | undefined;
    instrumentId?: number | undefined;
    instrumentUuid?: string | undefined;
    instrument?: Instrument | undefined;
    createdByEmail?: string;
    updatedByEmail?: string | undefined;
}

export class InstrumentPrice implements IInstrumentPrice {
    id?: number;
    sellPrice?: number;
    instrumentCurrencyId?: number | undefined;
    instrumentCurrency?: InstrumentCurrency | undefined;
    sellPriceAdjusted?: number;
    fromDate?: string;
    toDate?: string | undefined;
    created?: string;
    createdById?: number | undefined;
    instrumentId?: number;
    instrument?: Instrument | undefined;
    insightId?: number;

    constructor(data?: IInstrumentPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.sellPrice = _data["SellPrice"];
            this.instrumentCurrencyId = _data["InstrumentCurrencyId"];
            this.instrumentCurrency = _data["InstrumentCurrency"] ? InstrumentCurrency.fromJS(_data["InstrumentCurrency"]) : undefined as any;
            this.sellPriceAdjusted = _data["SellPriceAdjusted"];
            this.fromDate = _data["FromDate"];
            this.toDate = _data["ToDate"];
            this.created = _data["Created"];
            this.createdById = _data["CreatedById"];
            this.instrumentId = _data["InstrumentId"];
            this.instrument = _data["Instrument"] ? Instrument.fromJS(_data["Instrument"]) : undefined as any;
            this.insightId = _data["InsightId"];
        }
    }

    static fromJS(data: any): InstrumentPrice {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentPrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["SellPrice"] = this.sellPrice;
        data["InstrumentCurrencyId"] = this.instrumentCurrencyId;
        data["InstrumentCurrency"] = this.instrumentCurrency ? this.instrumentCurrency.toJSON() : undefined as any;
        data["SellPriceAdjusted"] = this.sellPriceAdjusted;
        data["FromDate"] = this.fromDate;
        data["ToDate"] = this.toDate;
        data["Created"] = this.created;
        data["CreatedById"] = this.createdById;
        data["InstrumentId"] = this.instrumentId;
        data["Instrument"] = this.instrument ? this.instrument.toJSON() : undefined as any;
        data["InsightId"] = this.insightId;
        return data;
    }
}

export interface IInstrumentPrice {
    id?: number;
    sellPrice?: number;
    instrumentCurrencyId?: number | undefined;
    instrumentCurrency?: InstrumentCurrency | undefined;
    sellPriceAdjusted?: number;
    fromDate?: string;
    toDate?: string | undefined;
    created?: string;
    createdById?: number | undefined;
    instrumentId?: number;
    instrument?: Instrument | undefined;
    insightId?: number;
}

export class InstrumentTransactionGlTransactionInsightLine implements IInstrumentTransactionGlTransactionInsightLine {
    id?: number;
    glTransactionType?: GlTransactionType;
    instrumentTransactionId?: number;
    instrumentTransaction?: InstrumentTransaction;
    glTransactionInsightLineId?: number;
    glTransactionInsightLine?: GlTransactionInsightLine | undefined;

    constructor(data?: IInstrumentTransactionGlTransactionInsightLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.glTransactionType = _data["GlTransactionType"];
            this.instrumentTransactionId = _data["InstrumentTransactionId"];
            this.instrumentTransaction = _data["InstrumentTransaction"] ? InstrumentTransaction.fromJS(_data["InstrumentTransaction"]) : undefined as any;
            this.glTransactionInsightLineId = _data["GlTransactionInsightLineId"];
            this.glTransactionInsightLine = _data["GlTransactionInsightLine"] ? GlTransactionInsightLine.fromJS(_data["GlTransactionInsightLine"]) : undefined as any;
        }
    }

    static fromJS(data: any): InstrumentTransactionGlTransactionInsightLine {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentTransactionGlTransactionInsightLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["GlTransactionType"] = this.glTransactionType;
        data["InstrumentTransactionId"] = this.instrumentTransactionId;
        data["InstrumentTransaction"] = this.instrumentTransaction ? this.instrumentTransaction.toJSON() : undefined as any;
        data["GlTransactionInsightLineId"] = this.glTransactionInsightLineId;
        data["GlTransactionInsightLine"] = this.glTransactionInsightLine ? this.glTransactionInsightLine.toJSON() : undefined as any;
        return data;
    }
}

export interface IInstrumentTransactionGlTransactionInsightLine {
    id?: number;
    glTransactionType?: GlTransactionType;
    instrumentTransactionId?: number;
    instrumentTransaction?: InstrumentTransaction;
    glTransactionInsightLineId?: number;
    glTransactionInsightLine?: GlTransactionInsightLine | undefined;
}

export enum GlTransactionType {
    Standard = 1,
    Retract = 2,
}

export class GlTransactionInsightLine implements IGlTransactionInsightLine {
    id?: number;
    transactionsApiId?: number;
    accountNumber?: number;
    glAccountType?: AccountType;
    amount?: number;
    documentDate?: string;
    postingDate?: string;
    vatCode?: string | undefined;
    glTransactionInsightId?: number;
    glTransactionInsight?: GlTransactionInsight | undefined;
    instrumentTransactionGlTransactionInsightLines?: InstrumentTransactionGlTransactionInsightLine[] | undefined;

    constructor(data?: IGlTransactionInsightLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.transactionsApiId = _data["TransactionsApiId"];
            this.accountNumber = _data["AccountNumber"];
            this.glAccountType = _data["GlAccountType"];
            this.amount = _data["Amount"];
            this.documentDate = _data["DocumentDate"];
            this.postingDate = _data["PostingDate"];
            this.vatCode = _data["VatCode"];
            this.glTransactionInsightId = _data["GlTransactionInsightId"];
            this.glTransactionInsight = _data["GlTransactionInsight"] ? GlTransactionInsight.fromJS(_data["GlTransactionInsight"]) : undefined as any;
            if (Array.isArray(_data["InstrumentTransactionGlTransactionInsightLines"])) {
                this.instrumentTransactionGlTransactionInsightLines = [] as any;
                for (let item of _data["InstrumentTransactionGlTransactionInsightLines"])
                    this.instrumentTransactionGlTransactionInsightLines!.push(InstrumentTransactionGlTransactionInsightLine.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GlTransactionInsightLine {
        data = typeof data === 'object' ? data : {};
        let result = new GlTransactionInsightLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["TransactionsApiId"] = this.transactionsApiId;
        data["AccountNumber"] = this.accountNumber;
        data["GlAccountType"] = this.glAccountType;
        data["Amount"] = this.amount;
        data["DocumentDate"] = this.documentDate;
        data["PostingDate"] = this.postingDate;
        data["VatCode"] = this.vatCode;
        data["GlTransactionInsightId"] = this.glTransactionInsightId;
        data["GlTransactionInsight"] = this.glTransactionInsight ? this.glTransactionInsight.toJSON() : undefined as any;
        if (Array.isArray(this.instrumentTransactionGlTransactionInsightLines)) {
            data["InstrumentTransactionGlTransactionInsightLines"] = [];
            for (let item of this.instrumentTransactionGlTransactionInsightLines)
                data["InstrumentTransactionGlTransactionInsightLines"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGlTransactionInsightLine {
    id?: number;
    transactionsApiId?: number;
    accountNumber?: number;
    glAccountType?: AccountType;
    amount?: number;
    documentDate?: string;
    postingDate?: string;
    vatCode?: string | undefined;
    glTransactionInsightId?: number;
    glTransactionInsight?: GlTransactionInsight | undefined;
    instrumentTransactionGlTransactionInsightLines?: InstrumentTransactionGlTransactionInsightLine[] | undefined;
}

export class GlTransactionInsight implements IGlTransactionInsight {
    id?: number;
    transactionsApiId?: number;
    originalTransactionsApiId?: number | undefined;
    retractedTransactionsApiId?: number | undefined;
    description?: string | undefined;
    date?: string;
    externalVoucherNr?: string | undefined;
    externalVoucherId?: string | undefined;
    externalImportId?: string | undefined;
    savedGl?: string | undefined;
    postedGl?: string | undefined;
    created?: string;
    glTransactionStatus?: GlStatus;
    createdById?: number | undefined;
    createdBy?: User | undefined;
    glTransactionInsightLines?: GlTransactionInsightLine[] | undefined;

    constructor(data?: IGlTransactionInsight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.transactionsApiId = _data["TransactionsApiId"];
            this.originalTransactionsApiId = _data["OriginalTransactionsApiId"];
            this.retractedTransactionsApiId = _data["RetractedTransactionsApiId"];
            this.description = _data["Description"];
            this.date = _data["Date"];
            this.externalVoucherNr = _data["ExternalVoucherNr"];
            this.externalVoucherId = _data["ExternalVoucherId"];
            this.externalImportId = _data["ExternalImportId"];
            this.savedGl = _data["SavedGl"];
            this.postedGl = _data["PostedGl"];
            this.created = _data["Created"];
            this.glTransactionStatus = _data["GlTransactionStatus"];
            this.createdById = _data["CreatedById"];
            this.createdBy = _data["CreatedBy"] ? User.fromJS(_data["CreatedBy"]) : undefined as any;
            if (Array.isArray(_data["GlTransactionInsightLines"])) {
                this.glTransactionInsightLines = [] as any;
                for (let item of _data["GlTransactionInsightLines"])
                    this.glTransactionInsightLines!.push(GlTransactionInsightLine.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GlTransactionInsight {
        data = typeof data === 'object' ? data : {};
        let result = new GlTransactionInsight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["TransactionsApiId"] = this.transactionsApiId;
        data["OriginalTransactionsApiId"] = this.originalTransactionsApiId;
        data["RetractedTransactionsApiId"] = this.retractedTransactionsApiId;
        data["Description"] = this.description;
        data["Date"] = this.date;
        data["ExternalVoucherNr"] = this.externalVoucherNr;
        data["ExternalVoucherId"] = this.externalVoucherId;
        data["ExternalImportId"] = this.externalImportId;
        data["SavedGl"] = this.savedGl;
        data["PostedGl"] = this.postedGl;
        data["Created"] = this.created;
        data["GlTransactionStatus"] = this.glTransactionStatus;
        data["CreatedById"] = this.createdById;
        data["CreatedBy"] = this.createdBy ? this.createdBy.toJSON() : undefined as any;
        if (Array.isArray(this.glTransactionInsightLines)) {
            data["GlTransactionInsightLines"] = [];
            for (let item of this.glTransactionInsightLines)
                data["GlTransactionInsightLines"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGlTransactionInsight {
    id?: number;
    transactionsApiId?: number;
    originalTransactionsApiId?: number | undefined;
    retractedTransactionsApiId?: number | undefined;
    description?: string | undefined;
    date?: string;
    externalVoucherNr?: string | undefined;
    externalVoucherId?: string | undefined;
    externalImportId?: string | undefined;
    savedGl?: string | undefined;
    postedGl?: string | undefined;
    created?: string;
    glTransactionStatus?: GlStatus;
    createdById?: number | undefined;
    createdBy?: User | undefined;
    glTransactionInsightLines?: GlTransactionInsightLine[] | undefined;
}

export class User implements IUser {
    id?: number;
    changed?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    policyId?: number | undefined;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.changed = _data["Changed"];
            this.name = _data["Name"];
            this.email = _data["Email"];
            this.policyId = _data["PolicyId"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Changed"] = this.changed;
        data["Name"] = this.name;
        data["Email"] = this.email;
        data["PolicyId"] = this.policyId;
        return data;
    }
}

export interface IUser {
    id?: number;
    changed?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    policyId?: number | undefined;
}

export class InstrumentCostBreakdownViewModel implements IInstrumentCostBreakdownViewModel {
    instrumentId?: number | undefined;
    isin?: string | undefined;
    orgNr?: string | undefined;
    name?: string | undefined;
    currencyCode?: string | undefined;
    quantity?: number;
    amount?: number;
    totalCostPrice?: number;
    avgCostPrice?: number;
    totalCostPriceInCurrency?: number;
    totalCostPriceInPeriod?: number;
    totalCostPriceInCurrencyInPeriod?: number;
    avgTotalCostPrice?: number;
    avgTotalCostPriceInCurrency?: number;
    avgTotalCostPriceInPeriod?: number;
    avgTotalCostPriceInCurrencyInPerio?: number;
    voucherNr?: string | undefined;
    lastTransactionDate?: string | undefined;

    constructor(data?: IInstrumentCostBreakdownViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.instrumentId = _data["InstrumentId"];
            this.isin = _data["Isin"];
            this.orgNr = _data["OrgNr"];
            this.name = _data["Name"];
            this.currencyCode = _data["CurrencyCode"];
            this.quantity = _data["Quantity"];
            this.amount = _data["Amount"];
            this.totalCostPrice = _data["TotalCostPrice"];
            this.avgCostPrice = _data["AvgCostPrice"];
            this.totalCostPriceInCurrency = _data["TotalCostPriceInCurrency"];
            this.totalCostPriceInPeriod = _data["TotalCostPriceInPeriod"];
            this.totalCostPriceInCurrencyInPeriod = _data["TotalCostPriceInCurrencyInPeriod"];
            this.avgTotalCostPrice = _data["AvgTotalCostPrice"];
            this.avgTotalCostPriceInCurrency = _data["AvgTotalCostPriceInCurrency"];
            this.avgTotalCostPriceInPeriod = _data["AvgTotalCostPriceInPeriod"];
            this.avgTotalCostPriceInCurrencyInPerio = _data["AvgTotalCostPriceInCurrencyInPerio"];
            this.voucherNr = _data["VoucherNr"];
            this.lastTransactionDate = _data["LastTransactionDate"];
        }
    }

    static fromJS(data: any): InstrumentCostBreakdownViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentCostBreakdownViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InstrumentId"] = this.instrumentId;
        data["Isin"] = this.isin;
        data["OrgNr"] = this.orgNr;
        data["Name"] = this.name;
        data["CurrencyCode"] = this.currencyCode;
        data["Quantity"] = this.quantity;
        data["Amount"] = this.amount;
        data["TotalCostPrice"] = this.totalCostPrice;
        data["AvgCostPrice"] = this.avgCostPrice;
        data["TotalCostPriceInCurrency"] = this.totalCostPriceInCurrency;
        data["TotalCostPriceInPeriod"] = this.totalCostPriceInPeriod;
        data["TotalCostPriceInCurrencyInPeriod"] = this.totalCostPriceInCurrencyInPeriod;
        data["AvgTotalCostPrice"] = this.avgTotalCostPrice;
        data["AvgTotalCostPriceInCurrency"] = this.avgTotalCostPriceInCurrency;
        data["AvgTotalCostPriceInPeriod"] = this.avgTotalCostPriceInPeriod;
        data["AvgTotalCostPriceInCurrencyInPerio"] = this.avgTotalCostPriceInCurrencyInPerio;
        data["VoucherNr"] = this.voucherNr;
        data["LastTransactionDate"] = this.lastTransactionDate;
        return data;
    }
}

export interface IInstrumentCostBreakdownViewModel {
    instrumentId?: number | undefined;
    isin?: string | undefined;
    orgNr?: string | undefined;
    name?: string | undefined;
    currencyCode?: string | undefined;
    quantity?: number;
    amount?: number;
    totalCostPrice?: number;
    avgCostPrice?: number;
    totalCostPriceInCurrency?: number;
    totalCostPriceInPeriod?: number;
    totalCostPriceInCurrencyInPeriod?: number;
    avgTotalCostPrice?: number;
    avgTotalCostPriceInCurrency?: number;
    avgTotalCostPriceInPeriod?: number;
    avgTotalCostPriceInCurrencyInPerio?: number;
    voucherNr?: string | undefined;
    lastTransactionDate?: string | undefined;
}

export class InstrumentValuesGridResponse implements IInstrumentValuesGridResponse {
    values?: InstrumentValuesReportViewModel[];
    total?: number;

    constructor(data?: IInstrumentValuesGridResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Values"])) {
                this.values = [] as any;
                for (let item of _data["Values"])
                    this.values!.push(InstrumentValuesReportViewModel.fromJS(item));
            }
            this.total = _data["Total"];
        }
    }

    static fromJS(data: any): InstrumentValuesGridResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentValuesGridResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.values)) {
            data["Values"] = [];
            for (let item of this.values)
                data["Values"].push(item ? item.toJSON() : undefined as any);
        }
        data["Total"] = this.total;
        return data;
    }
}

export interface IInstrumentValuesGridResponse {
    values?: InstrumentValuesReportViewModel[];
    total?: number;
}

export class NavDetailsViewModel implements INavDetailsViewModel {
    date?: string;
    endOfLastYearDate?: string;
    buckets?: NavBucketViewModel[];
    valueAdjustedNetAssetValue?: number;
    valueAdjustedNetAssetValueEndOfLastYear?: number;

    constructor(data?: INavDetailsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["Date"];
            this.endOfLastYearDate = _data["EndOfLastYearDate"];
            if (Array.isArray(_data["Buckets"])) {
                this.buckets = [] as any;
                for (let item of _data["Buckets"])
                    this.buckets!.push(NavBucketViewModel.fromJS(item));
            }
            this.valueAdjustedNetAssetValue = _data["ValueAdjustedNetAssetValue"];
            this.valueAdjustedNetAssetValueEndOfLastYear = _data["ValueAdjustedNetAssetValueEndOfLastYear"];
        }
    }

    static fromJS(data: any): NavDetailsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new NavDetailsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Date"] = this.date;
        data["EndOfLastYearDate"] = this.endOfLastYearDate;
        if (Array.isArray(this.buckets)) {
            data["Buckets"] = [];
            for (let item of this.buckets)
                data["Buckets"].push(item ? item.toJSON() : undefined as any);
        }
        data["ValueAdjustedNetAssetValue"] = this.valueAdjustedNetAssetValue;
        data["ValueAdjustedNetAssetValueEndOfLastYear"] = this.valueAdjustedNetAssetValueEndOfLastYear;
        return data;
    }
}

export interface INavDetailsViewModel {
    date?: string;
    endOfLastYearDate?: string;
    buckets?: NavBucketViewModel[];
    valueAdjustedNetAssetValue?: number;
    valueAdjustedNetAssetValueEndOfLastYear?: number;
}

export class NavBucketViewModel implements INavBucketViewModel {
    bucketKey?: string;
    bucket?: string;
    sortOrder?: number;
    total?: number;
    totalEndOfLastYear?: number;
    accounts?: NavAccountBalanceViewModel[];

    constructor(data?: INavBucketViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bucketKey = _data["BucketKey"];
            this.bucket = _data["Bucket"];
            this.sortOrder = _data["SortOrder"];
            this.total = _data["Total"];
            this.totalEndOfLastYear = _data["TotalEndOfLastYear"];
            if (Array.isArray(_data["Accounts"])) {
                this.accounts = [] as any;
                for (let item of _data["Accounts"])
                    this.accounts!.push(NavAccountBalanceViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NavBucketViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new NavBucketViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["BucketKey"] = this.bucketKey;
        data["Bucket"] = this.bucket;
        data["SortOrder"] = this.sortOrder;
        data["Total"] = this.total;
        data["TotalEndOfLastYear"] = this.totalEndOfLastYear;
        if (Array.isArray(this.accounts)) {
            data["Accounts"] = [];
            for (let item of this.accounts)
                data["Accounts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface INavBucketViewModel {
    bucketKey?: string;
    bucket?: string;
    sortOrder?: number;
    total?: number;
    totalEndOfLastYear?: number;
    accounts?: NavAccountBalanceViewModel[];
}

export class NavAccountBalanceViewModel implements INavAccountBalanceViewModel {
    accountCode?: number;
    accountName?: string;
    groupName?: string;
    balance?: number;
    balanceEndOfLastYear?: number;
    isUnbookedValueAdjustment?: boolean;

    constructor(data?: INavAccountBalanceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountCode = _data["AccountCode"];
            this.accountName = _data["AccountName"];
            this.groupName = _data["GroupName"];
            this.balance = _data["Balance"];
            this.balanceEndOfLastYear = _data["BalanceEndOfLastYear"];
            this.isUnbookedValueAdjustment = _data["IsUnbookedValueAdjustment"];
        }
    }

    static fromJS(data: any): NavAccountBalanceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new NavAccountBalanceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AccountCode"] = this.accountCode;
        data["AccountName"] = this.accountName;
        data["GroupName"] = this.groupName;
        data["Balance"] = this.balance;
        data["BalanceEndOfLastYear"] = this.balanceEndOfLastYear;
        data["IsUnbookedValueAdjustment"] = this.isUnbookedValueAdjustment;
        return data;
    }
}

export interface INavAccountBalanceViewModel {
    accountCode?: number;
    accountName?: string;
    groupName?: string;
    balance?: number;
    balanceEndOfLastYear?: number;
    isUnbookedValueAdjustment?: boolean;
}

export class BankTotal implements IBankTotal {
    periodName?: string;
    date?: string;
    amount?: number;
    amountFrom?: number;

    constructor(data?: IBankTotal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.periodName = _data["PeriodName"];
            this.date = _data["Date"];
            this.amount = _data["Amount"];
            this.amountFrom = _data["AmountFrom"];
        }
    }

    static fromJS(data: any): BankTotal {
        data = typeof data === 'object' ? data : {};
        let result = new BankTotal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PeriodName"] = this.periodName;
        data["Date"] = this.date;
        data["Amount"] = this.amount;
        data["AmountFrom"] = this.amountFrom;
        return data;
    }
}

export interface IBankTotal {
    periodName?: string;
    date?: string;
    amount?: number;
    amountFrom?: number;
}

export class BalanceTotalsQueryModel implements IBalanceTotalsQueryModel {
    customerName?: string | undefined;
    periodName?: string;
    date?: string;
    estimatedValue?: number;
    costPrice?: number;
    costOfAcquired?: number;
    dividend?: number;
    interest?: number;
    unrealizedProfitLoss?: number;
    realizedProfitLoss?: number;
    indexSellprice?: number;
    netAssetValue?: number;
    glMarketAdjustment?: number;
    glIntangibleAssets?: number;
    glTangibleAssets?: number;
    glReceivables?: number;
    glReceivablesGroupCompanies?: number;
    glInvestmentsBaseInvested?: number;
    glDeposits?: number;
    glPaidEquity?: number;
    glRetainedEarnings?: number;
    glLiabilities?: number;
    glLiabilitiesGroupCompanies?: number;
    glNotChangeInValue?: number;
    glRevenues?: number;
    glCostOfGoodsSold?: number;
    glPersonellExpenses?: number;
    glOtherOperatingExpenses?: number;
    glNetInterest?: number;
    glNetCurrency?: number;
    glNetSoldSecurities?: number;
    glDividend?: number;
    glOtherFinancialItems?: number;
    glFinancialIncomeAndExpenses?: number;
    glEverything?: number;

    constructor(data?: IBalanceTotalsQueryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerName = _data["CustomerName"];
            this.periodName = _data["PeriodName"];
            this.date = _data["Date"];
            this.estimatedValue = _data["EstimatedValue"];
            this.costPrice = _data["CostPrice"];
            this.costOfAcquired = _data["CostOfAcquired"];
            this.dividend = _data["Dividend"];
            this.interest = _data["Interest"];
            this.unrealizedProfitLoss = _data["UnrealizedProfitLoss"];
            this.realizedProfitLoss = _data["RealizedProfitLoss"];
            this.indexSellprice = _data["IndexSellprice"];
            this.netAssetValue = _data["NetAssetValue"];
            this.glMarketAdjustment = _data["GlMarketAdjustment"];
            this.glIntangibleAssets = _data["GlIntangibleAssets"];
            this.glTangibleAssets = _data["GlTangibleAssets"];
            this.glReceivables = _data["GlReceivables"];
            this.glReceivablesGroupCompanies = _data["GlReceivablesGroupCompanies"];
            this.glInvestmentsBaseInvested = _data["GlInvestmentsBaseInvested"];
            this.glDeposits = _data["GlDeposits"];
            this.glPaidEquity = _data["GlPaidEquity"];
            this.glRetainedEarnings = _data["GlRetainedEarnings"];
            this.glLiabilities = _data["GlLiabilities"];
            this.glLiabilitiesGroupCompanies = _data["GlLiabilitiesGroupCompanies"];
            this.glNotChangeInValue = _data["GlNotChangeInValue"];
            this.glRevenues = _data["GlRevenues"];
            this.glCostOfGoodsSold = _data["GlCostOfGoodsSold"];
            this.glPersonellExpenses = _data["GlPersonellExpenses"];
            this.glOtherOperatingExpenses = _data["GlOtherOperatingExpenses"];
            this.glNetInterest = _data["GlNetInterest"];
            this.glNetCurrency = _data["GlNetCurrency"];
            this.glNetSoldSecurities = _data["GlNetSoldSecurities"];
            this.glDividend = _data["GlDividend"];
            this.glOtherFinancialItems = _data["GlOtherFinancialItems"];
            this.glFinancialIncomeAndExpenses = _data["GlFinancialIncomeAndExpenses"];
            this.glEverything = _data["GlEverything"];
        }
    }

    static fromJS(data: any): BalanceTotalsQueryModel {
        data = typeof data === 'object' ? data : {};
        let result = new BalanceTotalsQueryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomerName"] = this.customerName;
        data["PeriodName"] = this.periodName;
        data["Date"] = this.date;
        data["EstimatedValue"] = this.estimatedValue;
        data["CostPrice"] = this.costPrice;
        data["CostOfAcquired"] = this.costOfAcquired;
        data["Dividend"] = this.dividend;
        data["Interest"] = this.interest;
        data["UnrealizedProfitLoss"] = this.unrealizedProfitLoss;
        data["RealizedProfitLoss"] = this.realizedProfitLoss;
        data["IndexSellprice"] = this.indexSellprice;
        data["NetAssetValue"] = this.netAssetValue;
        data["GlMarketAdjustment"] = this.glMarketAdjustment;
        data["GlIntangibleAssets"] = this.glIntangibleAssets;
        data["GlTangibleAssets"] = this.glTangibleAssets;
        data["GlReceivables"] = this.glReceivables;
        data["GlReceivablesGroupCompanies"] = this.glReceivablesGroupCompanies;
        data["GlInvestmentsBaseInvested"] = this.glInvestmentsBaseInvested;
        data["GlDeposits"] = this.glDeposits;
        data["GlPaidEquity"] = this.glPaidEquity;
        data["GlRetainedEarnings"] = this.glRetainedEarnings;
        data["GlLiabilities"] = this.glLiabilities;
        data["GlLiabilitiesGroupCompanies"] = this.glLiabilitiesGroupCompanies;
        data["GlNotChangeInValue"] = this.glNotChangeInValue;
        data["GlRevenues"] = this.glRevenues;
        data["GlCostOfGoodsSold"] = this.glCostOfGoodsSold;
        data["GlPersonellExpenses"] = this.glPersonellExpenses;
        data["GlOtherOperatingExpenses"] = this.glOtherOperatingExpenses;
        data["GlNetInterest"] = this.glNetInterest;
        data["GlNetCurrency"] = this.glNetCurrency;
        data["GlNetSoldSecurities"] = this.glNetSoldSecurities;
        data["GlDividend"] = this.glDividend;
        data["GlOtherFinancialItems"] = this.glOtherFinancialItems;
        data["GlFinancialIncomeAndExpenses"] = this.glFinancialIncomeAndExpenses;
        data["GlEverything"] = this.glEverything;
        return data;
    }
}

export interface IBalanceTotalsQueryModel {
    customerName?: string | undefined;
    periodName?: string;
    date?: string;
    estimatedValue?: number;
    costPrice?: number;
    costOfAcquired?: number;
    dividend?: number;
    interest?: number;
    unrealizedProfitLoss?: number;
    realizedProfitLoss?: number;
    indexSellprice?: number;
    netAssetValue?: number;
    glMarketAdjustment?: number;
    glIntangibleAssets?: number;
    glTangibleAssets?: number;
    glReceivables?: number;
    glReceivablesGroupCompanies?: number;
    glInvestmentsBaseInvested?: number;
    glDeposits?: number;
    glPaidEquity?: number;
    glRetainedEarnings?: number;
    glLiabilities?: number;
    glLiabilitiesGroupCompanies?: number;
    glNotChangeInValue?: number;
    glRevenues?: number;
    glCostOfGoodsSold?: number;
    glPersonellExpenses?: number;
    glOtherOperatingExpenses?: number;
    glNetInterest?: number;
    glNetCurrency?: number;
    glNetSoldSecurities?: number;
    glDividend?: number;
    glOtherFinancialItems?: number;
    glFinancialIncomeAndExpenses?: number;
    glEverything?: number;
}

export class ClickHouseReportDateRange implements IClickHouseReportDateRange {
    name?: string;
    from?: string;
    to?: string;
    interval?: ClickHouseReportDateRangeInterval;

    constructor(data?: IClickHouseReportDateRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.from = _data["From"];
            this.to = _data["To"];
            this.interval = _data["Interval"];
        }
    }

    static fromJS(data: any): ClickHouseReportDateRange {
        data = typeof data === 'object' ? data : {};
        let result = new ClickHouseReportDateRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["From"] = this.from;
        data["To"] = this.to;
        data["Interval"] = this.interval;
        return data;
    }
}

export interface IClickHouseReportDateRange {
    name?: string;
    from?: string;
    to?: string;
    interval?: ClickHouseReportDateRangeInterval;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function getTraceParent(span: Span) {
  return `00-${span.spanContext().traceId}-${span.spanContext().spanId}-0${Number(span.spanContext().traceFlags || TraceFlags.NONE).toString(16)}`;
}